/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable @typescript-eslint/indent */

import { isNull, isUndefined } from 'lodash';

const partnerGlobalConfigLocal = JSON.parse(
  window.localStorage.getItem('partner_settings')
);
let primaryColor =
  process.env.REACT_APP_PLATFORM_DEFAULT_PRIMARY_COLOR || '#006699';

if (
  !isNull(partnerGlobalConfigLocal) &&
  !isUndefined(partnerGlobalConfigLocal)
) {
  primaryColor = partnerGlobalConfigLocal?.color_schema?.primary;
}

export const fr = {
         login_sign_in: 'Se connecter',
         login_email_address: 'Adresse e-mail',
         login_form_password_label: 'Mot de passe',
         login_forget_password: 'Mot de passe oublié',
         login_credentials_error:
           'Veuillez vérifier votre e-mail et votre mot de passe',
         login_api_error: 'Alarme API de connexion interne',
         internal_server_error: 'Alarme Serveur Interne',
         /* Forget Password */
         forget_password_title: 'Mot de passe oublié',
         forget_password_email_address: 'Adresse e-mail',
         forget_password_button:
           'Envoyer le lien de réinitialisation du mot de passe',
         forget_password_login: 'Retour',
         forgot_password_form_success:
           "L'e-mail de réinitialisation du mot de passe a été envoyé. Veuillez vérifier votre boîte de réception. L'e-mail pourrait se trouver dans vos spams.",
         forgot_password_subject:
           'Fortes Data Management - Mot de passe oublié',
         temporary_password_subject: 'Nouveau compte créé',
         forgot_password_required_form_error:
           "L'adresse e-mail est obligatoire",
         forgot_password_valid_form_error:
           'Doit être une adresse e-mail valide',
         /* END Forget Password */
         /** Reset Password */
         reset_password_title: 'Réinitialiser le mot de passe',
         reset_password_new_password: 'Nouveau mot de passe',
         reset_password_confirm_password: 'Confirmer le mot de passe',
         reset_password_new_password_required_form_error:
           'Le nouveau mot de passe est requis',
         reset_password_confirm_password_required_form_error:
           'La confirmation du mot de passe est requise',
         reset_password_passwords_not_matching:
           'Les mots de passe ne correspondent pas',
         reset_password_new_password_form_error:
           'Le mot de passe doit contenir au moins 8 caractères, dont au moins une lettre majuscule, au moins un chiffre et au moins un caractère spécial.',
         reset_password_button: 'Réinitialiser le mot de passe',
         reset_password_form_success:
           'Votre mot de passe a été mis à jour avec succès.',
         /** End Reset Password */
         /* DASHBOARD */
         dashboard_title: 'Tableau de bord',
         dashboard_amount_of_devices: "NOMBRE D'APPAREILS",
         dashboard_amount_of_devices_week:
           "NOMBRE D'APPAREILS LA SEMAINE DERNIÈRE",
         dashboard_amount_of_devices_error:
           "NOMBRE D'APPAREILS AVEC DES ERREURS",
         dashboard_temperature: 'TEMPÉRATURE DE RETOUR EN DEGRÉS CELSIUS',
         dashboard_device_status: 'Connexions totales : ',
         dashboard_routing_temperature: 'Températures de tous les appareils',
         dashboard_routing_temperature_hr: 'Heure',
         dashboard_error_devices: 'Appareils dont le contrôle est défectueux :',
         dashboard_error: 'ERREUR',
         dashboard_online: 'EN LIGNE',
         dashboard_offline: 'HORS LIGNE',
         'dashboard organic': 'Biologique',
         'dashboard referal': 'Référence',
         dashboard_see_all: 'TOUT VOIR',
         /* END DASHBOARD */
         /* Sidebar */
         date_range: 'Plage de dates',
         sidebar_dashboard: 'Tableau de bord',
         sidebar_clients_overview: 'Gestion des clients',
         sidebar_clients: 'Clients',
         sidebar_service_clients: 'Service clients',
         sidebar_devices_overview: 'Gestion des appareils',
         sidebar_devices: 'Aperçu des appareils',
         sidebar_projects: 'Projets',
         sidebar_presets: 'Préréglages',
         sidebar_fortes_users: 'Administrateurs',
         sidebar_fortes_settings: 'Paramètres',
         sidebar_audit: 'Audit',
         sidebar_reports: 'Rapports',
         sidebar_total_devices: 'Appareils - Total',
         sidebar_online_devices: 'Appareils - En ligne',
         sidebar_offline_devices: 'Appareils - Hors ligne',
         sidebar_error_devices: 'Appareils - Alarme',
         sidebar_change_logs: 'Journaux de modifications',
         sidebar_version_title: 'Version',
         image_upload_success: "L'image a été mise à jour avec succès !",
         image_upload_file_type_error:
           'Seuls les fichiers JPEG et PNG sont autorisés.',
         image_upload_file_size_error:
           'La taille du fichier doit être inférieure à 5 Mo.',
         image_uploading_text: 'Chargement en cours...',
         /* END Sidebar */
         /* Navbar */
         navbar_search: 'Rechercher',
         navbar_notification: 'Notification',
         navbar_no_notification: "Il n'y a pas de notifications",
         navbar_profile: 'Profil',
         navbar_setting: 'Paramètres du compte',
         navbar_logout: 'Se déconnecter',
         /* END Navbar */
         active_label: 'ACTIF',
         deactive_label: 'INACTIF',
         please_fix_form_errors: 'Veuillez corriger les erreurs du formulaire',
         /* Clients */
         clients: 'Clients',
         clients_all: 'TOUS',
         clients_active: 'ACTIF',
         clients_inactive: 'INACTIF',
         clients_add_new: 'Ajouter un nouveau client',
         clients_filter_search: 'Rechercher un client',
         clients_sort_by_filter_label: 'Trier par',
         clients_sort_by_value_1: 'Date (plus récent)',
         clients_sort_by_value_2: 'Date (plus ancien)',
         clients_sort_by_value_3: 'Alphabétique',
         clients_country_filter_label: 'Pays',
         clients_filter_reset_button: 'Réinitialiser',
         clients_filter_delete_button: 'Désactiver',
         clients_table_name: 'Nom',
         clients_table_country: 'Pays',
         clients_table_devices: 'Appareils',
         clients_table_added: 'Date de création',
         clients_table_status: 'Statut',
         clients_table_row_per_page: 'Lignes par page',
         clients_bread_crumb_main_title: 'Clients',
         add_clients_bread_crumb_first_link: 'Ajouter un client',
         add_clients_form_header: 'Ajouter un client',
         edit_clients_bread_crumb_first_link: 'Modifier le client',
         edit_clients_form_header: 'Modifier le client',
         clients_form_client_name_field: 'Nom',
         clients_form_email_field: 'Adresse e-mail',
         clients_form_user_field: 'Client Contact',
         clients_form_city_field: 'Ville',
         clients_form_country_field: 'Pays',
         clients_form_client_kong_role_field: 'Rôle Kong',
         clients_form_client_kong_role_member_label: 'Membre',
         clients_form_client_kong_role_admin_label: 'Admin',
         clients_form_allow_customization_field: 'Autoriser le marquage blanc',
         clients_form_add_client_button: 'Ajouter le client',
         clients_form_edit_client_button: 'Enregistrer les modifications',
         clients_form_cancel_button: 'Annuler',
         clients_form_submitting_client_button: 'Envoi en cours...',
         clients_name_required_form_error: 'Le nom est requis',
         clients_email_required_form_error: "L'adresse e-mail est requise",
         clients_api_kong_role_required_form_error: 'Le rôle Kong est requis',
         clients_email_valid_form_error: 'Doit être une adresse e-mail valide',
         clients_city_required_form_error: 'La ville est requise',
         clients_country_required_form_error: 'Le pays est requis',
         clients_add_form_success: 'Client créé avec succès !',
         clients_edit_form_success: 'Le client a été mis à jour avec succès !',
         clients_form_api_error: 'Alarme serveur interne du client - API',
         clients_form_email_error: "L'adresse e-mail existe déjà",
         clients_no_record_found: 'Aucun client trouvé',
         client_deactivated_message: 'Le client a été désactivé avec succès',
         client_activated_message: 'Le client a été activé avec succès',
         clients_bulk_no_user_is_selected_error_message:
           'Veuillez sélectionner plusieurs enregistrements à désactiver',
         clients_bulk_deactivated_message:
           '{{ USERS_COUNT }} clients ont été désactivés avec succès',
         client_single_stats_table_title: 'Statut',
         /* END Clients */
         client_single_first_bread_crumb: 'Clients',
         client_single_second_bread_crumb: 'Voir le client',
         client_single_country_label: 'Pays',
         client_single_devices_label: 'Appareils',
         client_single_edit_button: 'Modifier',
         client_single_users_tab: 'Utilisateurs',
         client_single_apis_tab: 'Clés API',
         client_single_customization_tab: 'Marque blanche',
         client_single_customization_tab_logo: 'Logo',
         client_single_customization_tab_primary_color: 'Couleur principale',
         client_single_customization_tab_secondary_color: 'Couleur secondaire',
         client_single_customization_tab_submit_button:
           'Enregistrer les modifications',
         client_single_customization_color_schema_success:
           'Marque blanche mise à jour avec succès.',
         client_single_filter_search: 'Rechercher',
         client_single_add_new_user_button: 'Ajouter un utilisateur',
         client_single_add_new_api_key_button: 'Ajouter une clé API',
         client_single_role_id_filter: 'Rôle',
         client_single_users_search: 'Rechercher',
         client_single_filter_reset_button: 'Réinitialiser',
         client_single_users_all: 'TOUS',
         client_single_users_active: 'ACTIF',
         client_single_users_inactive: 'INACTIF',
         client_single_filter_delete_button: 'Désactiver',
         client_single_users_table_name: 'Nom',
         client_single_users_table_address: 'Adresse',
         client_single_users_table_role_id: 'Rôle',
         client_single_users_table_status: 'Statut',
         client_single_users_table_added: 'Date de création',
         client_single_users_table_no_record_found:
           'Aucun enregistrement trouvé',
         client_single_table_row_per_page: 'Lignes par page',
         client_single_stats_online_devices_label: 'Appareils en ligne',
         client_single_stats_error_devices_label: 'Appareils en alarme',
         client_single_no_user_selected_for_de_activation_message:
           'Veuillez sélectionner un enregistrement à désactiver',
         /* END Clients Single */
         /* Service Clients */
         service_clients: 'Service Clients',
         service_clients_all: 'TOUS',
         service_clients_active: 'ACTIF',
         service_clients_inactive: 'INACTIF',
         service_clients_add_new: 'Ajouter un nouveau',
         service_clients_filter_search: 'Rechercher',
         service_clients_sort_by_filter_label: 'Trier par',
         service_clients_sort_by_value_1: 'Date (plus récent)',
         service_clients_sort_by_value_2: 'Date (plus ancien)',
         service_clients_sort_by_value_3: 'Alphabétique',
         service_clients_country_filter_label: 'Pays',
         service_clients_filter_reset_button: 'Réinitialiser',
         service_clients_filter_delete_button: 'Désactiver',
         service_clients_table_name: 'Nom',
         service_clients_table_country: 'Pays',
         service_clients_table_devices: 'Appareils',
         service_clients_table_added: 'Date de création',
         service_clients_table_status: 'Statut',
         service_clients_table_row_per_page: 'Lignes par page',
         service_clients_bread_crumb_main_title: 'Service Clients',
         add_service_clients_bread_crumb_first_link:
           'Ajouter un service client',
         add_service_clients_form_header: 'Ajouter un service client',
         edit_service_clients_bread_crumb_first_link:
           'Modifier le service client',
         edit_service_clients_form_header: 'Modifier le service client',
         service_clients_form_service_client_name_field: 'Nom',
         service_clients_form_email_field: 'Adresse e-mail',
         service_clients_form_client_field: 'Client',
         service_clients_form_user_field: 'Client Contact',
         service_clients_form_city_field: 'Ville',
         service_clients_form_country_field: 'Pays',
         service_clients_form_add_service_client_button:
           'Enregistrer les modifications',
         service_clients_form_edit_service_client_button:
           'Enregistrer les modifications',
         service_clients_form_cancel_button: 'Annuler',
         service_clients_form_submitting_service_client_button:
           'Envoi en cours...',
         service_clients_name_required_form_error: 'Le nom est requis',
         service_clients_email_required_form_error:
           "L'adresse e-mail est requise",
         service_clients_focal_user_id_required_form_error:
           "L'utilisateur focal est requis",
         service_clients_email_valid_form_error:
           'Doit être une adresse e-mail valide',
         service_clients_city_required_form_error: 'La ville est requise',
         service_clients_client_required_form_error: 'Le client est requis',
         service_clients_country_required_form_error: 'Le pays est requis',
         service_clients_add_form_success: 'Service client créé avec succès !',
         service_clients_edit_form_success:
           'Le service client a été mis à jour avec succès !',
         service_clients_form_api_error:
           'Alarme serveur interne du service client - API',
         service_clients_form_email_error: "L'adresse e-mail existe déjà",
         service_clients_no_record_found: 'Aucun service client trouvé',
         service_client_deactivated_message:
           'Le service client a été désactivé avec succès',
         service_client_activated_message:
           'Le service client a été activé avec succès',
         service_clients_bulk_no_user_is_selected_error_message:
           'Veuillez sélectionner des enregistrements à désactiver',
         service_clients_bulk_deactivated_message:
           '{{ USERS_COUNT }} service(s) client(s) ont été désactivés avec succès',
         service_client_single_stats_table_title: 'Statut',
         /* END Service Clients */
         service_client_single_first_bread_crumb: 'Service Clients',
         service_client_single_second_bread_crumb: 'Voir le service client',
         service_client_single_country_label: 'Pays',
         service_client_single_devices_label: 'Appareils',
         service_client_single_edit_button: 'Modifier',
         service_client_single_users_tab: 'Utilisateurs',
         service_client_single_apis_tab: 'Clés API',
         service_client_single_filter_search: 'Rechercher',
         service_client_single_add_new_user_button: 'Ajouter un utilisateur',
         service_client_single_add_new_api_key_button: 'Ajouter une clé API',
         service_client_single_role_id_filter: 'Rôle',
         service_client_single_users_search: 'Rechercher',
         service_client_single_filter_reset_button: 'Réinitialiser',
         service_client_single_users_all: 'TOUS',
         service_client_single_users_active: 'ACTIF',
         service_client_single_users_inactive: 'INACTIF',
         service_client_single_filter_delete_button: 'Désactiver',
         service_client_single_users_table_name: 'Nom',
         service_client_single_users_table_address: 'Adresse',
         service_client_single_users_table_role_id: 'Rôle',
         service_client_single_users_table_status: 'Statut',
         service_client_single_users_table_added: 'Date de création',
         service_client_single_users_table_no_record_found:
           'Aucun enregistrement trouvé',
         service_client_single_table_row_per_page: 'Lignes par page',
         service_client_single_stats_active_devices_label: 'Appareils en ligne',
         service_client_single_stats_error_devices_label: 'Appareils en alarme',
         service_client_single_no_user_selected_for_de_activation_message:
           'Veuillez sélectionner des enregistrements à désactiver',
         /* END Service Clients Single */
         /* Users */
         users_bread_crumb_main_title: 'Client',
         add_users_bread_crumb_first_link: 'Ajouter un utilisateur',
         add_users_form_header: 'Ajouter un utilisateur',
         edit_users_bread_crumb_first_link: "Modifier l'utilisateur",
         edit_users_form_header: "Modifier l'utilisateur",
         users_form_first_name_field: 'Prénom',
         users_form_last_name_field: 'Nom de famille',
         users_form_email_field: 'Adresse e-mail',
         users_form_official_email_field: 'Adresse e-mail officielle',
         users_form_phone_field: 'Numéro de téléphone',
         users_form_official_phone_number_field: 'Numéro de téléphone officiel',
         users_form_password_field: 'Mot de passe',
         users_form_role_id_field: 'Rôle',
         users_form_select_role_id_field: 'Sélectionner un rôle',
         users_form_street_number_field: 'Rue',
         users_form_house_number_field: 'Numéro de maison',
         users_form_neighbourhood_field: 'Quartier',
         users_form_postal_code_field: 'Code postal',
         users_form_city_field: 'Ville',
         users_form_country_field: 'Pays',
         users_form_email_verification_field:
           "Vérification de l'adresse e-mail",
         users_form_email_verification_sub_title_field:
           "La désactivation de ce bouton enverra automatiquement à l'utilisateur un e-mail de vérification",
         users_form_add_user_button: 'Enregistrer les modifications',
         users_form_edit_user_button: 'Enregistrer les modifications',
         users_form_cancel_button: 'Annuler',
         users_form_submitting_user_button: 'Envoi en cours...',
         users_first_name_required_form_error: 'Le prénom est requis',
         users_last_name_required_form_error: 'Le nom de famille est requis',
         users_email_required_form_error: "L'adresse e-mail est requise",
         users_email_valid_form_error: 'Doit être une adresse e-mail valide',
         users_password_required_form_error: 'Le mot de passe est requis',
         users_country_required_form_error: 'Le pays est requis',
         users_role_id_required_form_error: 'Le rôle est requis',
         users_password_form_error:
           'Le mot de passe doit contenir au moins 8 caractères, dont au moins une lettre majuscule, au moins un chiffre et au moins un caractère spécial.',
         users_add_form_success: 'Utilisateur créé avec succès !',
         users_edit_form_success:
           "L'utilisateur a été mis à jour avec succès !",
         users_form_api_error: 'Alarme serveur interne des utilisateurs - API',
         users_form_email_error: "L'adresse e-mail existe déjà",
         users_no_record_found: 'Aucun utilisateur trouvé',
         user_deactivated_message: "L'utilisateur a été désactivé avec succès",
         user_activated_message: "L'utilisateur a été activé avec succès",
         user_email_verified_title: 'Adresse e-mail vérifiée',
         user_email_verified_sub_title:
           "La désactivation de ce bouton enverra automatiquement à l'utilisateur un e-mail de vérification",
         users_bulk_no_user_is_selected_error_message:
           'Veuillez sélectionner des enregistrements à désactiver',
         users_bulk_deactivated_message:
           '{{ USERS_COUNT }} utilisateurs ont été désactivés avec succès',
         /** Projects */
         projects: 'Projets',
         projects_all: 'TOUS',
         projects_active: 'ACTIF',
         projects_inactive: 'INACTIF',
         projects_unassigned: 'NON ATTRIBUÉ',
         projects_add_new: 'Ajouter un nouveau',
         projects_filter_search: 'Rechercher un projet',
         projects_sort_by_filter_label: 'Trier par',
         projects_sort_by_value_1: 'Date (plus récent)',
         projects_sort_by_value_2: 'Date (plus ancien)',
         projects_sort_by_value_3: 'Alphabétique',
         projects_country_filter_label: 'Pays',
         projects_filter_reset_button: 'Réinitialiser',
         projects_filter_delete_button: 'Supprimer',
         projects_table_name: 'Nom',
         projects_table_batch_number: 'Numéro de lot',
         projects_table_client: 'Clients',
         projects_table_devices: 'Appareils',
         projects_table_added: 'Date de création',
         projects_table_status: 'Statut',
         projects_table_row_per_page: 'Lignes par page',
         projects_bread_crumb_main_title: 'Projets',
         add_projects_bread_crumb_first_link: 'Ajouter un projet',
         add_projects_form_header: 'Ajouter un projet',
         edit_projects_bread_crumb_first_link: 'Modifier le projet',
         edit_projects_form_header: 'Modifier le projet',
         projects_form_project_name_field: 'Nom du projet',
         projects_form_email_field: 'Adresse e-mail',
         projects_form_client_field: 'Client',
         projects_form_service_client_field: 'Service client',
         projects_form_user_field: 'Utilisateur',
         projects_form_description_field: 'Description (facultatif)',
         projects_form_add_project_button: 'Enregistrer les modifications',
         projects_form_edit_project_button: 'Enregistrer les modifications',
         projects_form_cancel_button: 'Annuler',
         projects_form_submitting_service_client_button: 'Envoi en cours...',
         projects_name_required_form_error: 'Le nom est requis',
         projects_form_unqiue_project_order_number_error:
           'Le numéro de commande du projet doit être unique',
         projects_batch_number_required_form_error:
           'Le numéro de lot est requis',
         projects_client_required_form_error: 'Le client est requis',
         projects_description_required_form_error: 'La description est requise',
         projects_add_form_success: 'Projet créé avec succès !',
         projects_edit_form_success: 'Le projet a été mis à jour avec succès !',
         projects_form_api_error: 'Alarme serveur interne des projets - API',
         projects_no_record_found: 'Aucun projet trouvé',
         projects_deactivated_message: 'Le projet a été désactivé avec succès',
         projects_activated_message: 'Le projet a été activé avec succès',
         projects_bulk_no_user_is_selected_error_message:
           'Veuillez sélectionner des enregistrements à désactiver',
         projects_bulk_deactivated_message:
           '{{ USERS_COUNT }} projets ont été désactivés avec succès',
         projects_single_stats_table_title: 'Statut',
         /** Devices */
         devices_form_header: 'Appareils',
         devices_all: 'Tous',
         devices_active: 'En ligne',
         devices_inactive: 'Hors ligne',
         devices_error: 'ERREUR',
         devices_register_enabled: 'Activé',
         devices_register_disabled: 'Désactivé',
         devices_add_new: 'Ajouter un nouveau',
         devices_name: 'Nom',
         devices_address: "Adresse d'installation",
         devices_client: 'Client',
         devices_project: 'Projet',
         devices_status: 'Statut',
         devices_description: "Module Thermique d'Appartement",
         device_is_online: 'L\'appareil est "en ligne"',
         device_is_offline: 'L\'appareil est "hors ligne"',
         devices_last_viewed: 'Dernière vue',
         devices_action: 'Action',
         devices_search: 'Recherche',
         devices_row_per_page: 'Lignes par page',
         device_rssi_title: 'RSSI',
         device_status_reg_105_no_error_255: "Pas d'erreur",
         device_status_menu_list: JSON.stringify([
           {
             key: 'operating_state',
             value: 'État de fonctionnement',
             permission: 'operating-state-tab-read',
           },
           {
             key: 'settings_hot_water',
             value: 'Réglages eau chaude',
             permission: 'settings-hot-water-tab-read',
           },
           {
             key: 'settings_heating_and_cooling',
             value: 'Réglages chauffage et refroidissement',
             permission: 'settings-heating-and-cooling-tab-read',
           },
           {
             key: 'manual_control',
             value: 'Contrôle manuel',
             permission: 'manual-control-tab-read',
           },
           {
             key: 'firmware_registers',
             value: 'Firmware Registers',
             permission: 'firmware-registers-tab-read',
           },
           {
             key: 'lin_pump_delta_parameters',
             value: 'LIN-Pump DeltaP Parameters',
             permission: 'lin-pump-tab-read',
           },
           {
             key: 'm_bus_meters',
             value: 'Compteurs M-Bus',
             permission: 'm-bus-meters-tab-read',
           },
           {
             key: 'live_hot_water',
             value: 'Journal en direct eau chaude',
             permission: 'livelog-hot-water-tab-read',
           },
           {
             key: 'live_heating',
             value: 'Journal en direct chauffage',
             permission: 'livelog-heating-tab-read',
           },
           {
             key: 'live_cooling',
             value: 'Journal en direct refroidissement',
             permission: 'livelog-cooling-tab-read',
           },
         ]),
         device_status_menu_keys_list: JSON.stringify([
           'operating_state',
           'settings_hot_water',
           'settings_heating_and_cooling',
           'manual_control',
           'firmware_registers',
           'lin_pump_delta_parameters',
           'm_bus_meters',
           'live_hot_water',
           'live_heating',
           'live_cooling',
         ]),
         devices_filter_search: 'Rechercher',
         devices_sort_by_filter_label: 'Trier par',
         devices_sort_by_value_1: 'Date (plus récent)',
         devices_sort_by_value_2: 'Date (plus ancien)',
         devices_sort_by_value_3: 'Alphabétique',
         devices_country_filter_label: 'Pays',
         devices_filter_reset_button: 'Réinitialiser',
         devices_filter_delete_button: 'Supprimer',
         devices_table_name: 'Nom',
         devices_table_firmware: 'Firmware',
         devices_table_device_type: "Type d'appareil",
         devices_table_batch_number: 'Numéro de lot',
         devices_table_client: 'Clients',
         devices_table_devices: 'Appareils',
         devices_table_added: 'Date de création',
         devices_table_status: 'Statut',
         devices_table_row_per_page: 'Lignes par page',
         devices_bread_crumb_main_title: 'Appareils',
         add_devices_bread_crumb_first_link: 'Ajouter un appareil',
         add_devices_form_header: 'Ajouter un appareil',
         edit_devices_bread_crumb_first_link: "Modifier l'appareil",
         edit_devices_form_header: "Modifier l'appareil",
         devices_form_device_information_tab: "Informations sur l'appareil",
         devices_form_name_field: "Nom de l'appareil",
         devices_form_type_field: "Type d'appareil",
         devices_form_ip_address_field: 'Adresse IP',
         devices_form_preset_field: 'Préréglage',
         devices_form_project_field: 'Projet',
         devices_form_client_field: 'Client',
         devices_form_batch_number_field: 'Numéro de lot',
         devices_form_serial_number_field: 'Numéro de série Mercurius',
         devices_form_box_serial_number_field:
           "Numéro de série Unité d'interface thermique",
         devices_form_firmware_field: 'Version du firmware',
         devices_form_description_field: "Module Thermique d'Appartement",
         devices_form_device_address_tab: "Adresse d'installation",
         devices_form_street_number_field: 'Rue',
         devices_form_house_number_field: 'Numéro de maison',
         devices_form_postal_code_field: 'Code postal',
         devices_form_neighbourhood_field: 'Informations supplémentaires',
         devices_form_city_field: 'Ville',
         devices_form_country_field: 'Pays',
         devices_form_floor_number_field: 'Étage',
         devices_form_building_number_field: 'Numéro de construction',
         devices_form_additional_information_tab:
           'Informations supplémentaires',
         devices_form_sn_heat_unit_field:
           'Numéro de série unité d’interface thermique',
         devices_form_article_number_field:
           'Numéro d’article unité d’interface thermique',
         devices_form_prod_order_nr_week_field:
           'Numéro de commande de production',
         devices_form_serial_number_mercurius_field:
           'Numéro de série Mercurius',
         devices_form_sim_card_number_field: 'Numéro de carte SIM',
         devices_form_customer_ref_field: 'Référence du client',
         devices_form_production_date_field: 'Date de production',
         devices_form_order_number_field: 'Numéro de commande',
         devices_form_product_number_field: 'Numéro d’article',
         devices_form_model_number_field: 'Numéro de modèle',
         devices_form_note_field: 'Note (facultatif)',
         devices_form_settings_tab: 'Réglages',
         devices_form_device_interval_field: 'Intervalle',
         devices_form_is_device_enabled_sensor_field:
           'Activer les données du capteur',
         devices_form_is_device_activated_field: "Désactiver l'appareil",
         devices_form_mbus_tab: 'M-Bus',
         devices_form_is_device_enabled_heat_meter_field:
           'Activer le compteur de chaleur',
         devices_form_is_device_enabled_cool_meter_field:
           'Activer le compteur de froid',
         devices_form_is_device_enabled_electric_meter_field:
           "Activer le compteur d'électricité",
         devices_form_is_device_enabled_bi_directional_meter_field:
           'Activer le compteur de chaleur/froid',
         devices_form_is_device_enabled_water_meter_field:
           "Activer le compteur d'eau",
         devices_form_is_device_enabled_mbus_search_meter_button:
           'Recherche M-Bus',
         devices_form_add_device_button: 'Ajouter un appareil',
         devices_form_edit_device_button: 'Enregistrer les modifications',
         devices_form_cancel_button: 'Annuler',
         devices_form_submitting_service_client_button:
           'En cours de soumission...',
         devices_name_required_form_error: 'Le nom est requis',
         devices_batch_number_required_form_error:
           'Le numéro de lot est requis',
         devices_serial_number_required_form_error:
           'Le numéro de série est requis',
         devices_sn_heat_number_numeric_form_error:
           "Le numéro de série de l'unité d'interface thermique doit être un nombre",
         devices_article_number_form_error: 'Le numéro d’article est requis',
         devices_prod_order_nr_week_form_error:
           'Le numéro de commande de production est requis',
         devices_serial_number_mercurius_form_error:
           'Le numéro de série Mercurius est requis',
         devices_sim_card_number_form_error:
           'Le numéro de carte SIM est requis',
         devices_device_interval_numeric_form_error:
           "L'intervalle de l'appareil doit être un nombre",
         devices_client_required_form_error: 'Le client est requis',
         devices_project_required_form_error: 'Le projet est requis',
         devices_preset_required_form_error: 'Le préréglage est requis',
         devices_description_required_form_error: 'La description est requise',
         devices_add_form_success: 'Appareil créé avec succès !',
         devices_edit_form_success: "L'appareil a été mis à jour avec succès !",
         devices_form_unique_error:
           "Le numéro de série de l'unité d'interface thermique et le numéro de série Mercurius doivent être uniques",
         devices_form_api_error: 'Alarme interne - API des appareils',
         devices_no_record_found: 'Aucun appareil trouvé',
         devices_deactivated_message: "L'appareil a été désactivé avec succès",
         devices_activated_message: "L'appareil a été activé avec succès",
         devices_search_mbus_registers_success:
           "Le message a été envoyé avec succès à l'appareil.",
         devices_search_mbus_registers_missing_serial_number_error:
           'Veuillez remplir le numéro de série pour continuer.',
         devices_bulk_no_user_is_selected_error_message:
           'Veuillez sélectionner des enregistrements à désactiver',
         devices_bulk_deactivated_message:
           '{{ USERS_COUNT }} appareils ont été désactivés avec succès',
         // Devices Single
         device_single_page_title: "Détails de l'appareil",
         devices_single_bread_crumb_main_title: "Vue d'ensemble de l'appareil",
         devices_single_bread_crumb_first_link: "Page de l'appareil",
         devices_single_basic_details_client: 'CLIENT',
         devices_single_basic_details_serial_number:
           'NUMÉRO DE SÉRIE MERCURIUS',
         devices_single_basic_details_firmware: 'FIRMWARE',
         devices_single_basic_details_type: "TYPE D'APPAREIL",
         devices_single_edit_device_button: "Modifier l'appareil",
         device_single_error_status: 'Erreur',
         device_single_online_status: 'En ligne',
         device_single_offline_status: 'Hors ligne',
         device_single_rss_device_status: "Statut de l'appareil",
         device_single_rss_signal_strength: 'Force du signal',
         device_single_temperature_tab: 'Graphique de température',
         device_single_temperature_title:
           "Historique de l'unité d'interface thermique",
         device_single_temperature_hr: 'Heure',
         device_single_registers_tab: 'Registres',
         device_single_event_tab: 'Événements',
         device_single_device_details_tab: 'Infos',
         device_single_device_api_timer_seconds_label: 'Secondes',
         device_single_device_api_timer_minute_label: 'Minute',
         device_single_device_api_timer_minutes_label: 'Minutes',
         device_single_recall_device_status_api_timer_field: 'Intervalle API',
         devices_single_last_seen: 'Dernière connexion',
         devices_single_fetch_registers: 'COLLECTE DE DONNÉES',
         fetch_registers_success:
           "La demande a été envoyée avec succès à l'appareil.",
         write_registers_success:
           "Le message d'écriture a été envoyé avec succès à l'appareil.",
         write_registers_error: 'Veuillez changer la valeur pour continuer.',
         fetch_registers_m_bus_meters_not_supported:
           'Les compteurs M-Bus ne sont pas pris en charge pour le moment.',
         // Operating Status
         business_situation_operating_status_TR03_title:
           "État de fonctionnement de l'unité d'interface thermique",
         device_status_nr: 'NR',
         device_status_name: 'Nom',
         device_status_value: 'Valeur',
         business_situation_operating_status_TR03_100: 'État de chauffage',
         business_situation_operating_status_TR03_100_list: JSON.stringify({
           list: {
             0: 'Inactif',
             1: 'Demande',
             2: 'Demande',
             3: 'Circulation après',
             4: 'Désactivé',
             5: 'Circulation avant',
           },
         }),
         business_situation_operating_status_TR03_101: "État de l'eau chaude",
         business_situation_operating_status_TR03_101_list: JSON.stringify({
           list: {
             0: 'Inactif',
             1: 'Demande',
             2: 'Demande',
             3: 'Circulation après',
             4: 'Désactivé',
           },
         }),
         business_situation_operating_status_TR03_102: 'État de préchauffage',
         business_situation_operating_status_TR03_102_list: JSON.stringify({
           list: {
             0: 'Inactif',
             1: 'Demande',
           },
         }),
         business_situation_operating_status_TR03_103:
           'État de désinfection thermique',
         business_situation_operating_status_TR03_103_list: JSON.stringify({
           list: {
             0: 'Inactif',
             1: 'Demande',
             2: 'Demande',
             3: 'Circulation après',
             4: 'Désactivé',
           },
         }),
         business_situation_operating_status_TR03_104:
           'État de refroidissement',
         business_situation_operating_status_TR03_104_list: JSON.stringify({
           list: {
             0: 'Inactif',
             1: 'Demande',
             2: 'Initialisation',
             3: 'Demande',
             4: 'Circulation après',
             5: 'Circulation avant',
           },
         }),
         business_situation_operating_status_TR03_1802:
           "État de l'élément chauffant TE",
         business_situation_operating_status_TR03_1802_list: JSON.stringify({
           list: {
             0: 'Désactivé',
             1: 'Activé',
           },
         }),
         business_situation_operating_status_TR03_105: "Code d'alarme",
         business_situation_operating_status_TR03_106: 'Version du logiciel',
         business_situation_operating_status_TR03_107:
           "Vanne d'eau chaude (M1)",
         business_situation_operating_status_TR03_108:
           'Vanne de chauffage/refroidissement (M2)',
         business_situation_operating_status_TR03_109: 'Pompe',
         business_situation_operating_status_TR03_109_list: JSON.stringify({
           list: {
             0: 'Désactivée',
             1: 'Activée',
           },
         }),
         business_situation_operating_status_TR03_110: 'Vanne 6 voies',
         business_situation_operating_status_TR03_110_list: JSON.stringify({
           list: {
             0: 'Position : Chauffage',
             1: 'Position : Refroidissement',
           },
         }),
         business_situation_operating_status_TR03_112_list: JSON.stringify({
           list: {
             0: 'Chauffage ou demande',
             1: 'Refroidissement',
           },
         }),
         business_situation_operating_status_TR03_113:
           "Entrée du thermostat d'ambiance",
         business_situation_operating_status_TR03_113_list: JSON.stringify({
           list: {
             1: 'Pas de demande de chauffage',
             2: 'Demande de chauffage',
           },
         }),
         business_situation_operating_status_TR03_114: 'Indicateur OpenTherm',
         business_situation_operating_status_TR03_114_list: JSON.stringify({
           list: {
             0: 'Connexion inactive',
             1: 'Connexion active',
           },
         }),
         business_situation_operating_status_TR03_115: "Type d'appareil",
         // Business situation
         business_situation_measured_values_TR03_title: 'Mesures',
         business_situation_measured_values_TR03_200: "Débit d'eau chaude",
         business_situation_measured_values_TR03_201:
           "Température de l'eau chaude",
         business_situation_measured_values_TR03_202:
           'Approvisionnement primaire',
         business_situation_measured_values_TR03_203:
           'Retour primaire/Extérieur',
         business_situation_measured_values_TR03_205:
           'Approvisionnement secondaire',
         business_situation_measured_values_TR03_206: 'Retour secondaire',
         business_situation_measured_values_TR03_204:
           'Point de consigne de chauffage calculé',
         business_situation_measured_values_TR03_207:
           'Température ambiante (OpenTherm)',
         business_situation_measured_values_TR03_208:
           'Point de consigne de la pièce (OpenTherm)',
         business_situation_measured_values_TR03_210:
           "Pression d'eau secondaire",
         // Operating time
         business_situation_operating_time_TR03_title:
           'Temps de fonctionnement',
         business_situation_operating_time_TR03_800:
           'Temps de fonctionnement total du système',
         business_situation_operating_time_TR03_801:
           'Temps de combustion de chauffage',
         business_situation_operating_time_TR03_802:
           'Temps de combustion de refroidissement',
         business_situation_operating_time_TR03_803:
           "Temps de combustion de l'eau chaude",
         business_situation_operating_time_TR03_804: 'Nombre de puisages',
         business_situation_operating_time_TR03_805: "Volume d'eau chaude",
         business_situation_operating_time_TR03_806: 'Coupures de courant',
         // Warmtapwater
         settings_dhw_warm_tap_water_TR03_title:
           'Réglages eau chaude sanitaire',
         settings_dhw_warm_tap_water_TR03_300:
           "Point de consigne de l'eau chaude",
         settings_dhw_warm_tap_water_TR03_301: 'Mode préchauffage',
         settings_dhw_warm_tap_water_TR03_301_list: JSON.stringify({
           list: {
             0: 'Désactivé',
             1: 'Antigel',
             2: 'Économie',
             3: 'Confort',
             4: 'Dynamique (recommandé)',
           },
         }),
         settings_dhw_warm_tap_water_TR03_302: 'Point de consigne de confort',
         settings_dhw_warm_tap_water_TR03_303: 'Seuil de débit minimal',
         settings_dhw_warm_tap_water_TR03_304: "Activation de l'eau chaude",
         settings_dhw_warm_tap_water_TR03_304_list: JSON.stringify({
           list: {
             0: 'Désactivé',
             1: 'Activé',
           },
         }),
         // Thermal disinfection
         settings_thermal_disinfection_TR03_title:
           'Réglages Désinfection thermique',
         settings_thermal_disinfection_TR03_400:
           'Désinfection thermique activée',
         settings_thermal_disinfection_TR03_400_list: JSON.stringify({
           list: {
             0: 'Désactivé',
             1: 'Activé',
           },
         }),
         settings_thermal_disinfection_TR03_401:
           'Point de consigne de désinfection thermique',
         settings_thermal_disinfection_TR03_402:
           'Durée de combustion de la désinfection thermique',
         settings_thermal_disinfection_TR03_403:
           "Temps d'attente de la désinfection thermique",
         // TE-Booster
         settings_dhw_te_booster_TR03_title: 'Réglages TE-Booster',
         settings_dhw_te_booster_TR03_1800: 'TE-Booster',
         settings_dhw_te_booster_TR03_1800_list: JSON.stringify({
           list: {
             0: 'Désactivé',
             1: 'Activé',
           },
         }),
         settings_dhw_te_booster_TR03_1804: 'Point de consigne TE-Booster',
         settings_dhw_te_booster_TR03_1805:
           'Hystérésis du point de consigne TE-Booster',
         settings_dhw_te_booster_TR03_1812:
           'Délai du point de consigne TE-Booster',
         settings_dhw_te_booster_TR03_1813:
           'Minuteur du point de consigne TE-Booster',
         settings_dhw_te_booster_TR03_1815: 'Seuil TE-Booster',
         settings_dhw_te_booster_TR03_1816: 'Volume enregistré TE-Booster',
         // Heating
         heating_and_cooling_settings_heating_TR03_title: 'Réglages chauffage',
         heating_and_cooling_settings_heating_TR03_500:
           'Point de consigne maximal chauffage',
         heating_and_cooling_settings_heating_TR03_501:
           'Point de consigne minimal chauffage',
         heating_and_cooling_settings_heating_TR03_506:
           'Retour primaire maximal',
         heating_and_cooling_settings_heating_TR03_507:
           'Facteur de compensation de retour primaire',
         heating_and_cooling_settings_heating_TR03_508:
           'Différence de consigne primaire-secondaire',
         heating_and_cooling_settings_heating_TR03_510:
           'Température maximale de chauffage',
         heating_and_cooling_settings_heating_TR03_509:
           'Différence minimale primaire-secondaire',
         heating_and_cooling_settings_heating_TR03_514:
           'Point de consigne de chauffage',
         heating_and_cooling_settings_heating_TR03_515:
           'Activation du chauffage',
         heating_and_cooling_settings_heating_TR03_515_list: JSON.stringify({
           list: {
             0: 'Désactivé',
             1: 'Activé',
           },
         }),
         // Cooling
         heating_and_cooling_settings_cooling_TR03_title:
           'Réglages refroidissement',
         heating_and_cooling_settings_cooling_TR03_600:
           'Point de consigne de refroidissement',
         heating_and_cooling_settings_cooling_TR03_601:
           'Retour primaire minimal',
         heating_and_cooling_settings_cooling_TR03_602:
           'Facteur de compensation de retour primaire',
         heating_and_cooling_settings_cooling_TR03_605:
           'Température maximale de refroidissement',
         heating_and_cooling_settings_cooling_TR03_606:
           'Point de consigne de refroidissement minimal',
         heating_and_cooling_settings_cooling_TR03_607:
           'Point de consigne de refroidissement maximal',
         heating_and_cooling_settings_cooling_TR03_611:
           'Activation du refroidissement',
         heating_and_cooling_settings_cooling_TR03_611_list: JSON.stringify({
           list: {
             0: 'Désactivé',
             1: 'Activé',
           },
         }),
         // Secondary General
         heating_and_cooling_settings_secondary_general_TR03_title:
           'Réglages généraux',
         heating_and_cooling_settings_secondary_general_TR03_512:
           'Pression minimale',
         heating_and_cooling_settings_secondary_general_TR03_513:
           'Pression maximale',
         heating_and_cooling_settings_secondary_general_TR03_603:
           "Temps d'attente pour basculer chauffage et refroidissement",
         heating_and_cooling_settings_secondary_general_TR03_604:
           "Temps d'attente de la vanne 6 voies",
         // Changeover WKW
         heating_and_cooling_settings_changeover_wkw_TR03_title:
           'Réglages systèmes 3,5 tubes',
         heating_and_cooling_settings_changeover_wkw_TR03_1850:
           'Configuration 3,5 tubes',
         heating_and_cooling_settings_changeover_wkw_TR03_1850_list: JSON.stringify(
           {
             list: {
               0: 'Chauffage',
               1: 'Refroidissement',
             },
           }
         ),
         heating_and_cooling_settings_changeover_wkw_TR03_1851:
           'Seuil de détection du refroidissement',
         heating_and_cooling_settings_changeover_wkw_TR03_1852:
           'Seuil de détection du chauffage',
         heating_and_cooling_settings_changeover_wkw_TR03_1853:
           'Point de consigne de chauffage abaissé',
         heating_and_cooling_settings_changeover_wkw_TR03_1854:
           'Point de consigne abaissé utilisé',
         heating_and_cooling_settings_changeover_wkw_TR03_1854_list: JSON.stringify(
           {
             list: {
               0: 'Désactivé',
               1: 'Activé',
             },
           }
         ),
         heating_and_cooling_settings_changeover_wkw_TR03_1855:
           'Position de pré-détection M2',
         heating_and_cooling_settings_changeover_wkw_TR03_1856:
           'Intervalle de détection',
         heating_and_cooling_settings_changeover_wkw_TR03_1857:
           "Minuteur de l'intervalle de détection",
         heating_and_cooling_settings_changeover_wkw_TR03_1858:
           'Délai de pré-détection',
         heating_and_cooling_settings_changeover_wkw_TR03_1859:
           'Minuteur de pré-détection',
         heating_and_cooling_settings_changeover_wkw_TR03_1860:
           'Minuteur de bascule de configuration',
         heating_and_cooling_settings_changeover_wkw_TR03_1861:
           'Délai de bascule',
         heating_and_cooling_settings_changeover_wkw_TR03_1862:
           'Seuil de bascule de configuration',
         heating_and_cooling_settings_changeover_wkw_TR03_1863:
           'Mode de fonction Boost',
         heating_and_cooling_settings_changeover_wkw_TR03_1863_list: JSON.stringify(
           {
             list: {
               0: 'Désactivé',
               1: 'Activé',
             },
           }
         ),
         heating_and_cooling_settings_changeover_wkw_TR03_1864:
           'Minuteur de détection Boost',
         heating_and_cooling_settings_changeover_wkw_TR03_1865:
           'Délai de détection Boost',
         heating_and_cooling_settings_changeover_wkw_TR03_1866:
           'Position de boost maximale',
         // Manual Operation
         settings_manual_operation_TR03_title: 'Contrôle manuel',
         settings_manual_operation_TR03_700: 'Activation du contrôle manuel',
         settings_manual_operation_TR03_700_list: JSON.stringify({
           list: {
             0: 'Désactivé',
             1: 'Activé',
           },
         }),
         settings_manual_operation_TR03_701: 'Vanve eau chaude (M1)',
         settings_manual_operation_TR03_702:
           'Vanve chauffage/refroidissement (M2)',
         settings_manual_operation_TR03_703: 'Pompe',
         settings_manual_operation_TR03_703_list: JSON.stringify({
           list: {
             0: 'Désactivé',
             1: 'Activé',
           },
         }),
         settings_manual_operation_TR03_704: 'Vanne 6 voies',
         settings_manual_operation_TR03_704_list: JSON.stringify({
           list: {
             0: 'Chauffage',
             1: 'Refroidissement',
           },
         }),
         settings_manual_operation_TR03_706: 'État de la demande de chaleur',
         settings_manual_operation_TR03_706_list: JSON.stringify({
           list: {
             0: 'Chauffage ou demande',
             1: 'Refroidissement',
           },
         }),
         settings_manual_operation_TR03_707: 'Vanve eau chaude (M1) [%]',
         settings_manual_operation_TR03_708:
           'Vanve chauffage/refroidissement (M2) [%]',
         settings_manual_operation_TR03_1801: 'Élément électrique TE-Booster',
         settings_manual_operation_TR03_1801_list: JSON.stringify({
           list: {
             0: 'Désactivé',
             1: 'Activé',
           },
         }),
         settings_manual_operation_TR03_709: 'Manual control timeout timer',
         // Live Tap Water
         live_tap_water_title: 'Eau Chaude en Temps Réel',
         live_tap_water_101: "État de l'eau chaude",
         live_tap_water_107: 'Vanve eau chaude (M1)',
         live_tap_water_200: 'Débit',
         live_tap_water_201: "Température de l'eau chaude",
         live_tap_water_202: 'Approvisionnement primaire',
         live_tap_water_203: 'Retour primaire',
         live_tap_water_1007: 'Débit primaire compteur M-Bus',
         live_tap_water_1008: 'Puissance',
         // Live CV
         live_cv_title: 'Chauffage en Temps Réel',
         live_cv_100: 'État de chauffage',
         live_cv_108: 'Vanve chauffage (M2)',
         live_cv_202: 'Approvisionnement primaire',
         live_cv_203: 'Retour primaire',
         live_cv_204: 'Point de consigne de chauffage calculé',
         live_cv_205: 'Approvisionnement secondaire',
         live_cv_206: 'Retour secondaire',
         live_cv_113: "Entrée thermostat d'ambiance",
         live_cv_210: "Pression d'eau secondaire",
         live_cv_1007: 'Débit primaire compteur M-Bus',
         live_cv_1008: 'Puissance',
         // Live Cooling
         live_cooling_title: 'Refroidissement en Temps Réel',
         live_cooling_104: 'État de refroidissement',
         live_cooling_109: 'Pompe',
         live_cooling_110: 'Vanne 6 voies',
         live_cooling_113: "Entrée thermostat d'ambiance",
         live_cooling_108: 'Vanne de refroidissement (M2)',
         live_cooling_202: 'Approvisionnement primaire',
         live_cooling_204: 'Point de consigne de chauffage calculé',
         live_cooling_205: 'Approvisionnement secondaire',
         live_cooling_206: 'Retour secondaire',
         // M Bus Limit DELETE ALL
         m_bus_limit_title: 'Limitation du Bus M',
         m_bus_limit_1500: 'Activation de la limitation',
         m_bus_limit_1501: 'Numéro de série du compteur limité',
         m_bus_limit_1503: 'État de limitation',
         m_bus_limit_1504: 'Configuration de limitation EC (h) et ECS (b)',
         m_bus_limit_1505: 'Limitation de puissance',
         m_bus_limit_1506: 'Limitation de débit',
         m_bus_limit_1507:
           'Limitation de température de retour (Uniquement pour ECS)',
         // Meter 1
         m_bus_meter_1_title: 'Compteur 1 (Chauffage)',
         m_bus_meter_1_0000: 'Numéro de série',
         m_bus_meter_1_0002: 'Fabricant',
         m_bus_meter_1_0003: 'Type de compteur',
         m_bus_meter_1_0004: 'État',
         m_bus_meter_1_0005: 'Débit',
         m_bus_meter_1_0006: 'Puissance',
         m_bus_meter_1_0007: "Température d'alimentation",
         m_bus_meter_1_0008: 'Température de retour',
         m_bus_meter_1_0010: 'Énergie de chauffage accumulée',
         m_bus_meter_1_0012: 'Volume accumulé',
         // Meter 2
         m_bus_meter_2_title: 'Compteur 2 (Refroidissement)',
         m_bus_meter_2_0100: 'Numéro de série',
         m_bus_meter_2_0102: 'Fabricant',
         m_bus_meter_2_0103: 'Type de compteur',
         m_bus_meter_2_0104: 'État',
         m_bus_meter_2_0105: 'Débit',
         m_bus_meter_2_0106: 'Puissance',
         m_bus_meter_2_0107: "Température d'alimentation",
         m_bus_meter_2_0108: 'Température de retour',
         m_bus_meter_2_0110: 'Énergie de refroidissement accumulée',
         m_bus_meter_2_0112: 'Volume accumulé',
         // Meter 3
         m_bus_meter_3_title: 'Compteur 3 (Électricité)',
         m_bus_meter_3_0200: 'Numéro de série',
         m_bus_meter_3_0202: 'Fabricant',
         m_bus_meter_3_0203: 'Type de compteur',
         m_bus_meter_3_0204: 'État',
         m_bus_meter_3_0206: 'Puissance',
         m_bus_meter_3_0210: 'Énergie accumulée',
         m_bus_meter_3_0214: 'Courant',
         // Meter 4
         m_bus_meter_4_title: 'Compteur 4 (Eau)',
         m_bus_meter_4_0300: 'Numéro de série',
         m_bus_meter_4_0302: 'Fabricant',
         m_bus_meter_4_0303: 'Type de compteur',
         m_bus_meter_4_0304: 'État',
         m_bus_meter_4_0305: 'Débit',
         m_bus_meter_4_0307: "Température d'alimentation (si disponible)",
         m_bus_meter_4_0312: 'Volume accumulé',
         // Meter 5
         m_bus_meter_5_title: 'Compteur 5 (Bidirectionnel)',
         m_bus_meter_5_0400: 'Numéro de série',
         m_bus_meter_5_0402: 'Fabricant',
         m_bus_meter_5_0403: 'Type de compteur',
         m_bus_meter_5_0404: 'État',
         m_bus_meter_5_0405: 'Débit',
         m_bus_meter_5_0406: 'Puissance',
         m_bus_meter_5_0407: "Température d'alimentation",
         m_bus_meter_5_0408: 'Température de retour',
         m_bus_meter_5_0410: 'Énergie de chauffage accumulée',
         m_bus_meter_5_0412: 'Volume accumulé',
         m_bus_meter_5_0414: 'Énergie de refroidissement accumulée',
         // History Block Alarms
         history_block_errors_title:
           "Erreurs de Bloc d'Historique - triées par les plus récentes",
         history_block_errors_860: 'Alarme de Bloc 1',
         history_block_errors_861: 'Alarme de Bloc 2',
         history_block_errors_862: 'Alarme de Bloc 3',
         history_block_errors_863: 'Alarme de Bloc 4',
         history_block_errors_864: 'Alarme de Bloc 5',
         history_block_errors_865: 'Alarme de Bloc 6',
         history_block_errors_866: 'Alarme de Bloc 7',
         history_block_errors_867: 'Alarme de Bloc 8',
         history_block_errors_868: 'Alarme de Bloc 9',
         history_block_errors_869: 'Alarme de Bloc 10',
         history_block_errors_870: 'Alarme de Bloc 11',
         history_block_errors_871: 'Alarme de Bloc 12',
         history_block_errors_872: 'Alarme de Bloc 13',
         history_block_errors_873: 'Alarme de Bloc 14',
         history_block_errors_874: 'Alarme de Bloc 15',
         // Events
         device_events_type_filter_label: "Type d'événement",
         device_events_type_filter_value_1: 'Audit',
         device_events_type_filter_value_2: 'Alarme',
         // Presets
         presets: 'Préréglages',
         presets_all: 'Tous',
         presets_active: 'ACTIF',
         presets_inactive: 'INACTIF',
         presets_add_new: 'Ajouter nouveau',
         presets_filter_search: 'Recherche',
         presets_filter_reset_button: 'Réinitialiser',
         presets_filter_delete_button: 'Supprimer',
         presets_table_name: 'Nom',
         presets_table_status: 'Statut',
         presets_updated_date: 'Mis à jour le',
         presets_action: 'Actions',
         presets_table_row_per_page: 'Lignes par page',
         presets_status_menu_list: JSON.stringify([
           {
             key: 'settings_hot_water',
             value: 'Réglages eau chaude',
             permission: 'settings-hot-water-tab-read',
           },
           {
             key: 'settings_heating_and_cooling',
             value: 'Réglages chauffage et refroidissement',
             permission: 'settings-heating-and-cooling-tab-read',
           },
           {
             key: 'manual_control',
             value: 'Contrôle manuel',
             permission: 'manual-control-tab-read',
           },
         ]),
         add_presets_title: 'Ajouter préréglage',
         edit_presets_title: 'Modifier préréglage',
         presets_form_name_required: 'Le nom du préréglage est requis',
         presets_form_register_required:
           "La valeur d'enregistrement est requise",
         presets_form_add_preset_button: 'Enregistrer les modifications',
         presets_form_edit_preset_button: 'Enregistrer les modifications',
         presets_form_cancel_button: 'Annuler',
         presets_add_form_success: 'Préréglage créé avec succès !',
         presets_edit_form_success: 'Préréglage mis à jour avec succès !',
         presets_form_api_error:
           "Alarme du serveur interne de l'API - Préréglages",
         presets_no_record_found: 'Aucun préréglage trouvé',
         presets_deactivated_message: 'Le préréglage est désactivé avec succès',
         presets_activated_message: 'Le préréglage est activé avec succès',
         presets_bulk_no_user_is_selected_error_message:
           'Veuillez sélectionner des enregistrements à désactiver',
         presets_bulk_deactivated_message:
           '{{ USERS_COUNT }} préréglages sont désactivés avec succès',
         // Audits
         audits: 'Vérifications',
         audits_all: 'Tous',
         audits_active: 'Vérification',
         audits_inactive: 'Alarme',
         audits_filter_search: 'Recherche',
         audits_client_filter_label: 'Client',
         audits_error_code_filter_label: "Code d'alarme",
         audits_project_filter_label: 'Projet',
         audits_order_number_filter_label: 'Numéro de commande',
         audits_events_type_filter_label: "Type d'événement",
         audits_date_range_filter_label: 'Plage de dates',
         audits_events_type_filter_value_1: 'Vérification',
         audits_events_type_filter_value_2: 'Alarme',
         audits_reset_filters_button: 'Réinitialiser',
         audits_date: 'Date',
         audits_device: 'Appareil',
         audits_client: 'Client',
         audits_message: 'Message',
         audits_table_row_per_page: 'Lignes par page',
         audits_table_no_record_found: 'Aucun enregistrement trouvé',
         // Settings
         settings_update_profile_title: 'Mettre à jour le profil',
         settings_notification_title: 'Notifications',
         settings_notification_window_exceptions_title:
           "Notifier en cas d'exceptions de la fenêtre de fonctionnement",
         settings_notification_device_error_title:
           "Notifier lorsqu'un appareil est en mode d'erreur",
         settings_notification_channels_title: 'Canaux de notifications',
         settings_notification_use_email_title: "Utiliser l'email",
         /* Admins */
         admins: 'Administrateurs',
         admins_first_bread_crumb: 'Administrateurs',
         admins_filter_search: 'Recherche',
         admins_add_new: 'Ajouter un utilisateur',
         admins_filter_reset_button: 'Réinitialiser',
         admins_filter_delete_button: 'Désactiver',
         admins_search: 'Recherche',
         admins_all: 'TOUS',
         admins_active: 'ACTIF',
         admins_inactive: 'INACTIF',
         admins_table_name: 'Nom',
         admins_table_address: 'Adresse',
         admins_table_role_id: 'Rôle',
         admins_table_status: 'Statut',
         admins_table_added: 'Date de création',
         admins_table_no_record_found: 'Aucun enregistrement trouvé',
         admins_table_row_per_page: 'Lignes par page',
         admins_no_user_selected_for_de_activation_message:
           'Veuillez sélectionner des enregistrements à désactiver',
         admins_bread_crumb_main_title: 'Administrateurs',
         add_admins_bread_crumb_first_link: 'Ajouter administrateur',
         add_admins_form_header: 'Ajouter administrateur',
         edit_admins_bread_crumb_first_link: 'Modifier administrateur',
         edit_admins_form_header: 'Modifier administrateur',
         admins_form_first_name_field: 'Prénom',
         admins_form_last_name_field: 'Nom de famille',
         admins_form_email_field: 'Adresse email',
         admins_form_official_email_field: 'Adresse email officielle',
         admins_form_phone_field: 'Numéro de téléphone',
         admins_form_official_phone_number_field:
           'Numéro de téléphone officiel',
         admins_form_password_field: 'Mot de passe',
         admins_form_role_id_field: 'Rôle',
         admins_form_select_role_id_field: 'Sélectionner un rôle',
         admins_form_street_number_field: 'Rue',
         admins_form_house_number_field: 'Numéro de maison',
         admins_form_neighbourhood_field: 'Quartier',
         admins_form_postal_code_field: 'Code postal',
         admins_form_city_field: 'Ville',
         admins_form_country_field: 'Pays',
         admins_form_email_verification_field: "Vérification de l'email",
         admins_form_email_verification_sub_title_field:
           "La désactivation de ceci enverra automatiquement un email de vérification à l'administrateur",
         admins_form_add_admin_button: 'Enregistrer les modifications',
         admins_form_edit_admin_button: 'Enregistrer les modifications',
         admins_form_cancel_button: 'Annuler',
         admins_form_submitting_admin_button: 'En cours...',
         admins_first_name_required_form_error: 'Le prénom est requis',
         admins_last_name_required_form_error: 'Le nom de famille est requis',
         admins_email_required_form_error: "L'adresse email est requise",
         admins_email_valid_form_error: 'Doit être une adresse email valide',
         admins_password_required_form_error: 'Le mot de passe est requis',
         admins_country_required_form_error: 'Le pays est requis',
         admins_role_id_required_form_error: 'Le rôle est requis',
         admins_password_form_error:
           'Le mot de passe doit contenir au moins une lettre majuscule, un chiffre et un caractère spécial',
         admins_add_form_success: "L'administrateur est créé avec succès !",
         admins_edit_form_success:
           "L'administrateur est mis à jour avec succès !",
         admins_form_api_error:
           'Erreur interne du serveur API - Administrateurs',
         admins_form_email_error: "L'adresse email existe déjà",
         admins_no_record_found: 'Aucun administrateur trouvé',
         admins_deactivated_message:
           "L'administrateur est désactivé avec succès",
         admins_activated_message: "L'administrateur est activé avec succès",
         admins_email_verified_title: "L'email est vérifié",
         admins_email_verified_sub_title:
           "La désactivation de ceci enverra automatiquement un email de vérification à l'administrateur",
         admins_bulk_no_admin_is_selected_error_message:
           'Veuillez sélectionner des enregistrements à désactiver',
         admins_bulk_deactivated_message:
           '{{ USERS_COUNT }} administrateurs sont désactivés avec succès',
         // Search Results
         search_result_title: 'Résultats de la recherche : ',
         search_users: 'Utilisateurs',
         search_clients: 'Clients',
         search_service_clients: 'Clients de service',
         search_devices: 'Appareils',
         search_presets: 'Préréglages',
         search_projects: 'Projets',
         // New Languages
         no_error_devices_found: 'Aucun appareil en erreur trouvé',
         project_single_first_bread_crumb: 'Projets',
         project_single_second_bread_crumb: 'Voir le projet',
         project_single_client_label: 'Client',
         project_single_service_client_label: 'Client de service',
         project_single_devices_label: 'Appareils',
         project_single_edit_button: 'Modifier',
         project_single_devices_tab: 'Appareils',
         client_single_view_more_errors_button: 'Voir plus',
         client_error_single_devices_tab: 'Appareils en alarme',
         client_error_single_device_name: 'Appareil',
         client_error_single_device_error_code: "Code d'alarme",
         client_error_single_device_error_date_time: 'Date',
         devices_bulk_edit_registers_button: 'Modifier le(s) paramètre(s)',
         devices_bulk_edit_ota_button: 'Mise à jour du(des) appareil(s)',
         client_error_single_device_errors_table_row_per_page:
           'Lignes par page',
         client_error_single_device_error_no_record_found:
           'Aucun enregistrement trouvé',
         devices_bulk_edit_registers_title:
           "Mise à jour des paramètres d'appareil en vrac",
         devices_bulk_edit_registers_form_submit_button: 'Mise à jour groupée',
         devices_bulk_edit_registers_form_cancel_button: 'Annuler',
         devices_bulk_edit_registers_form_success:
           'Message transmis aux appareils sélectionnés',
         devices_bulk_edit_registers_form_error:
           'Veuillez remplir au moins une valeur de registre',
         devices_bulk_edit_registers_form_api_error:
           'Erreur interne du serveur',
         devices_bulk_edit_ota_title:
           "Mise à jour groupée du firmware d'appareil",
         devices_bulk_edit_ota_form_firmware_field: 'Firmware',
         devices_bulk_edit_ota_form_submit_button:
           'Mettre à jour les appareils',
         devices_bulk_edit_ota_form_cancel_button: 'Annuler',
         devices_bulk_edit_ota_form_success:
           'Message transmis aux appareils sélectionnés',
         devices_bulk_edit_ota_form_firmware_required_error: 'Firmware requis',
         devices_bulk_edit_ota_form_api_error:
           'Erreur interne du serveur en vrac',
         devices_bulk_edit_registers_selected_devices:
           'Appareils sélectionnés pour la mise à jour groupée',
         // Device Status Table Pop Over
         custom_popover_min_value: 'Valeur min.',
         custom_popover_max_value: 'Valeur max.',
         custom_popover_list_options: 'Valeurs possibles',
         custom_popover_short_description: 'Description',
         custom_popover_close_modal_button: 'Fermer la fenêtre',
         // Warmtapwater PopOver Short Description
         custom_popover_300_short_description:
           "Température de consigne d'eau chaude",
         custom_popover_301_short_description: 'Mode de préchauffage',
         custom_popover_302_short_description:
           'Température de consigne de confort',
         custom_popover_303_short_description: 'Seuil de débit minimum',
         custom_popover_304_short_description: "Activation de l'eau chaude",
         // Thermal disinfection PopOver Short Description
         custom_popover_400_short_description: 'Désinfection thermique activée',
         custom_popover_401_short_description:
           'Point de consigne de désinfection thermique',
         custom_popover_402_short_description:
           'Temps de brûlage de la désinfection thermique',
         custom_popover_403_short_description:
           "Temps d'attente de la désinfection thermique",
         // TE-Booster PopOver Short Description
         custom_popover_1800_short_description: 'TE-Booster activé',
         custom_popover_1804_short_description: 'Point de consigne TE-Booster',
         custom_popover_1805_short_description:
           'Hystérésis du point de consigne TE-Booster',
         custom_popover_1812_short_description:
           'Délai du point de consigne TE-Booster',
         custom_popover_1813_short_description:
           'Minuteur du point de consigne TE-Booster',
         custom_popover_1815_short_description: 'Seuil TE-Booster',
         custom_popover_1816_short_description: 'Volume enregistré TE-Booster',
         // Heating PopOver Short Description
         custom_popover_500_short_description:
           'Température de consigne maximale de chauffage',
         custom_popover_501_short_description:
           'Température de consigne minimale de chauffage',
         custom_popover_506_short_description: 'Retour primaire maximal',
         custom_popover_507_short_description:
           'Facteur de compensation de retour primaire',
         custom_popover_508_short_description:
           'Écart de température entre primaire et secondaire',
         custom_popover_510_short_description:
           'Température maximale de chauffage',
         custom_popover_509_short_description:
           'Écart minimal entre primaire et secondaire',
         custom_popover_514_short_description:
           'Température de consigne de chauffage',
         custom_popover_515_short_description: 'Activation du chauffage',
         // Cooling PopOver Short Description
         custom_popover_600_short_description:
           'Température de consigne de refroidissement',
         custom_popover_601_short_description: 'Retour primaire minimal',
         custom_popover_602_short_description:
           'Facteur de compensation de retour primaire',
         custom_popover_605_short_description:
           'Température maximale de refroidissement',
         custom_popover_606_short_description:
           'Température de consigne minimale de refroidissement',
         custom_popover_607_short_description:
           'Température de consigne maximale de refroidissement',
         custom_popover_611_short_description: 'Activation du refroidissement',
         // Secondary General PopOver Short Description
         custom_popover_512_short_description: 'Pression minimale',
         custom_popover_513_short_description: 'Pression maximale',
         custom_popover_603_short_description:
           "Temps d'attente pour basculer entre chauffage et refroidissement",
         custom_popover_604_short_description:
           "Temps d'attente de la vanne 6 voies",
         // Changeover WKW PopOver Short Description
         custom_popover_1850_short_description:
           'Configuration du système 3.5 tuyaux',
         custom_popover_1851_short_description:
           'Seuil de détection du refroidissement',
         custom_popover_1852_short_description:
           'Seuil de détection du chauffage',
         custom_popover_1853_short_description:
           'Point de consigne réduit pour le chauffage',
         custom_popover_1854_short_description:
           'Point de consigne réduit utilisé',
         custom_popover_1855_short_description: 'Position de prédétection M2',
         custom_popover_1856_short_description: 'Intervalle de détection',
         custom_popover_1857_short_description:
           "Minuterie d'intervalle de détection",
         custom_popover_1858_short_description: 'Délai de prédétection',
         custom_popover_1859_short_description: 'Minuterie de prédétection',
         custom_popover_1860_short_description:
           'Minuterie de commutation de configuration',
         custom_popover_1861_short_description: 'Délai de commutation',
         custom_popover_1862_short_description:
           'Seuil de commutation de configuration',
         custom_popover_1863_short_description:
           'Mode de fonctionnement de renforcement',
         custom_popover_1864_short_description:
           'Minuterie de détection de renforcement',
         custom_popover_1865_short_description:
           'Délai de détection de renforcement',
         custom_popover_1866_short_description:
           'Position de renforcement maximale',
         // Manual Operation PopOver Short Description
         custom_popover_700_short_description: 'Activation du contrôle manuel',
         custom_popover_701_short_description: 'Van M1 eau chaude',
         custom_popover_702_short_description:
           'Van M2 chauffage/refroidissement',
         custom_popover_703_short_description: 'Pompe',
         custom_popover_704_short_description: 'Van 6 voies',
         custom_popover_706_short_description:
           "Sortie d'état de la demande de chauffage",
         custom_popover_707_short_description: 'Van M1 eau chaude [%]',
         custom_popover_708_short_description:
           'Van M2 chauffage/refroidissement [%]',
         custom_popover_1801_short_description: 'Élément électrique TE-Booster',
         custom_popover_709_short_description:
           'Minuterie de temporisation de contrôle manuel',
         // Warmtapwater PopOver Long Description
         custom_popover_300_long_description: 'Point de consigne ECS',
         custom_popover_301_long_description: 'Mode de préchauffage',
         custom_popover_302_long_description: 'Point de consigne confort',
         custom_popover_303_long_description: 'Seuil de démarrage du débit',
         custom_popover_304_long_description: "Activation de l'ECS",
         // Thermal disinfection PopOver Long Description
         custom_popover_400_long_description:
           'Activation de la désinfection thermique',
         custom_popover_401_long_description:
           'Point de consigne de désinfection thermique',
         custom_popover_402_long_description:
           'Durée de combustion de désinfection thermique',
         custom_popover_403_long_description:
           "Temps d'attente de désinfection thermique",
         // TE-Booster PopOver Long Description
         custom_popover_1800_long_description: 'Activation du TE-Booster',
         custom_popover_1804_long_description:
           'Point de consigne du TE-Booster',
         custom_popover_1805_long_description:
           'Hystérésis du point de consigne du TE-Booster',
         custom_popover_1812_long_description:
           "Délai d'expiration du point de consigne du TE-Booster",
         custom_popover_1813_long_description:
           'Minuteur du point de consigne du TE-Booster',
         custom_popover_1815_long_description: 'Seuil du TE-Booster',
         custom_popover_1816_long_description:
           'Volume enregistré du TE-Booster',
         // Heating PopOver Long Description
         custom_popover_500_long_description:
           'Température de consigne maximale du chauffage',
         custom_popover_501_long_description:
           'Température de consigne minimale du chauffage',
         custom_popover_506_long_description: 'Retour primaire maximal',
         custom_popover_507_long_description:
           'Facteur de compensation Retour primaire',
         custom_popover_508_long_description: 'Différence de consigne Prim/CH',
         custom_popover_510_long_description:
           'Température maximale de chauffage',
         custom_popover_509_long_description: 'Différence minimale Prim/CH',
         custom_popover_514_long_description:
           'Température de consigne du chauffage',
         custom_popover_515_long_description: 'Activation du chauffage',
         // Cooling PopOver Long Description
         custom_popover_600_long_description:
           'Température de consigne de refroidissement',
         custom_popover_601_long_description:
           'Retour primaire maximal du refroidissement',
         custom_popover_602_long_description:
           'Facteur de compensation % de la consigne maximale',
         custom_popover_605_long_description:
           'Température maximale de refroidissement',
         custom_popover_606_long_description:
           'Température de consigne minimale de refroidissement',
         custom_popover_607_long_description:
           'Température de consigne maximale de refroidissement',
         custom_popover_611_long_description: 'Activation du refroidissement',
         // Secondary General PopOver Long Description
         custom_popover_512_long_description: 'Pression minimale du chauffage',
         custom_popover_513_long_description: 'Pression maximale du chauffage',
         custom_popover_603_long_description:
           "Temps d'attente pour passer du chauffage au refroidissement",
         custom_popover_604_long_description:
           "Temps d'attente de la vanne à 6 voies",
         // Changeover WKW PopOver Long Description
         custom_popover_1850_long_description: 'Configuration de 3,5 tuyaux',
         custom_popover_1851_long_description:
           'Seuil de détection du refroidissement',
         custom_popover_1852_long_description:
           'Seuil de détection du chauffage',
         custom_popover_1853_long_description:
           'Point de consigne de chauffage réduit',
         custom_popover_1854_long_description:
           'Point de consigne réduit utilisé',
         custom_popover_1855_long_description: 'Position MCV2 de prédétection',
         custom_popover_1856_long_description: 'Intervalle de détection',
         custom_popover_1857_long_description:
           "Minuterie d'intervalle de détection",
         custom_popover_1858_long_description: 'Délai de prédétection',
         custom_popover_1859_long_description: 'Minuterie de prédétection',
         custom_popover_1860_long_description:
           'Minuterie de commutation de configuration',
         custom_popover_1861_long_description: 'Délai de commutation',
         custom_popover_1862_long_description:
           'Seuil de commutation de configuration',
         custom_popover_1863_long_description: 'Mode de fonction Boost',
         custom_popover_1864_long_description:
           'Minuterie de détection du Boost',
         custom_popover_1865_long_description: 'Délai de détection du Boost',
         custom_popover_1866_long_description: 'Position de Boost maximale',
         // Manual Operation PopOver Long Description
         custom_popover_700_long_description: 'Contrôle manuel activé',
         custom_popover_701_long_description: 'Contrôle manuel VMC-1',
         custom_popover_702_long_description: 'Contrôle manuel VMC-2',
         custom_popover_703_long_description: 'Contrôle manuel Pompe (P1)',
         custom_popover_704_long_description: 'Valve1',
         custom_popover_706_long_description:
           "Sortie d'état de demande de chaleur",
         custom_popover_707_long_description: 'Contrôle manuel VMC-1 [%]',
         custom_popover_708_long_description: 'Contrôle manuel VMC-2 [%]',
         custom_popover_1801_long_description: 'Élément électrique TE-Booster',
         custom_popover_709_long_description: 'Minuterie de contrôle manuel',
         // API keys
         client_single_api_key_approve_api_key_label: 'Clé API',
         client_single_api_key_app_id_label: 'Identifiant App',
         client_single_api_key_approve_api_key_button: 'Approuver le Compte',
         client_single_api_key_suspend_api_key_button:
           "Suspendre l'Application",
         client_single_api_key_unblock_application_button:
           "Débloquer l'Application",
         client_single_api_key_generate_api_key_button: 'Générer une Clé API',
         client_single_api_key_generate_api_key_success:
           'La Clé API a été générée avec succès',
         client_single_api_key_generate_api_limit_error:
           'Désolé, nous ne pouvons pas régénérer une nouvelle Clé API car la limite de régénération est atteinte.',
         client_single_api_key_generate_api_kong_error:
           "Alarme API Kong. Veuillez contacter l'administrateur.",
         client_single_api_application_suspend_success:
           "L'application Kong a été suspendue avec succès",
         client_single_api_application_unblock_success:
           "L'application Kong a été débloquée avec succès",
         client_single_api_application_suspend_error:
           "L'application est déjà suspendue",
         client_single_api_application_unblock_error:
           "L'application est déjà débloquée",
         client_single_api_key_account_pending_approval:
           "Votre compte n'a pas encore été approuvé. Veuillez contacter l'administrateur pour plus de détails.",
         client_single_api_key_account_suspended:
           "Votre compte est suspendu. Veuillez contacter l'administrateur pour plus de détails.",
         // Clients Form
         kong_temporary_password_subject: 'Compte Kong Créé',
         clients_form_password_field: 'Mot de passe',
         clients_password_required_form_error:
           'Le mot de passe doit contenir au moins une lettre majuscule, un chiffre et un caractère spécial',
         // Devices Form
         devices_form_mbus_meters_are_not_connected:
           'Les compteurs MBus ne sont pas connectés.',
         MBUS_METER_HEATING: 'Compteur de chaleur',
         MBUS_METER_COOLING: 'Compteur de froid',
         MBUS_METER_ELECTRICITY: "Compteur d'électricité",
         MBUS_METER_WATER: "Compteur d'eau",
         MBUS_METER_BI_DIRECTIONAL: 'Compteur de chaleur/froid',
         meter_enabled: 'Activé',
         meter_disabled: 'Désactivé',
         devices_mbus_registers_toggle_register_status_success:
           "Le message a été envoyé avec succès à l'appareil.",
         MBUS_METER_SERIAL_NUMBER: 'Numéro de série',
         MBUS_METER_MANUFACTURER: 'Fabricant',
         MBUS_METER_METER_TYPE: 'Type de compteur',
         MBUS_METER_STATUS: 'Statut',
         MBUS_METER_FLOW: 'Débit',
         MBUS_METER_POWER: 'Puissance',
         MBUS_METER_SUPPLY_TEMPERATURE: 'Température de fourniture',
         MBUS_METER_RETURN_TEMPERATURE: 'Température de retour',
         MBUS_METER_HEATING_ENERGY: 'Énergie de chauffage accumulée',
         MBUS_METER_ELECTRICITY_ENERGY: 'Électricité accumulée',
         MBUS_METER_VOLUME: 'Volume accumulé',
         MBUS_METER_COOLING_ENERGY: 'Énergie de refroidissement accumulée',
         MBUS_METER_CURRENT: 'Courant',
         custom_popover_MBUS_METER_SERIAL_NUMBER_short_description:
           'Numéro de série',
         custom_popover_MBUS_METER_MANUFACTURER_short_description: 'Fabricant',
         custom_popover_MBUS_METER_METER_TYPE_short_description:
           'Type de compteur',
         custom_popover_MBUS_METER_STATUS_short_description: 'Statut',
         custom_popover_MBUS_METER_FLOW_short_description: 'Débit',
         custom_popover_MBUS_METER_POWER_short_description: 'Puissance',
         custom_popover_MBUS_METER_SUPPLY_TEMPERATURE_short_description:
           'Température de fourniture',
         custom_popover_MBUS_METER_RETURN_TEMPERATURE_short_description:
           'Température de retour',
         custom_popover_MBUS_METER_HEATING_ENERGY_short_description:
           'Énergie de chauffage accumulée',
         custom_popover_MBUS_METER_ELECTRICITY_ENERGY_short_description:
           'Électricité accumulée',
         custom_popover_MBUS_METER_VOLUME_short_description: 'Volume accumulé',
         custom_popover_MBUS_METER_COOLING_ENERGY_short_description:
           'Énergie de refroidissement accumulée',
         custom_popover_MBUS_METER_CURRENT_short_description: 'Courant',
         // Device Set Logs Per Device
         device_single_device_registers_tab: 'Définir les registres',
         device_single_device_registers_menu_list: JSON.stringify([
           {
             key: 'operating_state',
             value: 'État de fonctionnement',
             permission: 'operating-state-tab-read',
           },
         ]),
         device_status_interval: 'Intervalle',
         device_status_interval_in_seconds: 'Secondes',
         device_single_set_registers_error:
           'Veuillez sélectionner au moins un registre pour continuer.',
         device_single_set_registers_success:
           "Le message a été transmis avec succès à l'appareil.",
         device_single_set_register_form_interval_required_error:
           "L'intervalle (en secondes) est requis",
         device_single_set_register_form_interval_numeric_error:
           "L'intervalle (en secondes) doit être numérique",
         device_single_set_register_form_send_button: 'Envoyer',
         device_single_set_register_form_cancel_button: 'Annuler',
         clients_kong_email_error: "L'adresse e-mail existe déjà dans Kong",
         page_title_appending_title: ' | Gestion des données Fortes',
         project_single_device_registers_tab: 'Définir les registres',
         audits_user: 'Utilisateur',
         audits_system_generated: 'Application',
         device_single_project_set_registers_error:
           "Le message n'est pas transmis car aucun appareil n'est lié au projet",
         audits_user_filter_label: 'Utilisateur',
         audits_event_type_field: "Type d'événement",
         audits_select_event_type_field: "Sélectionner le type d'événement",
         audits_select_event_type_incoming_option: 'Entrant',
         audits_select_event_type_outgoing_option: 'Sortant',
         audits_select_event_type_system_generated_option: 'Application',
         audits_table_loading: 'Chargement des événements',
         appliance_type_reference_table_appliance_name: 'Nom',
         appliance_type_reference_table_appliance_type: "Type d'appareil",
         appliance_type_reference_table_updated_at: 'Mis à jour le',
         sidebar_appliance_type_reference_menu: "Types d'appareils",
         appliance_types_register_form_send_button: 'Enregistrer',
         appliance_types_register_form_cancel_button: 'Annuler',
         appliance_types: "Types d'appareils",
         appliance_types_table_no_record_found: 'Aucun enregistrement trouvé',
         appliance_types_table_row_per_page: 'Lignes par page',
         add_appliance_type: "Ajouter un type d'appareil",
         add_appliance_types_form_header: "Ajouter un type d'appareil",
         edit_appliance_types_form_header: "Modifier un type d'appareil",
         appliance_types_add_new: 'Ajouter un nouveau',
         appliance_type_form_name_label: 'Nom',
         appliance_type_form_type_label: "Type d'appareil",
         appliance_type_form_select_type_label:
           "Sélectionner un type d'appareil",
         appliance_name_form_required_error: 'Le nom est requis',
         appliance_type_form_required_error: "Le type d'appareil est requis",
         add_appliance_type_form_success:
           "L'enregistrement du type d'appareil a été créé avec succès",
         add_appliance_type_form_api_error: 'Erreur du serveur interne',
         edit_appliance_type_form_success:
           "L'enregistrement du type d'appareil a été mis à jour avec succès",
         edit_appliance_type_form_api_error: 'Erreur du serveur interne',
         appliance_type_reference_table_filter_reset_button: 'Réinitialiser',
         appliance_type_reference_table_search: 'Rechercher',
         appliance_type_reference_status_menu_list: JSON.stringify([
           {
             key: 'operating_state',
             value: 'État de fonctionnement',
             permission: 'lecture-onglet-état-de-fonctionnement',
           },
           {
             key: 'settings_hot_water',
             value: 'Réglages eau chaude',
             permission: 'lecture-onglet-réglages-eau-chaude',
           },
           {
             key: 'settings_heating_and_cooling',
             value: 'Réglages chauffage et refroidissement',
             permission: 'lecture-onglet-réglages-chauffage-et-refroidissement',
           },
           {
             key: 'manual_control',
             value: 'Contrôle manuel',
             permission: 'lecture-onglet-contrôle-manuel',
           },
           {
             key: 'firmware_registers',
             value: 'Firmware Registers',
             permission: 'firmware-registers-tab-read',
           },
           {
             key: 'lin_pump_delta_parameters',
             value: 'LIN-Pump DeltaP Parameters',
             permission: 'lin-pump-tab-read',
           },
         ]),
         audits_filter_button: 'Filtres',
         device_single_no_registers_are_available:
           "Aucun registre n'est disponible",
         device_single_device_diagnostics_tab: 'Diagnostics',
         device_single_dp_measurement_back_button: 'Précédent',
         device_single_diagnostic_next_button: 'Suivant',
         device_single_dp_measurement_start_button: 'Démarrer',
         device_single_diagnostict_finish_button: 'Terminer',
         device_single_diagnostic_stop_button: 'Arrêter',
         device_single_dp_measurement_refresh_button: 'Actualiser',
         device_single_dp_measurement_event_logs_title: 'Sortie',
         device_single_dp_measurement_select_mbus_meter_button:
           'Sélectionner un compteur M-Bus',
         device_single_dp_measurement_step_1_title:
           'Calcul de la pression différentielle - Choisissez le débit',
         device_single_dp_measurement_pressure_difference_stepper_1_title:
           'Choisissez le débit',
         device_single_dp_measurement_step_1_flow_1_label:
           'Calcul de la pression différentielle',
         device_single_dp_measurement_step_1_flow_2_label:
           'Eau chaude sanitaire',
         device_single_dp_measurement_pressure_difference_step_2_title:
           "Calcul de la pression différentielle - Explication de l'assistant",
         device_single_dp_measurement_pressure_difference_stepper_2_title:
           "Explication de l'assistant",
         device_single_dp_measurement_pressure_difference_step_2_description:
           "La pression différentielle disponible est toujours un problème dans les réseaux collectifs. Grâce à la puissante combinaison d'AquaHeat aflversets et de la plateforme Fortes Data Management, vous pouvez facilement effectuer un calcul de pression différentielle à n'importe quel point de votre réseau collectif grâce à un module convivial. Cela donne une excellente première indication d'une cause possible. Avec ce diagnostic, nous vous permettons de calculer une indication initiale de la différence de pression disponible. <br /><br /><strong>Requis : Le compteur de chaleur doit être connecté au module de communication Mercury</strong>",
         device_single_dp_measurement_pressure_difference_step_3_title:
           'Calcul de la pression différentielle - Contrôle des bons composants',
         device_single_dp_measurement_pressure_difference_stepper_3_title:
           'Registre de commande manuelle',
         device_single_dp_measurement_step_3_pressure_difference_output_1:
           'Sortie 1 - Activation du contrôle manuel',
         device_single_dp_measurement_pressure_difference_output_2:
           'Sortie 2 - Ouverture de la vanne de contrôle',
         device_single_dp_measurement_pressure_difference_step_3_mbus_meter_title:
           "Sélectionner le compteur M-Bus (pour plusieurs compteurs, il s'agit du compteur d'énergie qui enregistre l'eau potable.)",
         device_single_dp_measurement_pressure_difference_stepper_4_title:
           'Sélectionner le bon compteur M-Bus',
         device_single_dp_measurement_pressure_difference_step_4_flow_label:
           'Débit',
         device_single_dp_measurement_pressure_difference_stepper_5_title:
           'Calcul de la pression différentielle',
         device_single_dp_measurement_pressure_difference_output_3:
           'Sortie 3 - Sélectionner le compteur',
         device_single_dp_measurement_pressure_difference_output_4:
           'Sortie 4 - Calcul de la pression différentielle',
         device_single_dp_measurement_pressure_difference_stepper_6_title:
           'Résultat',
         device_single_dp_measurement_pressure_difference_step_6_description:
           "Votre pression différentielle est OK ! Aucune action supplémentaire n'est nécessaire.",
         device_single_dp_measurement_download_button:
           'Télécharger les résultats',
         device_single_dp_measurement_pressure_difference_step_7_description:
           'Le calcul de la pression différentielle a été effectué avec succès.',
         device_single_general_title: 'Général',
         device_single_hotwater_title: 'Eau chaude sanitaire',
         device_single_dp_measurement_hot_water_flow_1_stepper_1_title:
           'Choisir le débit',
         device_single_dp_measurement_hot_water_flow_1_stepper_2_title:
           "Explication de l'assistant",
         device_single_dp_measurement_hot_water_flow_1_stepper_3_title:
           'Ouvrir le robinet',
         device_single_dp_measurement_hot_water_flow_1_stepper_4_title:
           "Vérification du robinet et de la vanne d'eau chaude",
         device_single_dp_measurement_hot_water_flow_1_stepper_5_title:
           'Compteur M-Bus',
         device_single_dp_measurement_hot_water_flow_1_stepper_6_title:
           "Calcul du débit d'eau chaude",
         device_single_dp_measurement_hot_water_flow_1_stepper_7_title:
           'Résultats',
         device_single_dp_measurement_hot_water_flow_1_step_2_title:
           'Mesure de la pression différentielle - Explication du débit',
         device_single_dp_measurement_hot_water_flow_1_step_2_description:
           'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu proin amet vitae etiam. In mauris habitasse turpis quis tortor, integer magna dictum condimentum. In pellentesque proin eu ut viverra quam. Consequat pharetra proin lacus, ultrices enim. Tincidunt porta tortor lacinia varius mattis pellentesque. In augue sit vitae leo sed. Nibh sed mi bibendum convallis viverra vestibulum pretium commodo. Nibh quam vulputate malesuada sodales. Curabitur nisl leo quis sed vitae cras. Tempor risus, a volutpat consequat eget faucibus nulla fermentum. Ut dignissim proin nulla et congue mattis. Euismod et ipsum quis habitant in enim viverra. Mattis varius quis arcu cras vestibulum nunc mattis consectetur in. Tempus mauris egestas elit malesuada ullamcorper aliquet cras adipiscing ',
         device_single_dp_measurement_hot_water_flow_1_step_3_title:
           'Ouvrir le robinet',
         device_single_dp_measurement_hot_water_flow_1_step_3_faucet_error:
           'Défaut du capteur de débit',
         device_single_dp_measurement_hot_water_flow_1_step_3_faucet_error_one_try_left:
           'Essayez une fois de plus',
         diagnostic_flows_form_open_faucet_title:
           'Le robinet est ouvert par le client',
         diagnostic_flows_form_open_faucet_off_option_description:
           "Le robinet n'est pas ouvert par le client",
         device_single_dp_measurement_hot_water_flow_1_output_1:
           "Sortie 1 - État de l'eau chaude",
         device_single_dp_measurement_hot_water_flow_1_output_2:
           "Sortie 2 - Vanne d'eau chaude (M1)",
         device_single_dp_measurement_hot_water_flow_1_step_3_mbus_meter_title:
           'Sélectionner le compteur M-Bus',
         device_single_dp_measurement_hot_water_flow_1_step_4_flow_label:
           'Débit',
         device_single_dp_measurement_step_4_hot_water_flow_1_output_3:
           'Sortie 3 - Sélectionner le compteur',
         device_single_dp_measurement_hot_water_flow_1_output_4:
           'Sortie 4 - Débit Mbus',
         device_single_dp_measurement_hot_water_flow_1_output_5:
           "Sortie 5 - Calcul du débit d'eau chaude",
         device_single_dp_measurement_hot_water_flow_1_step_7_description:
           'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu proin amet vitae etiam. In mauris habitasse turpis quis tortor, integer magna dictum condimentum. In pellentesque proin eu ut viverra quam. Consequat pharetra proin lacus, ultrices enim. Tincidunt porta tortor lacinia varius mattis pellentesque. In augue sit vitae leo sed. Nibh sed mi bibendum convallis viverra vestibulum pretium commodo. Nibh quam vulputate malesuada sodales. Curabitur nisl leo quis sed vitae cras. Tempor risus, a volutpat consequat eget faucibus nulla fermentum. Ut dignissim proin nulla et congue mattis. Euismod et ipsum quis habitant in enim viverra. Mattis varius quis arcu cras vestibulum nunc mattis consectetur in. Tempus mauris egestas elit malesuada ullamcorper aliquet cras adipiscing ',
         device_single_dp_measurement_hot_water_flow_1_step_8_description:
           "Les diagnostics du débit d'eau chaude - Flow 1 sont terminés",
         device_single_heating_title: 'Chauffage',
         device_single_dp_measurement_step_1_flow_3_label: 'Débit 1',
         device_single_cooling_title: 'Refroidissement',
         device_single_dp_measurement_step_1_flow_4_label: 'Débit 1',
         device_single_temperature_graph_loading_data:
           'Chargement du graphique',
         device_single_temperature_no_graph_data_error:
           "Le graphique n'est pas disponible",
         device_graph_week_filter: 'S',
         device_graph_weeks_filter: 'S',
         device_graph_day_filter: 'J',
         device_graph_days_filter: 'J',
         device_graph_hours_filter: 'H',
         device_single_registers_table_numeric_error:
           'Seules les valeurs numériques sont autorisées',
         device_single_registers_table_min_max_error:
           'La valeur doit être entre min_value et max_value',
         MBUS_METER_TYPE_WATER: 'Eau',
         MBUS_METER_TYPE_ELECTRICITY: 'Électricité',
         MBUS_METER_TYPE_HEATING: 'Chaleur',
         MBUS_METER_TYPE_BIDIRECTIONAL: 'Chaleur/Froid',
         MBUS_METER_TYPE_COOLING: 'Refroidissement',
         UNKNOWN_MANUFACTURER: 'Fabricant inconnu',
         commissioning_form_header: 'Mise en service',
         commissioning_form_serial_number_scan_button: 'Scanner',
         commissioning_form_heat_interface_unit_scan_button:
           "Scanner l'unité d'interface de chauffage",
         commissioning_form_search_field: 'Numéro de série Mercurius',
         sidebar_commissioning_overview: 'Aperçu de la mise en service',
         sidebar_commissioning: 'Mise en service',
         commissioning_form_success:
           "L'appareil a été mis à jour avec succès !",
         commissioning_error_message: 'Appareil non trouvé',
         commissioning_device_submit_button: "Mettre à jour l'appareil",
         swapping_form_header: "Remplacement d'appareil",
         swapping_old_device_title: 'Ancien appareil',
         swapping_new_device_title: 'Nouvel appareil',
         swapping_form_scan_button: 'Scanner',
         swapping_form_search_field: 'Numéro de série Mercurius',
         sidebar_swapping_overview: "Aperçu du remplacement d'appareil",
         sidebar_swapping: 'Remplacement',
         swapping_form_success: "L'appareil a été remplacé avec succès !",
         swapping_old_device_error_message: 'Ancien appareil non trouvé',
         swapping_new_device_error_message: 'Nouvel appareil non trouvé',
         swapping_audit_message: "L'appareil a été remplacé",
         swapping_device_submit_button: 'Remplacer les appareils',
         email_device_swapping_subject: "Remplacement d'appareil",
         email_device_swapping_recipient_name: 'Fortes Data Management',
         email_device_swapping_title: "Remplacement d'appareil",
         email_device_swapping_old_device_title: 'Ancien appareil',
         email_device_swapping_new_device_title: 'Nouvel appareil',
         email_device_swapped_by: 'Appareil remplacé par :',
         swapping_device_unique_error: "L'appareil existe déjà",
         clear_device_form_header: "Effacer l'appareil",
         clear_device_form_scan_button: 'Scanner',
         clear_device_form_search_field: 'Numéro de série Mercurius',
         sidebar_clear_device_overview: "Effacer l'appareil",
         sidebar_clear_device: "Effacer l'appareil",
         clear_device_form_success: "L'appareil a été effacé avec succès !",
         clear_device_error_message: 'Appareil non trouvé',
         clear_device_submit_button: "Effacer l'appareil",
         clear_device_audit_message: "L'appareil a été effacé",
         device_single_swapped_devices_tab: 'Appareils remplacés',
         devices_single_swapped_old_device_name: 'Swapped From (Old)',
         devices_single_swapped_device_old_firmware: 'Old Firmware',
         devices_single_swapped_device_new_firmware: 'New Firmware',
         devices_single_swapped_old_device_type: 'Old Device Type',
         devices_single_swapped_new_device_type: 'New Device Type',
         devices_single_swapped_device_old_box_serial_number:
           'Old Serial number HIU',
         devices_single_swapped_device_new_box_serial_number:
           'Serial number HIU',
         devices_single_swapped_device_old_sim_card_number: 'Old Sim Number',
         devices_single_swapped_device_new_sim_card_number: 'New Sim Number',
         devices_single_swapped_device_created_at: 'Swapped Date',
         devices_single_swapped_device_name_search: 'Recherche',
         devices_single_swapped_new_device_name: 'Swapped To (New)',
         devices_single_swapped_device_table_no_record_found:
           'Aucun enregistrement trouvé',
         devices_single_swapped_device_table_loading: 'Chargement',
         devices_single_swapped_device_table_row_per_page: 'Lignes par page',
         sidebar_swapped_devices_overview: 'Aperçu des appareils remplacés',
         sidebar_swapped_devices: 'Appareils remplacés',
         swapped_devices_form_header: 'Appareils remplacés',
         devices_bulk_edit_registers_form_no_devices_error:
           'Veuillez sélectionner des appareils pour continuer.',
         devices_bulk_edit_firmware_modal_title:
           'Êtes-vous sûr de vouloir effectuer une mise à jour groupée ?',
         devices_bulk_edit_firmware_modal_subtitle:
           'Voulez-vous effectuer une mise à jour groupée de la version du micrologiciel ##firmware_value## pour ##total_devices## appareils ?',
         devices_bulk_edit_registers_modal_title:
           'Êtes-vous sûr de vouloir effectuer une mise à jour groupée ?',
         devices_bulk_edit_registers_modal_subtitle:
           'Voulez-vous effectuer une mise à jour groupée des registres pour ##total_devices## appareils ?',
         devices_bulk_edit_registers_modal_cancel_button: 'Annuler',
         devices_bulk_edit_registers_modal_submit_button: 'Confirmer',
         devices_bulk_edit_firmware_modal_cancel_button: 'Annuler',
         devices_bulk_edit_firmware_modal_submit_button: 'Confirmer',
         devices_bulk_export_button: 'Exporter les appareils',
         projects_bulk_export_button: 'Exporter les projets',
         project_devices_bulk_export_button: 'Exporter les appareils de projet',
         devices_bulk_export_file_name: "Exportation groupée d'appareils",
         projects_bulk_export_file_name: 'Exportation groupée de projets',
         project_devices_bulk_export_file_name:
           "Exportation groupée d'appareils",
         sidebar_reporting_overview: 'Rapports',
         sidebar_bulk_edit_ota_reporting: 'Rapport OTA',
         sidebar_bulk_reporting_registers_table_title: 'Rapport des registres',
         edit_ota_reporting: 'Audit OTA',
         reporting_ota_bulk_export_button: 'Exporter',
         reporting_ota_filter_reset_button: 'Réinitialiser',
         reporting_ota_table_filter_search: 'Recherche',
         reporting_ota_table_updated_at: 'Date',
         reporting_ota_table_total_devices: 'Total des appareils',
         reporting_ota_table_user: 'Utilisateur',
         reporting_ota_table_message: 'Message',
         reporting_ota_table_no_record_found: 'Aucun enregistrement trouvé',
         reporting_ota_table_row_per_page: 'Lignes par page',
         edit_ota_reporting_details: "Détails de l'audit OTA",
         reporting_ota_details_all_tab: 'Tout',
         reporting_ota_details_pending_tab: 'En attente',
         reporting_ota_details_success_tab: 'Succès',
         reporting_ota_details_failure_tab: 'Échec',
         reporting_ota_details_bulk_export_button: 'Exporter',
         reporting_ota_details_filter_reset_button: 'Réinitialiser',
         reporting_ota_details_table_filter_search: 'Recherche',
         reporting_ota_details_message:
           'La version du micrologiciel a été mise à jour en',
         reporting_ota_details_table_created_at: 'Date',
         reporting_ota_details_table_device: 'Appareil',
         reporting_ota_details_table_user: 'Utilisateur',
         reporting_ota_details_table_old_firmware_version:
           'Ancienne version du micrologiciel',
         reporting_ota_details_table_current_firmware_version:
           'Version actuelle du micrologiciel',
         reporting_ota_details_table_current_status: 'Statut',
         reporting_ota_details_table_message: 'Message',
         reporting_ota_details_table_no_record_found:
           'Aucun enregistrement trouvé',
         reporting_ota_details_table_row_per_page: 'Lignes par page',
         reporting_ota_bulk_export_file_name: 'Rapport OTA groupé',
         reporting_ota_details_bulk_export_file_name:
           'Détails du rapport OTA groupé',
         devices_single_swapped_bulk_export_button_file_name:
           "Rapport d'appareils remplacés",
         devices_single_swapped_bulk_export_button: 'Exporter',
         reporting_registers_table_title: "Rapport d'audit des registres",
         reporting_registers_table_created_at: 'Date',
         reporting_registers_table_total_devices: 'Total des appareils',
         reporting_registers_table_user: 'Utilisateur',
         reporting_registers_table_message: 'Message',
         reporting_registers_bulk_export_button: 'Exporter',
         reporting_registers_filter_reset_button: 'Réinitialiser',
         reporting_registers_table_filter_search: 'Recherche',
         reporting_registers_table_no_record_found:
           'Aucun enregistrement trouvé',
         reporting_registers_table_row_per_page: 'Lignes par page',
         reporting_registers_table_bulk_export_file_name:
           'Rapport groupé des registres',
         registers_reporting_details_title: "Détails de l'audit des registres",
         reporting_registers_details_bulk_export_button: 'Exporter',
         reporting_registers_details_filter_reset_button: 'Réinitialiser',
         reporting_registers_details_table_filter_search: 'Recherche',
         reporting_registers_details_table_created_at: 'Date',
         reporting_registers_details_table_device: 'Appareil',
         reporting_registers_details_table_user: 'Utilisateur',
         reporting_registers_details_table_message: 'Message',
         reporting_registers_details_table_failed_message:
           "La version du micrologiciel n'a pas été mise à jour en",
         reporting_registers_details_table_pending_message:
           'Mise à jour de la version du micrologiciel en cours en',
         reporting_registers_details_table_successful_message:
           'La version du micrologiciel a été mise à jour en',
         reporting_registers_details_table_no_record_found:
           'Aucun enregistrement trouvé',
         reporting_registers_details_table_row_per_page: 'Lignes par page',
         reporting_registers_details_bulk_export_file_name:
           'Détails du rapport groupé des registres',
         devices_bulk_edit_ota_form_firmware_field_select_label:
           'Sélectionnez le micrologiciel',
         dashboard_users_overview: 'Aperçu des utilisateurs',
         dashboard_users_title: 'Utilisateurs',
         dashboard_devices_overview: 'Aperçu des appareils',
         dashboard_devices_title: 'Appareils',
         dashboard_commissioning_overview: 'Aperçu de la mise en service',
         dashboard_commissioning_title: 'Mise en service',
         devices_filters: 'Filtres :',
         devices_submit_button: 'Soumettre',
         device_single_device_documentation_tab: 'Docs',
         device_single_documentation_brochure_button: 'Brochure',
         device_single_documentation_installation_manual_button:
           "Manuel d'installation",
         device_single_documentation_dimensional_drawing_button:
           'Dessin dimensionnel',
         device_single_documentation_parts_drawing_button: 'Dessin des pièces',
         device_single_documentation_flow_direction_button: 'Direction du flux',
         device_single_documentation_principle_diagram_button:
           'Schéma de principe',
         device_single_documentation_information_end_user_button:
           "Information à l'utilisateur final",
         device_single_documentation_malfunction_key_button:
           'Clé de dysfonctionnement',
         reporting_ota_failed_message:
           "La version du micrologiciel n'a pas été mise à jour en",
         reporting_ota_pending_message:
           'Mise à jour de la version du micrologiciel en cours en',
         reporting_ota_successful_message:
           'La version du micrologiciel a été mise à jour en',
         ota_pending: 'En attente',
         ota_success: 'Succès',
         ota_failed: 'Échec',
         clear_devices_modal_title: "Effacer l'appareil",
         clear_devices_modal_subtitle:
           'Êtes-vous sûr de vouloir effacer cet appareil avec le numéro de série <strong>##serial_number##</strong> ?',
         clear_devices_modal_cancel_button: 'Annuler',
         clear_devices_modal_submit_button: "Effacer l'appareil",
         sidebar_fortes_roles: 'Rôles',
         sidebar_fortes_permissions: 'Permissions',
         roles_all: 'Tous',
         roles_active: 'Actif',
         roles_inactive: 'Inactif',
         roles_filter_delete_button: 'Supprimer',
         roles_table_identifier: 'Identifiant',
         roles_table_name_en: 'Nom (EN)',
         roles_table_name_nl: 'Nom (NL)',
         roles_table_description_en: 'Description (EN)',
         roles_table_description_nl: 'Description (NL)',
         roles_table_status: 'Statut',
         roles_table_updated_at: 'Mis à jour le',
         roles_filter_search: 'Recherche',
         roles_no_record_found: 'Aucun enregistrement trouvé',
         roles_table_row_per_page: 'Lignes par page',
         roles_bulk_no_record_is_selected_error_message:
           'Veuillez sélectionner des enregistrements pour la désactivation groupée.',
         roles_deactivated_message: 'Le rôle a été désactivé avec succès',
         roles_activated_message: 'Le rôle a été activé avec succès',
         roles_bulk_deactivated_message:
           '##ROLES_COUNT## rôles ont été désactivés avec succès',
         roles_title: 'Rôles',
         roles_add_new: 'Ajouter un nouveau',
         roles_bread_crumb_main_title: 'Rôles',
         add_roles_bread_crumb_first_link: 'Ajouter un rôle',
         edit_roles_bread_crumb_first_link: 'Modifier le rôle',
         add_roles_form_header: 'Ajouter un rôle',
         edit_roles_form_header: 'Modifier le rôle',
         roles_form_role_identifier_field: 'Identifiant',
         roles_identifier_required_form_error: "L'identifiant est requis",
         roles_form_role_name_en_field: 'Nom (EN)',
         roles_form_role_name_nl_field: 'Nom (NL)',
         roles_name_en_required_form_error: 'Le nom (EN) est requis',
         roles_name_nl_required_form_error: 'Le nom (NL) est requis',
         roles_form_description_en_field: 'Description (EN)',
         roles_form_description_nl_field: 'Description (NL)',
         roles_form_api_error: 'Erreur interne du serveur',
         roles_form_unqiue_role_name_error: "L'identifiant doit être unique",
         roles_form_api_forbidden:
           "L'utilisateur n'a pas les autorisations pour créer un rôle",
         roles_add_form_success: 'Le rôle a été créé avec succès',
         roles_edit_form_success: 'Le rôle a été mis à jour avec succès',
         roles_form_add_role_button: 'Ajouter un rôle',
         roles_form_edit_role_button: 'Modifier le rôle',
         roles_form_cancel_button: 'Annuler',
         roles_form_permissions_title: 'Permissions',
         sidebar_fortes_modules: 'Modules',
         modules_all: 'Tous',
         modules_active: 'Actif',
         modules_inactive: 'Inactif',
         modules_filter_delete_button: 'Supprimer',
         modules_table_identifier: 'Identifiant',
         modules_table_name_en: 'Nom (EN)',
         modules_table_name_nl: 'Nom (NL)',
         modules_table_description_en: 'Description (EN)',
         modules_table_description_nl: 'Description (NL)',
         modules_table_status: 'Statut',
         modules_table_updated_at: 'Mis à jour le',
         modules_filter_search: 'Recherche',
         modules_no_record_found: 'Aucun enregistrement trouvé',
         modules_table_row_per_page: 'Lignes par page',
         modules_bulk_no_record_is_selected_error_message:
           'Veuillez sélectionner des enregistrements pour la désactivation en masse.',
         modules_deactivated_message: 'Le module a été désactivé avec succès',
         modules_activated_message: 'Le module a été activé avec succès',
         modules_bulk_deactivated_message:
           '##MODULES_COUNT## modules ont été désactivés avec succès',
         modules_title: 'Modules',
         modules_add_new: 'Ajouter un nouveau',
         modules_bread_crumb_main_title: 'Modules',
         add_modules_bread_crumb_first_link: 'Ajouter un module',
         edit_modules_bread_crumb_first_link: 'Modifier le module',
         add_modules_form_header: 'Ajouter un module',
         edit_modules_form_header: 'Modifier le module',
         modules_form_module_identifier_field: 'Identifiant',
         modules_identifier_required_form_error: "L'identifiant est requis",
         modules_form_module_name_en_field: 'Nom (EN)',
         modules_form_module_name_nl_field: 'Nom (NL)',
         modules_name_en_required_form_error: 'Le nom (EN) est requis',
         modules_name_nl_required_form_error: 'Le nom (NL) est requis',
         modules_form_description_en_field: 'Description (EN)',
         modules_form_description_nl_field: 'Description (NL)',
         modules_form_api_error: 'Erreur interne du serveur',
         modules_form_unqiue_module_name_error:
           "L'identifiant doit être unique",
         modules_form_api_forbidden:
           "L'utilisateur n'a pas les autorisations pour créer un module",
         modules_add_form_success: 'Le module a été créé avec succès',
         modules_edit_form_success: 'Le module a été mis à jour avec succès',
         modules_form_add_module_button: 'Ajouter un module',
         modules_form_edit_module_button: 'Modifier le module',
         modules_form_cancel_button: 'Annuler',
         permissions_all: 'Tous',
         permissions_active: 'Actif',
         permissions_inactive: 'Inactif',
         permissions_filter_delete_button: 'Supprimer',
         permissions_table_identifier: 'Identifiant',
         permissions_table_module_name: 'Module',
         permissions_table_name_en: 'Nom (EN)',
         permissions_table_name_nl: 'Nom (NL)',
         permissions_table_description_en: 'Description (EN)',
         permissions_table_description_nl: 'Description (NL)',
         permissions_table_status: 'Statut',
         permissions_filter_search: 'Recherche',
         permissions_no_record_found: 'Aucun enregistrement trouvé',
         permissions_table_row_per_page: 'Lignes par page',
         permissions_bulk_no_record_is_selected_error_message:
           'Veuillez sélectionner des enregistrements pour la désactivation en masse.',
         permissions_deactivated_message:
           'La permission a été désactivée avec succès',
         permissions_activated_message:
           'La permission a été activée avec succès',
         permissions_bulk_deactivated_message:
           '##PERMISSIONS_COUNT## permissions ont été désactivées avec succès',
         permissions_title: 'Permissions',
         permissions_add_new: 'Ajouter une nouvelle',
         permissions_bread_crumb_main_title: 'Permissions',
         add_permissions_bread_crumb_first_link: 'Ajouter une permission',
         edit_permissions_bread_crumb_first_link: 'Modifier la permission',
         edit_permissions_form_header: 'Modifier la permission',
         add_permissions_form_header: 'Ajouter une permission',
         permissions_form_permission_identifier_field: 'Identifiant',
         permissions_form_permission_module_field: 'Module',
         permissions_form_permission_select_module_field:
           'Sélectionner un module',
         permissions_module_required_form_error: 'Le module est requis',
         permissions_identifier_required_form_error: "L'identifiant est requis",
         permissions_form_permission_name_en_field: 'Nom (EN)',
         permissions_form_permission_name_nl_field: 'Nom (NL)',
         permissions_form_permission_sub_module_field: 'Sous-module',
         permissions_form_permission_select_sub_module_field:
           'Sélectionner un sous-module',
         permissions_sub_module_required_form_error:
           'Le sous-module est requis',
         permissions_name_required_form_error: 'Le nom est requis',
         permissions_form_description_en_field: 'Description (EN)',
         permissions_form_description_nl_field: 'Description (NL)',
         permissions_form_api_error: 'Erreur interne du serveur',
         permissions_form_unqiue_permission_name_error:
           "L'identifiant doit être unique",
         permissions_edit_form_success:
           'La permission a été mise à jour avec succès!',
         permissions_form_api_forbidden:
           "L'utilisateur n'a pas les autorisations pour créer une permission",
         permissions_add_form_success: 'La permission a été créée avec succès',
         permissions_form_add_permission_button: 'Ajouter une permission',
         permissions_form_edit_permission_button: 'Modifier la permission',
         permissions_form_cancel_button: 'Annuler',
         permissions_read: 'Lecture',
         permissions_create: 'Créer',
         permissions_update: 'Mettre à jour',
         permissions_delete: 'Supprimer',
         permissions_status: 'Basculer le statut',
         permissions_get_all: 'Tout obtenir',
         permissions_get_by_id: 'Obtenir par ID',
         permissions_bulk_deactivate: 'Désactiver en masse',
         permissions_form_title: 'Permissions',
         duplicate_roles_form_header: 'Dupliquer un rôle',
         duplicate_roles_bread_crumb_first_link: 'Dupliquer un rôle',
         roles_duplicate_form_success: 'Le rôle a été dupliqué avec succès',
         roles_filter_duplicate_button: 'Dupliquer un rôle',
         roles_pre_identifier_required_form_error:
           'Le pré-identifiant est requis',
         roles_form_pre_identifier_field: 'Pré-identifiant',
         roles_form_pre_identifier_select: 'Sélectionner un pré-identifiant',
         duplicate_roles_identifier_message:
           '<ul style="margin: "0", padding-left: 15px"> <li>Pour un nouveau rôle client, commencez toujours l\'identifiant par client_</li> <li>Pour un nouveau rôle de sous-client, commencez toujours l\'identifiant par service_client_</li> <li>Pour un nouveau rôle Fortes, commencez toujours l\'identifiant par fortes_</li> </ul>',
         devices_single_device_counters_title: 'Compteurs du dispositif',
         devices_single_device_counters_offline_counter: 'Compteur hors ligne',
         devices_single_device_counters_online_counter: 'Compteur en ligne',
         devices_single_device_counters_ota_fail_counter:
           "Compteur d'échec OTA",
         devices_single_device_counters_ota_update_counter:
           'Compteur de mises à jour OTA',
         devices_single_device_counters_mbus_error_counter:
           "Compteur d'erreurs MBus",
         devices_single_device_counters_modbus_error_counter:
           "Compteur d'erreurs Modbus",
         devices_single_device_docs_directory: 'Répertoires',
         device_single_documentation_no_documents_found:
           'Aucun document trouvé',
         reporting_registers_details_table_registers_pending:
           'Registres en attente',
         reporting_registers_details_table_registers_updated_fail:
           'Registres mis à jour en échec',
         reporting_registers_details_table_registers_updated_successful:
           'Registres mis à jour avec succès',
         reporting_registers_details_table_status: 'Statut',
         reporting_ota_message: 'Mettre à jour la version du micrologiciel à',
         devices_bulk_edit_registers_form_fix_register_values_error:
           'Veuillez corriger les erreurs dans toutes les onglets',
         login_permission_error:
           "Veuillez obtenir les permissions appropriées auprès de l'administrateur de Fortes",
         monitoring_title: 'Surveillance',
         monitoring_vm_title: 'Machine virtuelle',
         monitoring_ram_title: 'RAM',
         monitoring_cpu_title: 'UC',
         monitoring_disk_title: 'Disque',
         monitoring_restarts_title: 'Redémarrages',
         monitoring_uptime_title: 'Temps de fonctionnement',
         monitoring_services_title: 'Services',
         monitoring_service_table_service_name: 'Nom',
         monitoring_service_table_service_status: 'Statut',
         devices_form_service_client_field: 'Client de service',
         sidebar_kong_users: 'Utilisateurs du client Kong',
         kong_users_title: 'Utilisateurs du client Kong',
         kong_users_table_name: 'Nom',
         kong_users_table_email: 'Email',
         kong_users_table_client: 'Client',
         kong_users_table_updated_at: 'Mis à jour le',
         kong_users_bread_crumb_main_title: 'Utilisateurs du client Kong',
         add_kong_users_bread_crumb_first_link:
           'Ajouter un utilisateur du client Kong',
         add_kong_users_form_header: 'Ajouter un utilisateur du client Kong',
         kong_users_form_name_field: 'Nom',
         kong_users_form_email_field: 'Adresse e-mail',
         kong_users_form_client_field: 'Client',
         kong_users_form_password_field: 'Mot de passe',
         kong_users_name_required_form_error: 'Le nom est requis',
         kong_users_email_valid_form_error:
           'Doit être une adresse e-mail valide',
         kong_users_email_required_form_error: "L'e-mail est requis",
         kong_users_client_required_form_error: 'Le client est requis',
         kong_users_password_required_form_error:
           'Le mot de passe doit contenir au moins 8 caractères avec au moins une lettre majuscule, au moins un chiffre et au moins un caractère spécial.',
         kong_users_no_record_found: 'Aucun enregistrement trouvé',
         kong_users_table_row_per_page: 'Lignes par page',
         kong_users_add_new: 'Ajouter un utilisateur du client Kong',
         kong_users_filter_search: 'Rechercher',
         kong_user_single_first_bread_crumb: 'Utilisateurs du client Kong',
         kong_user_single_second_bread_crumb:
           'Voir les utilisateurs du client Kong',
         kong_user_single_apis_tab: 'Clés API',
         kong_user_single_edit_button_label: 'Modifier',
         kong_user_single_user_label: 'Utilisateur',
         kong_user_single_email_label: 'Email',
         kong_user_single_client_label: 'Client',
         edit_kong_users_form_header: 'Modifier un utilisateur du client Kong',
         edit_kong_users_bread_crumb_first_link:
           'Modifier un utilisateur du client Kong',
         device_single_temperature_start_date: 'Date de début',
         device_single_temperature_end_date: 'Date de fin',
         device_single_temperature_start_date_error:
           'La date de début doit être inférieure ou égale à la date de fin',
         sidebar_kong_admins: 'Administrateurs Kong',
         kong_user_admins_title: 'Administrateurs Kong',
         kong_user_admins_table_name: 'Nom',
         kong_user_admins_table_email: 'Email',
         kong_user_admins_table_updated_at: 'Mis à jour le',
         kong_user_admins_bread_crumb_main_title: 'Administrateurs Kong',
         add_kong_user_admins_bread_crumb_first_link:
           'Ajouter un administrateur Kong',
         add_kong_user_admins_form_header: 'Ajouter un administrateur Kong',
         kong_user_admins_form_name_field: 'Nom',
         kong_user_admins_form_email_field: 'Adresse e-mail',
         kong_user_admins_form_client_field: 'Administrateur',
         kong_user_admins_form_password_field: 'Mot de passe',
         kong_user_admins_name_required_form_error: 'Le nom est requis',
         kong_user_admins_email_valid_form_error:
           'Doit être une adresse e-mail valide',
         kong_user_admins_email_required_form_error: "L'e-mail est requis",
         kong_user_admins_password_required_form_error:
           'Le mot de passe doit contenir au moins 8 caractères avec au moins une lettre majuscule, au moins un chiffre et au moins un caractère spécial.',
         kong_user_admins_no_record_found: 'Aucun enregistrement trouvé',
         kong_user_admins_table_row_per_page: 'Lignes par page',
         kong_user_admins_add_new: 'Ajouter un administrateur Kong',
         kong_user_admins_filter_search: 'Rechercher',
         kong_user_admin_single_first_bread_crumb: 'Administrateurs Kong',
         kong_user_admin_single_second_bread_crumb:
           'Voir les administrateurs Kong',
         kong_user_admin_single_apis_tab: 'Clés API',
         kong_user_admin_single_edit_button_label: 'Modifier',
         kong_user_admin_single_user_label: 'Utilisateur',
         kong_user_admin_single_email_label: 'E-mail',
         edit_kong_user_admins_form_header:
           "Modifier l'utilisateur administrateur Kong",
         edit_kong_user_admins_bread_crumb_first_link:
           "Modifier l'utilisateur administrateur Kong",
         projects_project_order_number_required_form_error:
           'Le numéro de commande du projet est requis',
         projects_form_project_order_number_field:
           'Numéro de commande du projet',
         client_error_single_device_address: "Adresse d'installation",
         navbar_notification_mark_all_as_read: 'Tout marquer comme lu',
         navbar_notification_view_all: 'Tout afficher',
         notifications_title: 'Notifications',
         notifications_all: 'Tout',
         notifications_unread: 'Non lu',
         notifications_read: 'Lu',
         notifications_table_title: 'Titre (EN)',
         notifications_table_description: 'Description (EN)',
         notifications_table_notification_type: 'Type de notification',
         notifications_table_notification_category: 'Catégorie de notification',
         notifications_table_date: 'Date',
         notifications_filter_search: 'Recherche',
         notifications_no_record_found: 'Aucun enregistrement trouvé',
         notifications_table_row_per_page: 'Lignes par page',
         add_notifications_form_header: 'Ajouter une notification',
         notifications_title_en_required_form_error: 'Le titre (EN) est requis',
         notifications_title_nl_required_form_error: 'Le titre (NL) est requis',
         notifications_description_en_required_form_error:
           'La description (EN) est requise',
         notifications_description_nl_required_form_error:
           'La description (NL) est requise',
         notifications_form_notification_type_field: 'Type de notification',
         notifications_notification_type_required_form_error:
           'Le type de notification est requis',
         notifications_form_notification_category_field:
           'Catégorie de notification',
         notifications_notification_category_required_form_error:
           'La catégorie de notification est requise',
         notifications_form_title_en_field: 'Titre (EN)',
         notifications_form_title_nl_field: 'Titre (NL)',
         notifications_form_start_date_field: 'Date de début',
         notifications_form_end_date_field: 'Date de fin',
         notifications_form_description_en_field: 'Description (EN)',
         notifications_form_description_nl_field: 'Description (NL)',
         notifications_form_add_button: 'Ajouter une notification',
         notifications_form_edit_button: 'Modifier la notification',
         notifications_form_cancel_button: 'Annuler',
         notifications_add_form_success:
           'La notification a été ajoutée avec succès',
         notifications_form_api_error: 'Erreur interne du serveur',
         notification_type_information: 'Information',
         notification_type_warning: 'Avertissement',
         notification_category_simple: 'Simple',
         notification_category_timebased: 'Basé sur le temps',
         edit_notifications_form_header: 'Modifier la notification',
         sidebar_notification_menu: 'Notifications',
         pop_over_close_button: 'Fermer',
         docs_user_type_end_user: 'Utilisateur final',
         docs_user_type_installer: 'Installateur',
         devices_single_device_docs_no_directory_found:
           'Aucun répertoire trouvé',
         device_single_status_tab: 'Visualisations',
         device_single_status_picture_tab: 'Image',
         device_single_status_principle_tab: 'Principe',
         device_single_status_table_loading: 'Chargement en cours...',
         device_single_status_mbus_export_button: 'Exporter',
         device_single_status_mbus_date_range_filter_label: 'Plage de dates',
         device_single_status_mbus_date_export_label: 'Date',
         device_single_status_mbus_time_export_label: 'Heure',
         device_single_status_mbus_port_export_label: 'Port',
         device_single_status_mbus_meter_connected_at_export_label:
           'Compteur connecté à',
         device_single_status_mbus_meter_status_export_label:
           'Statut du compteur',
         device_single_status_mbus_meter_type_export_label: 'Type de compteur',
         device_single_status_mbus_select_meter_type_export_label:
           'Sélectionner le type de compteur',
         device_single_status_mbus_select_meter_type_error:
           'Le type de compteur est manquant',
         device_single_status_mbus_export_internal_server_error:
           "Erreur interne du serveur lors de l'exportation",
         device_single_status_mbus_export_no_data_found_error:
           'Aucun enregistrement trouvé',
         sidebar_diagnostic_formulas: 'Formules de Diagnostic',
         diagnostic_formulas_all: 'Tout',
         diagnostic_formulas_active: 'Actif',
         diagnostic_formulas_inactive: 'Inactif',
         diagnostic_formulas_filter_delete_button: 'Supprimer',
         diagnostic_formulas_table_identifier: 'Identifiant',
         diagnostic_formulas_table_name_en: 'Nom (EN)',
         diagnostic_formulas_table_name_nl: 'Nom (NL)',
         diagnostic_formulas_table_description_en: 'Description (EN)',
         diagnostic_formulas_table_description_nl: 'Description (NL)',
         diagnostic_formulas_table_formula: 'Formule',
         diagnostic_formulas_table_status: 'Statut',
         diagnostic_formulas_table_updated_at: 'Mis à jour le',
         diagnostic_formulas_filter_search: 'Recherche',
         diagnostic_formulas_no_record_found: 'Aucun enregistrement trouvé',
         diagnostic_formulas_table_row_per_page: 'Lignes par page',
         diagnostic_formulas_bulk_no_record_is_selected_error_message:
           'Veuillez sélectionner des enregistrements pour la désactivation en masse.',
         diagnostic_formulas_deactivated_message:
           'Le diagnostic est désactivé avec succès',
         diagnostic_formulas_activated_message:
           'Le diagnostic est activé avec succès',
         diagnostic_formulas_bulk_deactivated_message:
           '##DIAGNOSTICS_COUNT## diagnostics sont désactivés avec succès',
         diagnostic_formulas_title: 'Formules de Diagnostics',
         diagnostic_formulas_add_new: 'Ajouter Nouveau',
         diagnostic_formulas_bread_crumb_main_title: 'Formules de Diagnostic',
         add_diagnostic_formulas_bread_crumb_first_link:
           'Ajouter des Formules de Diagnostic',
         edit_diagnostic_formulas_bread_crumb_first_link:
           'Modifier des Formules de Diagnostic',
         add_diagnostic_formulas_form_header:
           'Ajouter des Formules de Diagnostic',
         edit_diagnostic_formulas_form_header:
           'Modifier des Formules de Diagnostic',
         diagnostic_formulas_form_diagnostic_formulas_identifier_field:
           'Identifiant',
         diagnostic_formulas_identifier_required_form_error:
           "L'identifiant est requis",
         diagnostic_formulas_form_diagnostic_formulas_name_en_field: 'Nom (EN)',
         diagnostic_formulas_form_diagnostic_formulas_name_nl_field: 'Nom (NL)',
         diagnostic_formulas_name_en_required_form_error:
           'Le nom (EN) est requis',
         diagnostic_formulas_name_nl_required_form_error:
           'Le nom (NL) est requis',
         diagnostic_formulas_formula_required_form_error:
           'La formule est requise',
         diagnostic_formulas_form_description_en_field: 'Description (EN)',
         diagnostic_formulas_form_description_nl_field: 'Description (NL)',
         diagnostic_formulas_form_forumla_field: 'Formule',
         diagnostic_formulas_form_api_error: 'Erreur interne du serveur',
         diagnostic_formulas_form_unqiue_diagnostic_formulas_name_error:
           "L'identifiant doit être unique",
         diagnostic_formulas_form_api_forbidden:
           "L'utilisateur n'a pas les autorisations nécessaires pour créer des formules de diagnostic",
         diagnostic_formulas_add_form_success:
           'Le diagnostic est créé avec succès',
         diagnostic_formulas_edit_form_success:
           'Le diagnostic est mis à jour avec succès',
         diagnostic_formulas_form_add_diagnostic_formulas_button:
           'Ajouter le Diagnostic',
         diagnostic_formulas_form_edit_diagnostic_formulas_button:
           'Modifier le Diagnostic',
         diagnostic_formulas_form_cancel_button: 'Annuler',
         sidebar_diagnostic_categories: 'Catégories de Diagnostic',
         diagnostic_categories_all: 'Tout',
         diagnostic_categories_active: 'Actif',
         diagnostic_categories_inactive: 'Inactif',
         diagnostic_categories_filter_delete_button: 'Supprimer',
         diagnostic_categories_table_identifier: 'Identifiant',
         diagnostic_categories_table_name_en: 'Nom (EN)',
         diagnostic_categories_table_name_nl: 'Nom (NL)',
         diagnostic_categories_table_description_en: 'Description (EN)',
         diagnostic_categories_table_description_nl: 'Description (NL)',
         diagnostic_categories_table_status: 'Statut',
         diagnostic_categories_table_updated_at: 'Mis à jour le',
         diagnostic_categories_filter_search: 'Recherche',
         diagnostic_categories_no_record_found: 'Aucun enregistrement trouvé',
         diagnostic_categories_table_row_per_page: 'Lignes par page',
         diagnostic_categories_bulk_no_record_is_selected_error_message:
           'Veuillez sélectionner des enregistrements pour la désactivation en masse.',
         diagnostic_categories_deactivated_message:
           'La catégorie est désactivée avec succès',
         diagnostic_categories_activated_message:
           'La catégorie est activée avec succès',
         diagnostic_categories_bulk_deactivated_message:
           '##DIAGNOSTICS_COUNT## catégories sont désactivées avec succès',
         diagnostic_categories_title: 'Catégories de Diagnostic',
         diagnostic_categories_add_new: 'Ajouter Nouveau',
         diagnostic_categories_bread_crumb_main_title:
           'Catégories de Diagnostic',
         add_diagnostic_categories_bread_crumb_first_link:
           'Ajouter une Catégorie de Diagnostic',
         edit_diagnostic_categories_bread_crumb_first_link:
           'Modifier une Catégorie de Diagnostic',
         add_diagnostic_categories_form_header:
           'Ajouter une Catégorie de Diagnostic',
         edit_diagnostic_categories_form_header:
           'Modifier une Catégorie de Diagnostic',
         diagnostic_categories_form_diagnostic_categories_identifier_field:
           'Identifiant',
         diagnostic_categories_identifier_required_form_error:
           "L'identifiant est requis",
         diagnostic_categories_form_diagnostic_categories_name_en_field:
           'Nom (EN)',
         diagnostic_categories_form_diagnostic_categories_name_nl_field:
           'Nom (NL)',
         diagnostic_categories_name_en_required_form_error:
           'Le nom (EN) est requis',
         diagnostic_categories_name_nl_required_form_error:
           'Le nom (NL) est requis',
         diagnostic_categories_form_description_en_field: 'Description (EN)',
         diagnostic_categories_form_description_nl_field: 'Description (NL)',
         diagnostic_categories_form_api_error: 'Erreur interne du serveur',
         diagnostic_categories_form_unqiue_diagnostic_categories_name_error:
           "L'identifiant doit être unique",
         diagnostic_categories_form_api_forbidden:
           "L'utilisateur n'a pas les autorisations nécessaires pour créer des catégories de diagnostic",
         diagnostic_categories_add_form_success:
           'La catégorie est créée avec succès',
         diagnostic_categories_edit_form_success:
           'La catégorie est mise à jour avec succès',
         diagnostic_categories_form_add_diagnostic_categories_button:
           'Ajouter une Catégorie',
         diagnostic_categories_form_edit_diagnostic_categories_button:
           'Modifier une Catégorie',
         diagnostic_categories_form_cancel_button: 'Annuler',
         sidebar_diagnostics_overview: 'Diagnostics',
         sidebar_firmware_menu: 'Firmwares',
         firmwares_all: 'Tout',
         firmwares_active: 'Actif',
         firmwares_inactive: 'Inactif',
         firmwares_table_identifier: 'Identifiant',
         firmwares_table_name_en: 'Nom (EN)',
         firmwares_table_name_nl: 'Nom (NL)',
         firmwares_table_firmware: 'Micrologiciel',
         firmwares_table_status: 'Statut',
         firmwares_table_updated_at: 'Mis à jour le',
         firmwares_filter_search: 'Recherche',
         firmwares_no_record_found: 'Aucun enregistrement trouvé',
         firmwares_table_row_per_page: 'Lignes par page',
         firmwares_bulk_no_record_is_selected_error_message:
           'Veuillez sélectionner des enregistrements pour la désactivation en masse.',
         firmwares_deactivated_message:
           'Le micrologiciel est désactivé avec succès',
         firmwares_activated_message: 'Le micrologiciel est activé avec succès',
         firmwares_title: 'Micrologiciels',
         firmwares_add_new: 'Ajouter Nouveau',
         firmwares_bread_crumb_main_title: 'Micrologiciels',
         add_firmwares_bread_crumb_first_link: 'Ajouter un Micrologiciel',
         edit_firmwares_bread_crumb_first_link: 'Modifier un Micrologiciel',
         add_firmwares_form_header: 'Ajouter un Micrologiciel',
         edit_firmwares_form_header: 'Modifier un Micrologiciel',
         firmwares_form_firmware_identifier_field: 'Identifiant',
         firmwares_identifier_required_form_error: "L'identifiant est requis",
         firmwares_form_firmware_name_en_field: 'Nom (EN)',
         firmwares_form_firmware_name_nl_field: 'Nom (NL)',
         firmwares_form_firmware_firmware_field: 'Micrologiciel',
         firmwares_name_en_required_form_error: 'Le nom (EN) est requis',
         firmwares_name_nl_required_form_error: 'Le nom (NL) est requis',
         firmwares_form_description_en_field: 'Description (EN)',
         firmwares_form_description_nl_field: 'Description (NL)',
         firmwares_form_api_error: 'Erreur interne du serveur',
         firmwares_form_unqiue_firmware_name_error:
           "L'identifiant doit être unique",
         firmwares_form_api_forbidden:
           "L'utilisateur n'a pas les autorisations nécessaires pour créer un micrologiciel",
         firmwares_add_form_success: 'Le micrologiciel est créé avec succès',
         firmwares_edit_form_success:
           'Le micrologiciel est mis à jour avec succès',
         firmwares_form_edit_firmware_button: 'Modifier le Micrologiciel',
         firmwares_form_cancel_button: 'Annuler',
         diagnostic_flows_all: 'Tout',
         diagnostic_flows_active: 'Actif',
         diagnostic_flows_inactive: 'Inactif',
         diagnostic_flows_filter_delete_button: 'Supprimer',
         diagnostic_flows_table_identifier: 'Identifiant',
         diagnostic_flows_table_category: 'Catégorie',
         diagnostic_flows_table_name_en: 'Nom (EN)',
         diagnostic_flows_table_name_nl: 'Nom (NL)',
         diagnostic_flows_table_description_en: 'Description (EN)',
         diagnostic_flows_table_description_nl: 'Description (NL)',
         diagnostic_flows_table_status: 'Statut',
         diagnostic_flows_table_updated_at: 'Mis à jour le',
         diagnostic_flows_filter_search: 'Recherche',
         diagnostic_flows_no_record_found: 'Aucun enregistrement trouvé',
         diagnostic_flows_table_row_per_page: 'Lignes par page',
         diagnostic_flows_bulk_no_record_is_selected_error_message:
           'Veuillez sélectionner des enregistrements pour la désactivation en masse.',
         diagnostic_flows_deactivated_message:
           'Le flux est désactivé avec succès',
         diagnostic_flows_activated_message: 'Le flux est activé avec succès',
         diagnostic_flows_bulk_deactivated_message:
           '##DIAGNOSTICS_COUNT## flux sont désactivés avec succès',
         diagnostic_flows_title: 'Flux de Diagnostic',
         diagnostic_flows_add_new: 'Ajouter Nouveau',
         diagnostic_flows_bread_crumb_main_title: 'Flux de Diagnostic',
         add_diagnostic_flows_bread_crumb_first_link:
           'Ajouter un Flux de Diagnostic',
         edit_diagnostic_flows_bread_crumb_first_link:
           'Modifier un Flux de Diagnostic',
         add_diagnostic_flows_form_header: 'Ajouter un Flux de Diagnostic',
         edit_diagnostic_flows_form_header: 'Modifier un Flux de Diagnostic',
         diagnostic_flows_form_diagnostic_flows_identifier_field: 'Identifiant',
         diagnostic_flows_identifier_required_form_error:
           "L'identifiant est requis",
         diagnostic_flows_form_diagnostic_flows_name_en_field: 'Nom (EN)',
         diagnostic_flows_form_diagnostic_flows_name_nl_field: 'Nom (NL)',
         diagnostic_flows_name_en_required_form_error: 'Le nom (EN) est requis',
         diagnostic_flows_name_nl_required_form_error: 'Le nom (NL) est requis',
         diagnostic_flows_category_required_form_error:
           'La catégorie est requise',
         diagnostic_flows_form_description_en_field: 'Description (EN)',
         diagnostic_flows_form_description_nl_field: 'Description (NL)',
         diagnostic_flows_form_flow_condition_error_field:
           'La condition doit avoir des règles vraies et fausses',
         diagnostic_flows_form_flow_modal_title_field: 'Êtes-vous sûr ?',
         diagnostic_flows_form_flow_modal_subtitle_field:
           'Vous voulez enregistrer les modifications du flux dans le navigateur ?',
         diagnostic_flows_form_flow_modal_cancel_button_field: 'Annuler',
         diagnostic_flows_form_flow_modal_save_button_field:
           'Enregistrer dans le navigateur',
         diagnostic_flows_form_flow_modal_save_success_message:
           'Le flux est enregistré avec succès dans le navigateur',
         diagnostic_flows_form_featured_image_field: 'Image en Vedette',
         diagnostic_flows_form_upload_featured_image_label:
           "Télécharger l'Image en Vedette",
         diagnostic_flows_form_thumbnail_field: 'Miniature',
         diagnostic_flows_form_upload_thumbnail_image_label:
           "Télécharger l'Image Miniature",
         diagnostic_flows_form_api_error: 'Erreur interne du serveur',
         diagnostic_flows_form_unqiue_diagnostic_flows_name_error:
           "L'identifiant doit être unique",
         diagnostic_flows_form_api_forbidden:
           "L'utilisateur n'a pas les autorisations nécessaires pour créer des flux de diagnostic",
         diagnostic_flows_add_form_success:
           'Le Flux de Diagnostic est créé avec succès',
         diagnostic_flows_edit_form_success:
           'Le Flux de Diagnostic est mis à jour avec succès',
         diagnostic_flows_form_add_diagnostic_flows_button: 'Ajouter un Flux',
         diagnostic_flows_form_edit_diagnostic_flows_button: 'Modifier le Flux',
         diagnostic_flows_form_cancel_button: 'Annuler',
         audits_select_event_type_error_option: 'Erreur',
         diagnostic_flows_form_flow_field: 'Flux',
         diagnostic_flows_form_flow_condition_button: 'Condition',
         diagnostic_flows_form_flow_timer_button: 'Minuteur',
         diagnostic_flows_form_flow_normal_node_button: 'Noeud',
         diagnostic_flows_form_flow_download_image_button:
           "Télécharger l'Image",
         diagnostic_flows_form_flow_start_button: 'Démarrer',
         diagnostic_flows_form_flow_end_button: 'Terminer',
         devices_bulk_export_mbus_historic_data_button:
           'Télécharger les données Mbus',
         devices_bulk_export_mbus_historic_data_file_name:
           'Données Historiques Mbus',
         devices_bulk_mbus_download_title:
           'Télécharger les Données Historiques Mbus',
         devices_bulk_bulk_mbus_download_form_date_range: 'Plage de Dates :',
         devices_bulk_bulk_mbus_download_form_submit_button:
           'Télécharger les Données Mbus',
         devices_bulk_bulk_mbus_download_form_cancel_button: 'Annuler',
         devices_bulk_mbus_download_form_success:
           'Les Données Historiques Mbus sont envoyées par email à ##EMAIL## avec succès !',
         devices_bulk_mbus_download_form_api_error: 'Erreur interne du serveur',
         devices_bulk_mbus_download_no_devices_error: '',
         devices_bulk_mbus_download_form_no_devices_error:
           'Veuillez sélectionner des appareils pour continuer.',
         devices_bulk_bulk_mbus_download_modal_title: 'Êtes-vous sûr ?',
         devices_bulk_mbus_download_modal_subtitle:
           'Voulez-vous lancer un téléchargement en masse des données historiques Mbus ?',
         devices_bulk_mbus_download_modal_cancel_button: 'Annuler',
         devices_bulk_mbus_download_modal_submit_button: 'Confirmer',
         projects_bulk_export_mbus_historic_data_button:
           'Télécharger les données Mbus',
         projects_bulk_export_mbus_historic_data_file_name:
           'Données Historiques Mbus',
         projects_bulk_mbus_download_title:
           'Télécharger les Données Historiques Mbus',
         projects_bulk_bulk_mbus_download_form_date_range: 'Plage de Dates :',
         projects_bulk_bulk_mbus_download_form_data_export_type:
           "Type d'Export de Données",
         projects_bulk_bulk_mbus_download_form_data_export_type_combined:
           'Combiné',
         projects_bulk_bulk_mbus_download_form_data_export_type_daily:
           'Journalier',
         projects_bulk_bulk_mbus_download_form_data_export_type_normal:
           'Normal',
         projects_bulk_bulk_mbus_download_form_submit_button:
           'Télécharger les Données Mbus',
         projects_bulk_bulk_mbus_download_form_cancel_button: 'Annuler',
         projects_bulk_mbus_download_form_success:
           'Les Données Historiques Mbus sont envoyées par email à ##EMAIL## avec succès !',
         projects_bulk_mbus_download_form_api_error:
           'Erreur interne du serveur',
         projects_bulk_mbus_download_no_projects_error: '',
         projects_bulk_mbus_download_form_no_projects_error:
           'Veuillez sélectionner des projets pour continuer.',
         projects_bulk_bulk_mbus_download_modal_title: 'Êtes-vous sûr ?',
         projects_bulk_mbus_download_modal_subtitle:
           'Voulez-vous lancer un téléchargement en masse des données historiques Mbus ?',
         projects_bulk_mbus_download_modal_cancel_button: 'Annuler',
         projects_bulk_mbus_download_modal_submit_button: 'Confirmer',
         projects_bulk_mbus_selected_projects: 'Projets Sélectionnés',
         sidebar_diagnostic_flows: 'Flux de Diagnostic',
         diagnostic_flows_form_diagnostic_flows_category_field:
           'Catégorie de Flux de Diagnostic',
         diagnostics_send_message_modal_registers_label: 'Registres',
         diagnostics_send_message_modal_operator_label: 'Opérateur',
         diagnostics_send_message_modal_value_label: 'Valeur',
         diagnostics_send_message_modal_registers_label_default_option:
           'Sélectionner le Registre',
         diagnostics_send_message_modal_save_button: 'Enregistrer',
         diagnostics_send_message_modal_cancel_button: 'Annuler',
         diagnostics_condition_modal_sensor_type_label: 'Type de Capteur',
         diagnostics_condition_modal_modbus_label: 'Capteur Modbus',
         diagnostics_condition_modal_mbus_label: 'Capteur Mbus',
         diagnostics_condition_modal_formula_output_label:
           'Résultat de la Formule',
         diagnostics_condition_modal_meter_type_label: 'Type de Compteur',
         diagnostics_condition_modal_meter_type_label_default_option:
           'Sélectionner le Type de Compteur',
         diagnostics_condition_modal_operator_label: 'Opérateur',
         diagnostics_condition_modal_operator_option_1: 'Inférieur',
         diagnostics_condition_modal_operator_option_2: 'Inférieur ou égal à',
         diagnostics_condition_modal_operator_option_3: 'Égal à',
         diagnostics_condition_modal_operator_option_4: 'Supérieur',
         diagnostic_flows_menu_information_form_description_nl:
           'Description (NL)',
         diagnostic_flows_menu_information_form_cancel_button: 'Annuler',
         diagnostic_flows_menu_information_form_save_button: 'Enregistrer',
         diagnostic_flows_menu_condition_form_description_en:
           'Description (EN)',
         diagnostic_flows_menu_condition_form_description_nl:
           'Description (NL)',
         diagnostic_flows_menu_condition_form_register_label: 'Registre',
         diagnostic_flows_menu_condition_form_operator_label: 'Opérateur',
         diagnostic_flows_menu_condition_form_value_label: 'Valeur',
         diagnostic_flows_menu_condition_form_timer_label: 'Minuteur',
         diagnostic_flows_menu_condition_form_retries_label: 'Réessais',
         diagnostic_flows_menu_condition_form_delay_label: 'Délai',
         diagnostic_flows_menu_condition_form_times_label: 'fois',
         diagnostic_flows_menu_condition_form_second_label: 'sec',
         diagnostic_flows_menu_condition_form_cancel_button: 'Annuler',
         diagnostic_flows_menu_condition_form_save_button: 'Enregistrer',
         diagnostic_flows_menu_modbus_form_description_en: 'Description (EN)',
         diagnostic_flows_menu_modbus_form_description_nl: 'Description (NL)',
         diagnostic_flows_menu_modbus_form_register_label: 'Registre',
         diagnostic_flows_menu_modbus_form_operator_label: 'Opérateur',
         diagnostic_flows_menu_modbus_form_value_label: 'Valeur',
         diagnostic_flows_menu_modbus_form_cancel_button: 'Annuler',
         diagnostic_flows_menu_modbus_form_save_button: 'Enregistrer',
         diagnostic_flows_menu_message_form_description_en: 'Description (EN)',
         diagnostic_flows_menu_message_form_description_nl: 'Description (NL)',
         diagnostic_flows_menu_message_form_message_label: 'Message',
         diagnostic_flows_menu_message_form_cancel_button: 'Annuler',
         diagnostic_flows_menu_message_form_save_button: 'Enregistrer',
         diagnostic_flows_menu_timer_form_description_en: 'Description (EN)',
         diagnostic_flows_menu_timer_form_description_nl: 'Description (NL)',
         diagnostic_flows_menu_timer_form_timer_label: 'Minuteur',
         diagnostic_flows_menu_timer_form_delay_label: 'Délai',
         diagnostic_flows_menu_timer_form_times_label: 'fois',
         diagnostic_flows_menu_timer_form_second_label: 'sec',
         diagnostic_flows_menu_timer_form_cancel_button: 'Annuler',
         diagnostic_flows_menu_timer_form_save_button: 'Enregistrer',
         diagnostic_flows_menu_formula_form_description_en: 'Description (EN)',
         diagnostic_flows_menu_formula_form_description_nl: 'Description (NL)',
         diagnostic_flows_menu_formula_form_formula_label: 'Formule',
         diagnostic_flows_menu_formula_form_formula_placeholder:
           'Veuillez choisir @ pour sélectionner les Registres Modbus ou Mbus',
         diagnostic_flows_menu_formula_form_cancel_button: 'Annuler',
         diagnostic_flows_menu_formula_form_save_button: 'Enregistrer',
         diagnostic_flows_menu_user_interaction_form_description_en:
           'Description (EN)',
         diagnostic_flows_menu_user_interaction_form_description_nl:
           'Description (NL)',
         diagnostic_flows_menu_user_interaction_form_operation_type:
           "Type d'Opération",
         diagnostic_flows_menu_user_interaction_form_operation_type_default_option:
           "Sélectionner le Type d'Opération",
         diagnostic_flows_menu_user_interaction_form_operation_type_option_choose_mbus_meter:
           'Sélectionner le Compteur Mbus',
         diagnostic_flows_menu_user_interaction_form_operation_type_option_choose_faucet:
           'Sélectionner le Registre de Robinet',
         diagnostic_flows_menu_user_interaction_form_field_type_option_select_field:
           'Sélectionner le Type de Champ',
         diagnostic_flows_menu_user_interaction_form_field_type:
           'Type de Champ',
         diagnostic_flows_menu_user_interaction_form_field_type_default_option:
           'Sélectionner le Type de Champ',
         diagnostic_flows_menu_user_interaction_form_field_type_option_checkbox:
           'Case à cocher',
         diagnostic_flows_menu_user_interaction_form_field_type_option_radio_button:
           'Bouton Radio',
         diagnostic_flows_menu_user_interaction_form_field_type_option_text_field:
           'Champ de Texte',
         diagnostic_flows_menu_user_interaction_form_cancel_button: 'Annuler',
         diagnostic_flows_menu_user_interaction_form_save_button: 'Enregistrer',
         extra_white_space_form_error:
           'Les espaces supplémentaires ne sont pas autorisés',
         diagnostic_flows_form_incomplete_flow_error:
           'Veuillez vérifier les arêtes et les nœuds de couleur noire avec animation rouge',
         diagnostic_flows_menu_information: 'Information',
         diagnostic_flows_menu_modbus: 'Modbus',
         diagnostic_flows_menu_message: 'Message',
         diagnostic_flows_menu_condition: 'Condition',
         diagnostic_flows_menu_user_interaction: 'Interaction Utilisateur',
         diagnostic_flows_menu_steps: 'Page',
         diagnostic_flows_menu_timer: 'Minuteur',
         diagnostic_flows_menu_formula: 'Formule',
         diagnostic_flows_form_user_interaction_operation_type:
           "Type d'Opération",
         diagnostic_flows_form_user_interaction_operation_type_default_option:
           "Sélectionner le Type d'Opération",
         diagnostic_flows_form_user_interaction_operation_type_option_choose_mbus_meter:
           'Sélectionner le Compteur Mbus',
         diagnostic_flows_form_user_interaction_operation_type_option_choose_faucet:
           'Sélectionner le Registre de Robinet',
         diagnostic_flows_form_user_interaction_field_type_option_select_field:
           'Sélectionner le Type de Champ',
         diagnostic_flows_form_user_interaction_field_type: 'Type de Champ',
         diagnostic_flows_form_user_interaction_field_type_default_option:
           'Sélectionner le Type de Champ',
         diagnostic_flows_form_user_interaction_field_type_option_checkbox:
           'Case à cocher',
         diagnostic_flows_form_user_interaction_field_type_option_radio_button:
           'Bouton Radio',
         diagnostic_flows_form_user_interaction_field_type_option_text_field:
           'Champ de Texte',
         diagnostic_flows_form_user_interaction_description_en:
           'Description (EN)',
         diagnostic_flows_form_user_interaction_description_nl:
           'Description (NL)',
         diagnostic_flows_form_steps_label_en: 'Description (EN)',
         diagnostic_flows_form_steps_label_nl: 'Description (NL)',
         diagnostic_formulas_form_diagnostic_formulas_retries_field: 'Réessais',
         diagnostic_formulas_form_diagnostic_formulas_delay_field: 'Délai',
         diagnostic_formulas_form_diagnostic_formulas_unit_field:
           'Unité de Formule',
         diagnostic_formulas_form_forumla_field_placeholder:
           'Veuillez choisir @ pour sélectionner les Registres Modbus ou Mbus',
         device_single_diagnostic_flow_missing_pages_error:
           "##SELECTED_FLOW## n'a pas de pages. Veuillez ajouter des pages dans le flux pour continuer.",
         device_single_stepper_choose_flow_title: 'Choisissez le flux',
         device_single_stepper_choose_explanation_of_flow_wizard_title:
           "Explication de l'assistant",
         device_single_stepper_result_title: 'Résultat',
         devices_bulk_download_form_data_type: 'Type de Données',
         devices_bulk_download_form_export_type: "Type d'Exportation",
         devices_bulk_download_form_data_type_daily: 'Journalier',
         devices_bulk_download_form_data_type_hourly: 'Horaire',
         devices_bulk_download_form_export_type_combined: 'Combiné',
         devices_bulk_download_form_export_type_separated: 'Séparé',
         diagnostic_flows_form_main_stopped_text:
           "Le flux a été arrêté par l'utilisateur",
         diagnostic_execution_title: 'Exécutions de Diagnostic',
         diagnostic_execution_table_created_at: 'Créé le',
         diagnostic_execution_table_device: 'Appareil',
         diagnostic_execution_table_user: 'Utilisateur',
         diagnostic_execution_table_flow: 'Flux',
         diagnostic_execution_table_status: 'Statut',
         diagnostic_execution_table_filter_search: 'Recherche',
         diagnostic_executions_tab_all: 'Tous',
         diagnostic_executions_tab_completed: 'Terminé',
         diagnostic_executions_tab_in_progress: 'En cours',
         diagnostic_executions_tab_stopped: 'Arrêté',
         diagnostic_executions_tab_error: 'Erreur',
         diagnostic_executions_table_no_record_found:
           'Aucun enregistrement trouvé',
         diagnostic_executions_table_row_per_page: 'Lignes par page',
         diagnostic_flows_menu_result: 'Résultat',
         diagnostic_flows_menu_result_form_description_en: 'Description (EN)',
         diagnostic_flows_menu_result_form_description_nl: 'Description (NL)',
         diagnostic_flows_menu_result_form_cancel_button: 'Annuler',
         diagnostic_flows_menu_result_form_save_button: 'Enregistrer',
         diagnostic_flows_menu_page_form_cancel_button: 'Annuler',
         diagnostic_flows_menu_page_form_save_button: 'Enregistrer',
         diagnostic_flows_menu_information_form_description_en:
           'Description (EN)',
         sidebar_diagnostic_execution_title: 'Exécutions de Diagnostic',
         diagnostic_flow_execution_single_first_bread_crumb:
           'Exécutions de Diagnostic',
         diagnostic_flow_execution_single_second_bread_crumb:
           'Voir Exécution de Diagnostic',
         diagnostic_flow_execution_single_output_tab: 'Résultat',
         diagnostic_flow_execution_single_device_name: 'Appareil',
         diagnostic_flow_execution_single_flow: 'Flux',
         diagnostic_flow_execution_single_user: 'Utilisateur',
         diagnostic_flow_execution_single_status: 'Statut',
         diagnostic_flow_execution_single_created_at: 'Créé le',
         diagnostic_flow_execution_single_bulk_export_file_name:
           'Exécutions de Diagnostic en Bloc',
         diagnostic_flow_execution_single_bulk_export_date: 'Date',
         diagnostic_flow_execution_single_bulk_export_time: 'Heure',
         diagnostic_flow_execution_single_bulk_export_device_name:
           "Nom de l'Appareil",
         diagnostic_flow_execution_single_bulk_export_device_serial_number_mercurius:
           'Numéro de Série Mercurius',
         diagnostic_flow_execution_single_bulk_export_device_user_full_name:
           'Utilisateur',
         diagnostic_flow_execution_single_bulk_export_device_flow_name_en:
           'Nom du Flux (EN)',
         diagnostic_flow_execution_single_bulk_export_device_flow_name_nl:
           'Nom du Flux (NL)',
         diagnostic_flow_execution_single_bulk_export_device_status: 'Statut',
         diagnostic_flows_form_main_flow_already_running_error_text:
           "Un flux est déjà en cours d'exécution sur cet appareil. Les exécutions de flux multiples ne sont pas autorisées.",
         diagnostic_flows_form_open_faucet_on_option: 'Activé',
         diagnostic_flows_form_open_faucet_off_option:
           "Désactivé (Le flux passera en mode d'erreur)",
         diagnostic_flows_form_mbus_meters_error:
           "L'appareil ne possède pas les compteurs Mbus nécessaires au flux.",
         diagnostic_flows_result_title: 'Résultat',
         duplicate_diagnostic_flows_form_header:
           'Dupliquer le Flux de Diagnostic',
         duplicate_diagnostic_flows_bread_crumb_first_link:
           'Dupliquer le Flux de Diagnostic',
         diagnostic_flows_form_duplicate_diagnostic_flows_button: 'Dupliquer',
         diagnostic_flows_duplicate_form_success:
           'Le Flux de Diagnostic a été dupliqué avec succès',
         diagnostic_flows_filter_duplicate_button: 'Dupliquer le Flux',
         diagnostic_flows_menu_result_form_id: 'Id',
         audits_street_number_filter_label: 'Rue',
         audits_house_number_filter_label: 'Numéro de Maison',
         diagnostic_execution_counter_title:
           "Compteurs d'Exécution de Diagnostic",
         diagnostic_execution_counter_table_id: 'Id',
         diagnostic_execution_counter_table_counter: 'Compteurs',
         diagnostic_execution_counter_table_flow: 'Flux',
         diagnostic_execution_counter_table_result: 'Résultat',
         diagnostic_execution_counter_table_filter_search: 'Rechercher',
         diagnostic_execution_counter_table_no_record_found:
           'Aucun enregistrement trouvé',
         diagnostic_execution_counter_table_row_per_page: 'Lignes par Page',
         sidebar_diagnostic_flow_execution_counter:
           'Compteurs de Flux de Diagnostic',
         device_single_firmware_hiu_label: 'Micrologiciel MTA',
         device_single_firmware_mercurius_label: 'Micrologiciel Mercurius',
         custom_popover_105_long_description:
           "Description Longue du Registre d'Alarme",
         settings_menu_title: 'Paramètres',
         settings_menu_clients_title: 'Clients',
         settings_menu_admins_title: 'Administrateurs',
         settings_menu_kong_admins_title: 'Administrateurs Kong',
         settings_menu_kong_clients_title: 'Clients Kong',
         settings_menu_diagnostics_title: 'Diagnostics',
         settings_menu_formulas_title: 'Formules',
         settings_menu_flows_title: 'Flux',
         settings_menu_categories_title: 'Catégories',
         settings_menu_firmwares_title: 'Micrologiciels',
         settings_menu_appliance_types_title: "Types d'Appareil",
         settings_menu_notifications_title: 'Notifications',
         settings_menu_roles_title: 'Rôles',
         settings_menu_modules_title: 'Modules',
         settings_menu_permissions_title: 'Permissions',
         settings_menu_go_back_button: 'Revenir en Arrière',
         audits_device_name_filter_label: "Nom de l'Appareil",
         device_single_documentation_parts_button: 'Pièces',
         device_single_documentation_lab_vision_button: 'Labvision',
         device_single_documentation_manuals_button: 'Manuels',
         device_single_documentation_incident_button: "Clé d'Incident",
         navbar_avg_proof_switch: 'Interrupteur de Confidentialité',
         clients_filter_bulk_delete_button: 'Supprimer',
         clients_bulk_delete_no_clients_with_zero_devices_is_selected_error_message:
           'Veuillez sélectionner au moins un enregistrement avec 0 appareil',
         clients_bulk_delete_clients_with_devices_count_is_selected_error_message:
           'Veuillez sélectionner uniquement les enregistrements qui ont 0 appareil',
         projects_filter_bulk_delete_button: 'Supprimer',
         projects_bulk_delete_no_projects_with_zero_devices_is_selected_error_message:
           'Veuillez sélectionner au moins un enregistrement avec 0 appareil',
         projects_bulk_delete_projects_with_devices_count_is_selected_error_message:
           'Veuillez sélectionner uniquement les enregistrements qui ont 0 appareil',
         projects_bulk_deleted_message:
           '{{ PROJECTS_COUNT }} projets sont supprimés avec succès',
         projects_delete_modal_title: 'Êtes-vous sûr?',
         projects_delete_modal_subtitle:
           'Voulez-vous supprimer les enregistrements?',
         projects_delete_modal_cancel_button: 'Annuler',
         projects_delete_modal_delete_button: 'Supprimer',
         users_delete_modal_title: 'Êtes-vous sûr?',
         users_delete_modal_subtitle:
           'Voulez-vous supprimer les enregistrements?',
         users_delete_modal_cancel_button: 'Annuler',
         users_delete_modal_delete_button: 'Supprimer',
         users_bulk_delete_no_user_is_selected_error_message:
           'Veuillez sélectionner des enregistrements à supprimer',
         users_bulk_deleted_message:
           '{{ USERS_COUNT }} utilisateurs sont supprimés avec succès',
         service_client_single_filter_bulk_delete_button: 'Supprimer',
         service_client_single_no_user_selected_for_deleted_message:
           'Veuillez sélectionner des enregistrements à supprimer',
         admins_bulk_deleted_message:
           '{{ USERS_COUNT }} administrateurs sont supprimés avec succès',
         admins_no_user_selected_for_deleted_message:
           'Veuillez sélectionner des enregistrements à supprimer',
         admins_filter_bulk_delete_button: 'Supprimer',
         kong_admins_bulk_deleted_message:
           '{{ USERS_COUNT }} Kong Admins are deleted successfully',
         audits_message_type_label: 'Type de Message',
         audit_bulk_export_file_name: "Fichier d'Audits",
         registers_reporting_details_all_tab: 'Tous',
         registers_reporting_details_pending_tab: 'En Attente',
         registers_reporting_details_success_tab: 'Succès',
         registers_reporting_details_failure_tab: 'Échec',
         devices_form_is_service_device_field: 'Appareil de Service',
         service_portal_login_in_correct_qr_code:
           "Le Numéro de Série de l'Appareil est incorrect",
         service_portal_login_in_correct_credentials:
           "Les identifiants de l'appareil sont incorrects. Veuillez contacter l'administrateur Fortes.",
         service_portal_login_not_a_registered_service_device:
           "L'appareil avec le Numéro de Série {{ SERIAL_NUMBER }} n'est pas enregistré.",
         devices_unprovisioned: 'Non installé',
         sidebar_unprovisioned_devices: 'Appareils non installés',
         dashboard_unprovisioned: 'NON INSTALLÉ',
         device_single_documentation_warmwater_button: 'Erreur eau chaude',
         device_single_documentation_verwarming_button:
           'Erreur chauffage central',
         service_portal_login_in_serial_number_scan_button:
           'Scanner le Numéro de Série',
         service_portal_login_in_heat_interface_unit_scan_button:
           "Scanner l'Unité d'Interface Thermique",
         service_portal_login_in_serial_number_scanned_message:
           'Le Numéro de Série est scanné',
         service_portal_login_in_heat_interface_unit_scanned_message:
           "L'Unité d'Interface Thermique est scannée",
         swapping_device_missing_new_device_error:
           "Le nouvel appareil n'est pas importé dans la base de données Mercurius",
         device_single_dashboard_mbus_title: 'MBus',
         device_single_dashboard_tab: 'Tableau de Bord',
         device_single_offline_detailed_message: 'L\'appareil est "Hors Ligne"',
         device_single_online_detailed_message:
           'L\'appareil est "En Ligne", tout fonctionne correctement',
         device_single_error_detailed_message:
           'L\'appareil est en mode "Erreur"',
         device_single_status_documents_link: "Documents de l'Appareil",
         email_device_delete_subscription_title:
           "Fortes Data Management - Supprimer l'Abonnement",
         email_device_delete_subscription_api_status_title:
           "Réponse de l'API Maxitel :",
         email_device_delete_subscription_type_swapped_device_message:
           "L'abonnement de l'appareil est supprimé dans le module d'échange d'appareils",
         email_device_delete_subscription_type_clear_device_message:
           "L'abonnement de l'appareil est supprimé dans le module de réinitialisation de l'appareil",
         devices_form_subscription_id_field: "ID de l'Abonnement",
         device_single_rss_sim_status: 'Statut SIM',
         device_monitoring_error_list_table_title: 'Historic Alarm List',
         device_monitoring_error_list_table_device: 'Appareil',
         device_monitoring_error_list_table_alarm_code: "Code d'Alarme",
         device_monitoring_error_list_table_start_date: 'Date de Début',
         device_monitoring_error_list_table_end_date: 'Date de Fin',
         device_monitoring_data_consumed_list_table_title:
           'Consommation de Données',
         device_monitoring_data_consumed_list_table_device: 'Appareil',
         device_monitoring_data_consumed_list_table_data_usage:
           'Utilisation des Données',
         device_monitoring_data_consumed_list_table_date: 'Date',
         device_monitoring_ota_history_list_table_title: 'Historique OTA',
         device_monitoring_ota_history_list_table_device: 'Appareil',
         device_monitoring_ota_history_list_table_status: 'Statut',
         device_monitoring_ota_history_list_table_date: 'Date',
         device_monitoring_device_status_history_title:
           "Historique de l'État de l'Appareil",
         device_monitoring_device_status_history_hr: 'Hr',
         device_monitoring_device_status_history_no_graph_data_error:
           'Le graphique est indisponible',
         device_monitoring_device_status_history_graph_loading_data:
           'Chargement du graphique',
         device_monitoring_firmware_history_title: 'Historique des Firmware',
         device_monitoring_device_firmware_history_graph_loading_data:
           'Chargement du diagramme en barres',
         device_monitoring_device_firmware_history_no_graph_data_error:
           'Le diagramme en barres est indisponible',
         sidebar_devices_monitoring: 'Surveillance des Appareils',
         device_monitoring_projects_counter_title: 'Compteur de Projets',
         device_monitoring_device_projects_counter_graph_loading_data:
           'Chargement du diagramme en barres',
         device_monitoring_device_projects_counter_no_graph_data_error:
           'Le diagramme en barres est indisponible',
         device_monitoring_users_counter_title: "Compteur d'Utilisateurs",
         device_monitoring_device_users_counter_graph_loading_data:
           'Chargement du diagramme en barres',
         device_monitoring_device_users_counter_no_graph_data_error:
           'Le diagramme en barres est indisponible',
         device_monitoring_sim_counter_title: 'Compteur de Données SIM',
         device_monitoring_sim_counter_exceeded_data_title: 'Dépassé',
         device_monitoring_sim_counter_in_package_data_title:
           'Dans la Limite du Forfait',
         device_monitoring_device_sim_counter_graph_loading_data:
           'Chargement du diagramme en barres',
         device_monitoring_device_sim_counter_no_graph_data_error:
           'Le diagramme en barres est indisponible',
         service_portal_login_in_dont_have_hiu_qr_code_checkbox_field:
           "Je n'ai pas de Code QR MTA",
         service_portal_login_hiu_autocomplete: "Unité d'Interface Thermique",
         device_monitoring_device_error_counters_title:
           'Historic Alarm Counters',
         device_monitoring_device_error_counters_error: 'Aucune donnée trouvée',
         device_monitoring_device_error_counters_no_graph_data_error:
           'Le diagramme circulaire est indisponible',
         device_monitoring_date_range_field: 'Plage de Dates',
         reporting_ota_details_retries_tab: 'Tentatives',
         device_monitoring_single_page_title: 'Surveillance des Appareils',
         device_monitoring_ota_history_list_table_fail_counter: 'Tentatives',
         device_monitoring_ota_history_list_table_user: 'Utilisateur',
         device_monitoring_ota_history_list_table_message: 'Message',
         device_monitoring_ota_history_list_table_old_firmware_version:
           'Ancienne Version du Firmware',
         device_monitoring_project_list_table_title: 'Projets',
         device_monitoring_firmware_list_table_title: 'Firmwares',
         device_monitoring_firmware_list_table_firmware_version: 'Firmware',
         device_monitoring_firmware_list_table_device: 'Appareil',
         device_monitoring_firmware_list_table_project: 'Projet',
         device_monitoring_firmware_list_table_saved_at: 'Date',
         monitoring_users_list_table_title: 'Utilisateurs',
         monitoring_kong_users_list_table_title: 'Utilisateurs Kong',
         monitoring_kong_users_filter_kong_admin: 'Administrateur Kong',
         monitoring_kong_users_filter_kong_client: 'Client Kong',
         client_single_users_table_role: 'Rôle',
         device_monitoring_device_status_list_table_title: "État de l'Appareil",
         navbar_languages_english: 'Anglais',
         navbar_languages_dutch: 'Néerlandais',
         navbar_languages_german: 'Allemand',
         device_single_device_settings_tab: 'Paramètres v2',
         device_single_device_settings_title: "Paramètres de l'Appareil v2",
         device_single_device_settings_secondary_device_type_field:
           "Type d'Appareil Secondaire",
         device_single_device_settings_base_topic_field: 'Sujet de Base',
         device_single_device_settings_baud_rate_uart_field:
           'Taux de Baud UART',
         device_single_device_settings_select_baud_rate_uart_field:
           'Sélectionner le Taux de Baud UART',
         device_single_device_settings_modbus_error_register_address_field:
           "Adresse de Registre d'Erreur Modbus",
         device_single_device_settings_modbus_error_register_value_field:
           "Valeur Attendue de Registre d'Erreur Modbus",
         device_single_device_settings_reboot_device_v2: 'Redémarrer',
         device_single_device_settings_send_button_v2: 'Envoyer',
         device_single_device_settings_secondary_device_type_message_forwarded:
           'Device Secondary Device Type message is forwarded to device',
         device_single_device_settings_reboot_message_forwarded:
           'Device Reboot message is forwarded to device',
         device_single_device_settings_base_topic_message_forwarded:
           'Device Base Topic message is forwarded to device',
         device_single_device_settings_baud_rate_uart_message_forwarded:
           'Device Baud Rate UART message is forwarded to device',
         device_single_device_settings_modbus_error_register_address_message_forwarded:
           'Device Modbus alarm register address message is forwarded to device',
         device_single_device_settings_modbus_expected_error_register_value_message_forwarded:
           'Device Modbus expected alarm register value message is forwarded to device',
         device_single_device_settings_secondary_device_type_error:
           "Le Type d'Appareil Secondaire doit être entre 1 et 254",
         device_single_device_settings_base_topic_error:
           'La longueur du Sujet de Base doit être entre 5 et 50',
         device_single_device_settings_baud_rate_uart_error:
           'Veuillez sélectionner une option pour le Taux de Baud UART',
         device_single_device_settings_modbus_error_register_address_error:
           "L'adresse du registre d'erreur Modbus doit être entre 0 et 65535",
         device_single_device_settings_modbus_error_register_value_error:
           "La valeur attendue du registre d'erreur Modbus doit être entre 0 et 65535",
         device_monitoring_device_error_counters_loading_data:
           'Chargement du diagramme circulaire',
         diagnostic_formulas_form_diagnostic_formulas_name_de_field: 'Nom (DE)',
         diagnostic_formulas_name_de_required_form_error:
           'Le Nom (DE) est requis',
         diagnostic_formulas_form_description_de_field: 'Description (DE)',
         diagnostic_flows_form_diagnostic_flows_name_de_field: 'Nom (DE)',
         diagnostic_flows_name_de_required_form_error: 'Le Nom (DE) est requis',
         diagnostic_flows_form_description_de_field: 'Description (DE)',
         diagnostic_categories_form_diagnostic_categories_name_de_field:
           'Nom (DE)',
         diagnostic_categories_name_de_required_form_error:
           'Le Nom (DE) est requis',
         diagnostic_categories_form_description_de_field: 'Description (DE)',
         diagnostic_categories_table_name_de: 'Nom (DE)',
         diagnostic_flows_table_name_de: 'Nom (DE)',
         diagnostic_formulas_table_name_de: 'Nom (DE)',
         modules_form_module_name_de_field: 'Nom (DE)',
         modules_name_de_required_form_error: 'Le Nom (DE) est requis',
         modules_form_description_de_field: 'Description (DE)',
         modules_table_name_de: 'Nom (DE)',
         modules_table_description_de: 'Description (DE)',
         roles_form_role_name_de_field: 'Nom (DE)',
         roles_name_de_required_form_error: 'Le Nom (DE) est requis',
         roles_form_description_de_field: 'Description (DE)',
         roles_table_name_de: 'Nom (DE)',
         roles_table_description_de: 'Description (DE)',
         permissions_form_permission_name_de_field: 'Nom (DE)',
         permissions_form_description_de_field: 'Description (DE)',
         permissions_table_name_de: 'Nom (DE)',
         permissions_table_description_de: 'Description (DE)',
         notifications_form_title_de_field: 'Titre (DE)',
         notifications_form_description_de_field: 'Description (DE)',
         firmwares_name_de_required_form_error: 'Nom (DE)',
         firmwares_form_firmware_name_de_field: 'Le Nom (DE) est requis',
         navbar_languages_danish: 'Danois',
         firmwares_name_dk_required_form_error: 'Nom (DK)',
         firmwares_form_firmware_name_dk_field: 'Le Nom (DK) est requis',
         diagnostic_formulas_form_diagnostic_formulas_name_dk_field: 'Nom (DK)',
         diagnostic_formulas_name_dk_required_form_error:
           'Le Nom (DK) est requis',
         diagnostic_formulas_form_description_dk_field: 'Description (DK)',
         diagnostic_flows_form_diagnostic_flows_name_dk_field: 'Nom (DK)',
         diagnostic_flows_name_dk_required_form_error: 'Le Nom (DK) est requis',
         diagnostic_flows_form_description_dk_field: 'Description (DK)',
         diagnostic_categories_form_diagnostic_categories_name_dk_field:
           'Nom (DK)',
         diagnostic_categories_name_dk_required_form_error:
           'Le Nom (DK) est requis',
         diagnostic_categories_form_description_dk_field: 'Description (DK)',
         diagnostic_categories_table_name_dk: 'Nom (DK)',
         diagnostic_flows_table_name_dk: 'Nom (DK)',
         diagnostic_formulas_table_name_dk: 'Nom (DK)',
         modules_form_module_name_dk_field: 'Nom (DK)',
         modules_name_dk_required_form_error: 'Le Nom (DK) est requis',
         modules_form_description_dk_field: 'Description (DK)',
         modules_table_name_dk: 'Nom (DK)',
         modules_table_description_dk: 'Description (DK)',
         roles_form_role_name_dk_field: 'Nom (DK)',
         roles_name_dk_required_form_error: 'Le Nom (DK) est requis',
         roles_form_description_dk_field: 'Description (DK)',
         roles_table_name_dk: 'Nom (DK)',
         roles_table_description_dk: 'Description (DK)',
         permissions_table_name_dk: 'Nom (DK)',
         permissions_table_description_dk: 'Description (DK)',
         notifications_form_title_dk_field: 'Titre (DK)',
         notifications_form_description_dk_field: 'Description (DK)',
         device_monitoring_data_consumed_list_table_project: 'Projet',
         project_single_device_list_search_mbus_registers_by_project:
           'Recherche de Registres Mbus',
         project_single_fetch_mbus_registers_by_project_success_message:
           'Le message est transféré aux Appareils du Projet ##PROJECT_NAME## avec succès',
         project_single_fetch_mbus_registers_by_project_error_message:
           "Erreur du Serveur d'Intervalle",
         devices_list_diagnostic_filters_title: 'Filtres de Registres',
         devices_list_diagnostics_condition_modal_sensor_type_label:
           'Type de Capteur',
         devices_list_diagnostics_condition_modal_modbus_label:
           'Capteur Modbus',
         devices_list_diagnostics_condition_modal_mbus_label: 'Capteur Mbus',
         devices_list_diagnostics_condition_modal_formula_output_label:
           'Sortie de Formule',
         devices_list_diagnostics_condition_modal_meter_type_label:
           'Type de Compteur',
         devices_list_diagnostics_condition_modal_meter_type_label_default_option:
           'Sélectionner un Type de Compteur',
         devices_list_diagnostics_condition_modal_operator_label: 'Opérateur',
         devices_list_diagnostics_condition_modal_operator_option_1:
           'Inférieur',
         devices_list_diagnostics_condition_modal_operator_option_2:
           'Inférieur ou égal à',
         devices_list_diagnostics_condition_modal_operator_option_3: 'Égal à',
         devices_list_diagnostics_condition_modal_operator_option_4:
           'Supérieur',
         devices_list_diagnostics_condition_modal_operator_option_5:
           'Supérieur ou égal à',
         devices_list_diagnostics_condition_modal_operator_option_6:
           'Différent de',
         devices_list_diagnostics_condition_modal_register_label: 'Registre',
         devices_list_diagnostics_condition_modal_register_required_error:
           'Le Registre est requis',
         devices_list_diagnostics_send_message_modal_registers_label_default_option:
           'Sélectionner un Registre',
         devices_list_diagnostics_condition_modal_value_label: 'Valeur',
         devices_list_diagnostics_condition_modal_value_is_required_error:
           'La Valeur est requise',
         devices_list_diagnostics_condition_modal_operator_is_required_error:
           "L'Opérateur est requis",
         devices_list_diagnostics_condition_modal_meter_is_required_error:
           'Le Compteur est requis',
         devices_list_diagnostics_condition_modal_value_invalid_error:
           'Valeur invalide, veuillez vérifier',
         devices_list_diagnostics_condition_modal_save_button: 'Enregistrer',
         devices_list_diagnostics_condition_modal_cancel_button: 'Annuler',
         devices_list_diagnostics_condition_modal_add_button:
           'Ajouter plus de filtres',
         error_check_table_title: "Vérifications d'Erreur de l'Appareil",
         error_check_table_filter_search: 'Recherche',
         error_check_table_no_record_found: 'Aucun enregistrement trouvé',
         error_check_table_row_per_page: 'Lignes par page',
         error_check_table_created_at: 'Créé à',
         error_check_table_total_devices: 'Appareils au total',
         error_check_details_table_title:
           "Détails de la Vérification d'Erreur de l'Appareil",
         error_check_details_table_filter_search: 'Recherche',
         error_check_details_table_no_record_found:
           'Aucun enregistrement trouvé',
         error_check_details_table_row_per_page: 'Lignes par page',
         error_check_details_table_created_at: 'Créé à',
         error_check_details_table_device: 'Appareil',
         error_check_details_table_old_error: 'Ancienne Erreur',
         error_check_details_table_new_error: 'Nouvelle Erreur',
         error_check_details_table_status: 'Statut',
         error_check_details_table_status_success: 'Succès',
         error_check_details_table_status_failed: 'Échec',
         error_check_details_table_all_tab: 'Tous',
         error_check_details_table_success_tab: 'Succès',
         error_check_details_table_failure_tab: 'Échec',
         error_check_details_table_device_name: "Nom de l'Appareil",
         error_check_details_table_device_serial_number: 'Numéro de Série',
         sidebar_devices_error_check: 'Appareils avec Erreurs',
         error_check_details_table_bulk_export_file_name:
           'Liste de Détails des Appareils avec Erreurs',
         error_check_table_bulk_export_file_name:
           'Liste des Appareils avec Erreurs',
         device_single_registers_table_min_error:
           'La valeur doit être supérieure ou égale à min_value',
         device_single_registers_table_invalid_value_error:
           'Veuillez entrer un nombre valide',
         project_single_project_setting_tab: 'Project Setting',
         project_single_project_setting_mbus_registers_title: 'MBus Registers',
         project_single_project_setting_mbus_register_accumulated_heating_energy_title:
           'Accumulated heating energy Unit',
         project_single_project_setting_mbus_register_accumulated_heating_energy_success_message:
           'Accumulated heating energy unit is successfully updated',
         project_single_project_setting_mbus_register_accumulated_heating_energy_error_message:
           'Failed to update Accumulated heating energy unit',
         project_single_project_setting_select_mbus_register_accumulated_heating_energy_title:
           'Select Accumulated heating energy',
         project_single_project_setting_select_mbus_register_update_button:
           'Update',
         custom_popover_100_short_description: 'Heating state',
         custom_popover_101_short_description: 'Hot Water state',
         custom_popover_102_short_description: 'Preheat state',
         custom_popover_103_short_description: 'Thermal disinfection state',
         custom_popover_104_short_description: 'Cooling state',
         custom_popover_1802_short_description: 'TE Heating Element State',
         custom_popover_105_short_description: 'Alarm code',
         custom_popover_107_short_description: 'Hot water valve (M1)',
         custom_popover_108_short_description: 'Heating/cooling valve (M2)',
         custom_popover_109_short_description: 'Pump',
         custom_popover_110_short_description: '6-way-valve',
         custom_popover_113_short_description: 'Room thermostat input',
         custom_popover_114_short_description: 'OpenTherm Indicator',
         custom_popover_115_short_description: 'Appliance Type',
         custom_popover_200_short_description: 'Hot water flow rate',
         custom_popover_201_short_description: 'Hot water temperature',
         custom_popover_202_short_description: 'Primary supply',
         custom_popover_203_short_description: 'Primary return/Outdoor',
         custom_popover_205_short_description: 'Secondary supply',
         custom_popover_206_short_description: 'Secondary return',
         custom_popover_204_short_description: 'Calculated heating setpoint',
         custom_popover_207_short_description: 'Room Temperature (OpenTherm)',
         custom_popover_208_short_description: 'Room Setpoint (OpenTherm)',
         custom_popover_210_short_description: 'Secondary water pressure',
         custom_popover_800_short_description: 'Total system run time',
         custom_popover_801_short_description: 'Heating burn time',
         custom_popover_802_short_description: 'Cooling burn time',
         custom_popover_803_short_description: 'Hot water burn Time',
         custom_popover_804_short_description: 'Number of tappings',
         custom_popover_805_short_description: 'Hot water Volume',
         custom_popover_806_short_description: 'Power cuts',
         create_role_stepper_information_title: 'Information',
         create_role_stepper_client_title: 'Client',
         create_role_stepper_service_client_title: 'Service Client',
         create_role_stepper_project_title: 'Project',
         create_role_stepper_device_management_title: 'Device Management',
         create_role_stepper_commissioning_title: 'Commissioning',
         create_role_stepper_reporting_title: 'Reporting',
         create_role_stepper_general_title: 'General',
         roles_form_role_name_field: 'Name',
         roles_name_required_form_error: 'Name is required',
         roles_form_description_field: 'Description',
         create_role_stepper_back_button: 'Back',
         create_role_stepper_next_button: 'Next',
         create_role_stepper_finish_button: 'Finish',
         create_role_stepper_yes_label: 'Yes',
         create_role_stepper_no_label: 'No',
         create_role_stepper_step_2_client_view_all_users: 'View all users?',
         create_role_stepper_step_2_client_create_new_users:
           'Create new users?',
         create_role_stepper_step_2_client_edit_new_users:
           'Modify existing users like the role?',
         create_role_stepper_step_3_service_client_create_new:
           "Create a new 'service client'?",
         create_role_stepper_step_3_service_client_view_users:
           "View existing 'service client' users?",
         create_role_stepper_step_3_service_client_create_users:
           "Create new 'service client' users?",
         create_role_stepper_step_3_service_client_modify_users:
           "Modify 'service client' users like the role?",
         create_role_stepper_step_4_project_view: 'View projects?',
         create_role_stepper_step_4_project_create_new: 'Create new projects?',
         create_role_stepper_step_4_project_export_mbus_data:
           'Export energy meter data from projects?',
         create_role_stepper_step_5_device_view_single_page: 'Open a device?',
         create_role_stepper_step_5_device_view_single_page_setting_registers:
           'View settings?',
         create_role_stepper_step_5_device_edit_single_page_setting_registers:
           'Modify settings?',
         create_role_stepper_step_5_device_edit_single_page_manual_control:
           'Use manual control?',
         create_role_stepper_step_5_device_single_page_view_history:
           'View history?',
         create_role_stepper_step_5_device_single_page_view_meter_data:
           'View meter data?',
         create_role_stepper_step_5_device_single_page_use_diagnostics_module:
           'Use the diagnostics module?',
         create_role_stepper_step_5_device_single_page_information_and_delivery_set_data:
           'View information such as device info, address details, and delivery set data?',
         create_role_stepper_step_6_commissioning_module_put_devices_into_operation:
           'Commissioning module to put devices into operation?',
         create_role_stepper_step_6_commissioning_module_swapping:
           'Exchange devices (transfer data from old device to new device)?',
         create_role_stepper_step_7_reporting_audit:
           'The logbook that contains all messages, alarms, and actions on devices?',
         create_role_stepper_step_7_reporting_swapped_devices:
           'Logbook of exchanged devices?',
         create_role_stepper_step_7_reporting_error_devices:
           'Logbook of devices with faults?',
         create_role_stepper_step_7_reporting_bulk_registers_update:
           'Results of group changes?',
         create_role_stepper_step_8_view_dashboard:
           'Dashboard all access and sidebar device counters',
         create_role_stepper_step_8_general_create_role: 'Creating roles?',
         create_role_stepper_question_required_error:
           'One option is required to proceed',
         project_single_project_setting_device_v2_settings_title:
           'Device V2 Settings',
         project_single_device_settings_secondary_device_type_field:
           'Secondary Device Type',
         project_single_project_setting_base_topic_field: 'Base Topic',
         project_single_device_settings_baud_rate_uart_field: 'Baud Rate UART',
         project_single_device_settings_select_baud_rate_uart_field:
           'Select Baud Rate UART',
         project_single_device_settings_modbus_error_register_address_field:
           'Modbus alarm register address',
         project_single_device_settings_modbus_error_register_value_field:
           'Modbus expected alarm register value',
         project_single_project_setting_device_v2_send_button: 'Send',
         project_single_project_setting_base_topic_success_message:
           'Base Topic is successfully forwarded to ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices of Project',
         project_single_project_setting_secondary_device_type_success_message:
           'Secondary Device Type is successfully forwarded to ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices of Project',
         project_single_project_setting_reboot_message:
           'Device Reboot Message is successfully forwarded to ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices of Project',
         project_single_project_setting_baut_rate_uart_success_message:
           'Device Baut Rate UART Message is successfully forwarded to ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices of Project',
         project_single_project_setting_modbus_expected_error_register_value_success_message:
           'Device Modbus Expected Alarm Register Value Message is successfully forwarded to ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices of Project',
         project_single_project_setting_modbus_error_register_address_success_message:
           'Device Reboot Message is successfully forwarded to ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices of Project',
         docs_third_tab_video_instruction: 'Video Instruction',
         docs_third_tab_video_instruction_title: 'Video Instruction',
         custom_popover_106_short_description: 'Software version',
         custom_popover_106_long_description: 'Software version',
         EXPORT_MBUS_METER_SERIAL_NUMBER: 'Serial number meter',
         navbar_languages_french: 'French',
         diagnostic_formulas_form_diagnostic_formulas_name_fr_field:
           'Name (FR)',
         diagnostic_formulas_name_fr_required_form_error:
           'Name (FR) is required',
         diagnostic_formulas_form_description_fr_field: 'Description (FR)',
         diagnostic_flows_form_diagnostic_flows_name_fr_field: 'Name (FR)',
         diagnostic_flows_name_fr_required_form_error: 'Name (FR) is required',
         diagnostic_flows_form_description_fr_field: 'Description (FR)',
         diagnostic_categories_form_diagnostic_categories_name_fr_field:
           'Name (FR)',
         diagnostic_categories_name_fr_required_form_error:
           'Name (FR) is required',
         diagnostic_categories_form_description_fr_field: 'Description (FR)',
         modules_form_module_name_fr_field: 'Name (FR)',
         modules_name_fr_required_form_error: 'Name (FR) is required',
         modules_form_description_fr_field: 'Description (FR)',
         roles_form_role_name_fr_field: 'Name (FR)',
         roles_name_fr_required_form_error: 'Name (FR) is required',
         roles_form_description_fr_field: 'Description (FR)',
         permissions_form_permission_name_fr_field: 'Name (FR)',
         permissions_form_description_fr_field: 'Description (FR)',
         firmwares_form_firmware_name_fr_field: 'Name (FR)',
         firmwares_name_fr_required_form_error: 'Name (FR) is required',
         notifications_form_title_fr_field: 'Name (FR)',
         notifications_form_description_fr_field: 'Description (FR)',
         notifications_title_dk_required_form_error: 'Name (DK) is required',
         notifications_title_fr_required_form_error: 'Name (FR) is required',
         notifications_title_de_required_form_error: 'Name (DE) is required',
         notifications_description_dk_required_form_error:
           'Description (DK) is required',
         notifications_description_de_required_form_error:
           'Description (DE) is required',
         notifications_description_fr_required_form_error:
           'Description (FR) is required',
         client_single_error_devices_bread_crumb: 'Alarm Devices',
         service_client_single_error_devices_bread_crumb: 'Alarm Devices',
         devices_list_diagnostics_condition_modal_fetch_and_filter_button:
           'Fetch & Filter',
         diagnostic_register_drawer_selected_devices_title: 'Selected Devices',
         diagnostic_register_drawer_fetch_and_filter_message_1:
           'Fetching devices data',
         diagnostic_register_drawer_fetch_and_filter_message_2:
           'Database refresh',
         diagnostic_register_drawer_fetch_and_filter_message_3:
           'Filtering devices',
         devices_bulk_selected_devices_title: 'Devices Selected',
         custom_popover_100_long_description: 'Heating state',
         custom_popover_101_long_description: 'Hot Water state',
         custom_popover_102_long_description: 'Preheat state',
         custom_popover_103_long_description: 'Thermal disinfection state',
         custom_popover_104_long_description: 'Cooling state',
         custom_popover_1802_long_description: 'TE Heating Element State',
         custom_popover_107_long_description: 'Hot water valve (M1)',
         custom_popover_108_long_description: 'Heating/cooling valve (M2)',
         custom_popover_109_long_description: 'Pump',
         custom_popover_110_long_description: '6-way-valve',
         custom_popover_113_long_description: 'Room thermostat input',
         custom_popover_114_long_description: 'OpenTherm Indicator',
         custom_popover_115_long_description: 'Appliance Type',
         custom_popover_200_long_description: 'Hot water flow rate',
         custom_popover_201_long_description: 'Hot water temperature',
         custom_popover_202_long_description: 'Primary supply',
         custom_popover_203_long_description: 'Primary return/Outdoor',
         custom_popover_205_long_description: 'Secondary supply',
         custom_popover_206_long_description: 'Secondary return',
         custom_popover_204_long_description: 'Calculated heating setpoint',
         custom_popover_207_long_description: 'Room Temperature (OpenTherm)',
         custom_popover_208_long_description: 'Room Setpoint (OpenTherm)',
         custom_popover_210_long_description: 'Secondary water pressure',
         custom_popover_800_long_description: 'Total system run time',
         custom_popover_801_long_description: 'Heating burn time',
         custom_popover_802_long_description: 'Cooling burn time',
         custom_popover_803_long_description: 'Hot water burn Time',
         custom_popover_804_long_description: 'Number of tappings',
         custom_popover_805_long_description: 'Hot water Volume',
         custom_popover_806_long_description: 'Power cuts',
         project_single_project_setting_mbus_hourly_logs_title:
           'Mbus Hourly Logs',
         project_single_project_setting_mbus_hourly_logs_field:
           'Fetch Mbus Hourly',
         project_single_project_setting_mbus_hourly_logs_update_button:
           'Update',
         project_single_project_setting_mbus_hourly_logs_success_set_message:
           'Mbus Hourly logs are successfully set for the project',
         project_single_project_setting_mbus_hourly_logs_error_message:
           'Failed to update Mbus Hourly logs for the project',
         sidebar_mbus_reporting: 'Mbus Reporting',
         mbus_reporting_table_device: 'Device',
         mbus_reporting_table_project: 'Project',
         mbus_reporting_table_created_at: 'Created At',
         mbus_reporting_table_viewed_by: 'Viewed By',
         mbus_reporting_table_viewed_at: 'Viewed At',
         mbus_reporting_table_firmware: 'Firmware',
         mbus_reporting_table_no_record_found: 'No Records Found',
         mbus_reporting_table_all_filter: 'All',
         mbus_reporting_table_read_filter: 'Read',
         mbus_reporting_table_unread_filter: 'Unread',
         mbus_reporting_table_row_per_page: 'Rows per page',
         mbus_reporting_table_title: 'Mbus Reporting',
         mbus_reporting_anomaly_table_title: 'Mbus Anomalies',
         mbus_reporting_anomaly_table_difference: 'Difference',
         mbus_reporting_anomaly_table_detection: 'Detection',
         mbus_reporting_anomaly_table_mbus_meter_type: 'Meter',
         mbus_reporting_anomaly_table_mbus_serial_number: 'Mbus Serial Number',
         mbus_reporting_anomaly_table_mbus_old_value: 'Old Value',
         mbus_reporting_anomaly_table_mbus_register: 'Register',
         mbus_reporting_anomaly_table_mbus_reason: 'Reason',
         mbus_reporting_anomaly_table_mbus_fail_reason: 'Greater than',
         mbus_reporting_anomaly_table_mbus_suspicious_reason: 'Lies in between',
         mbus_reporting_anomaly_table_fail: 'Fail',
         mbus_reporting_anomaly_table_suspicious: 'Suspicious',
         mbus_reporting_table_bulk_view_reports_success_message:
           'Mbus Reporting Messages are successfully viewed',
         mbus_reporting_table_bulk_view_reports_error_message:
           'Please select Mbus Reporting records to proceed',
         mbus_reporting_table_bulk_view_button: 'Bulk View',
         mbus_reporting_table_view_button: 'View',
         mbus_reporting_table_filters_project_field: 'Project',
         mbus_reporting_table_filters_device_name_field: 'Device',
         mbus_reporting_table_filters_start_date: 'Start Date',
         mbus_reporting_table_filters_end_date: 'End Date',
         mbus_reporting_table_filters_firmware: 'Firmware',
         mbus_reporting_table_filters_mbus_serial_number: 'Mbus Serial Number',
         mbus_reporting_table_filters_viewed_by: 'Viewed By',
         business_situation_measured_values_TR03_209: 'Outdoor Temperature',
         custom_popover_209_short_description: 'Outdoor Temperature',
         custom_popover_209_long_description: 'Outdoor Temperature',
         appliance_types_set_registers_table_dashboard: 'Dashboard',
         appliance_types_set_registers_table_dashboard_error_message:
           'Device dashboard registers must be either 0 or exactly 8.',
         sidebar_missing_hourly_reporting: 'Mbus Missing Data Report',
         missing_hourly_reporting_table_title:
           'Mbus Hourly Missing Data Reporting',
         mbus_hourly_missing_reporting_table_filters_project_field: 'Project',
         mbus_hourly_missing_reporting_table_filters_device_name_field:
           'Device',
         mbus_hourly_missing_reporting_table_filters_firmware_field: 'Firmware',
         mbus_hourly_missing_reporting_table_last_seen: 'Mbus Message At',
         mbus_hourly_missing_reporting_table_created_at: 'Created At',
         mbus_hourly_missing_reporting_table_device: 'Device',
         mbus_hourly_missing_reporting_table_project: 'Project',
         mbus_hourly_missing_reporting_table_firmware: 'Firmware',
         mbus_hourly_missing_reporting_table_no_record_found:
           'No Records Found',
         mbus_hourly_missing_reporting_table_row_per_page: 'Rows per page',
         diagnostic_flows_form_loading_text: 'Loading ...',
         device_monitoring_device_frequency_history_counters_title:
           'Device Anomalies Frequency',
         device_monitoring_device_frequency_history_counters_error:
           'No data found',
         device_monitoring_device_frequency_history_counters_no_graph_data_error:
           'The piechart is unavailable',
         device_monitoring_device_frequency_history_counters_loading_data:
           'Loading ...',
         device_monitoring_project_frequency_history_counters_title:
           'Project Anomalies Frequency',
         device_monitoring_project_frequency_history_counters_error:
           'No data found',
         device_monitoring_project_frequency_history_counters_no_graph_data_error:
           'The piechart is unavailable',
         device_monitoring_project_frequency_history_counters_loading_data:
           'Loading ...',
         device_monitoring_firmware_anomalies_history_title:
           'Firmware Anomalies Frequency',
         device_monitoring_device_firmware_anomalies_history_graph_loading_data:
           'The barchart is unavailable',
         device_monitoring_device_firmware_anomalies_history_no_graph_data_error:
           'Loading ...',
         devices_device_id: 'Device Id',
         device_monitoring_device_frequency_details_table_title:
           'Device Anomalies Frequency',
         device_monitoring_device_frequency_details_table_firmware: 'Firmware',
         device_monitoring_device_frequency_details_table_device: 'Device',
         device_monitoring_device_frequency_details_table_project: 'Project',
         device_monitoring_device_frequency_details_table_saved_at: 'Date',
         device_monitoring_device_frequency_details_table_startup_messages_count:
           'Start up messages count',
         device_monitoring_project_frequency_details_table_title:
           'Project Anomalies Frequency',
         device_monitoring_project_frequency_details_table_project: 'Project',
         device_monitoring_project_frequency_details_table_devices_count:
           'Devices Count',
         device_monitoring_project_frequency_details_table_startup_messages_count:
           'Start up messages count',
         device_monitoring_firmware_frequency_details_table_title:
           'Firmware Anomalies Frequency',
         device_monitoring_firmware_frequency_details_table_firmware:
           'Firmware',
         device_monitoring_firmware_frequency_details_table_startup_messages_count:
           'Start up messages count',
         client_single_users_list_reset_and_send_email_button: 'Reset Password',
         user_reset_password_form_success:
           'User password is updated successfully',
         users_reset_password_modal_title: 'Reset Password',
         users_reset_password_modal_subtitle:
           'Do you want to reset password for this user and send email?',
         users_reset_password_modal_cancel_button: 'Close',
         users_reset_password_modal_reset_password_button:
           'Reset and Send Email',
         reset_password_subject: 'Fortes Data Management - Reset Password',
         clients_form_is_2fa_enabled_field:
           'Enable Two-Factor Authentication (2FA)',
         service_clients_form_is_2fa_enabled_field:
           'Enable Two-Factor Authentication (2FA)',
         two_factor_authentication_qr_verified_title:
           'Two-Factor Authentication (2FA)',
         two_factor_authentication_qr_unverified_title:
           'Setup Two-Factor Authentication (2FA)',
         two_factor_authentication_permission_error: '',
         two_factor_authentication_description_step_1:
           'Install one of the following applications on your mobile:',
         two_factor_authentication_description_step_2:
           'Open the application and scan the QR Code:',
         two_factor_authentication_description_step_2_rescan:
           'Regenerate QR Code',
         two_factor_authentication_description_step_3:
           'Enter the one-time code provided by the application and click Submit to finish the setup.',
         two_factor_authentication_form_otp_field: 'OTP Code',
         two_factor_authentication_form_otp_characters_limit_error:
           'OTP must be 6 characters',
         two_factor_authentication_form_otp_required_error: 'OTP is required',
         two_factor_authentication_form_incorrect_otp_error:
           'Invalid OTP, please retry again with a new OTP',
         two_factor_authentication_form_success:
           'OTP is successfully authenticated',
         two_factor_authentication_submit_button: 'Submit',
         client_single_users_list_enable_2fa_qr_code_button:
           'Enable Two-Factor Authentication (2FA) QR Code',
         service_client_single_users_list_enable_2fa_qr_code_button:
           'Enable Two-Factor Authentication (2FA) QR Code',
         users_enable_2fa_qr_code_modal_title:
           'Enable Two-Factor Authentication (2FA) QR Code',
         users_enable_2fa_qr_code_modal_subtitle:
           'Are you sure you want to enable Two-Factor Authentication (2FA) QR Code for this user?',
         users_enable_2fa_qr_code_modal_cancel_button: 'Cancel',
         users_enable_2fa_qr_code_modal_enable_2fa_qr_code_button:
           'Enable Two-Factor Authentication (2FA) QR Code',
         client_single_users_list_enable_2fa_qr_code_success_message:
           'Two-Factor Authentication (2FA) QR Code is successfully enabled',
         client_single_2fa_label: 'Two-Factor Authentication (2FA)',
         enabled_2fa_label: 'Enabled',
         disabled_2fa_label: 'Disabled',
         service_client_single_2fa_label: 'Two-Factor Authentication (2FA)',
         client_single_users_table_last_access: 'Last Seen',
         service_client_single_users_table_last_access: 'Last Seen',
         projects_form_header: 'Project Information',
         projects_commissioning_form_header: 'Project Commissioning',
         projects_commissioning_form_export_button: 'Export Devices',
         projects_commissioning_form_export_file_name:
           'Project Commissioning Export',
         projects_commissioning_form_import_button: 'Import Devices',
         projects_commissioning_form_import_message:
           "<strong>Steps to Import Devices</strong> <ol> <li>Download the Project Commissioning File Template from green Export Devices Button.</li> <li>Update the file and don't change the header column names, in case they're changed. The file import will fail.</li> <li>Import the file and changes will be updated.</li> </ol>",
         projects_commissioning_form_import_success_message:
           'Devices data is successfully commissioned',
         commissioning_device_stepper_step_1_scan_qr_serial_number_title:
           'Scan QR code Mercurius',
         commissioning_device_stepper_step_3_validate_project_setting_title:
           'Validate connectivity',
         commissioning_device_stepper_step_4_update_address_information_title:
           'Update address',
         commissioning_device_stepper_step_2_hiu_commissioning_title:
           'Scan QR code HIU',
         commissioning_device_stepper_step_5_preview_and_submit_title:
           'Preview and submit',
         commissioning_form_dont_have_serial_number_checkbox:
           "Don't have Serial QR Code?",
         commissioning_form_back_button: 'Previous',
         commissioning_form_next_button: 'Next',
         commissioning_form_finish_button: 'Finish',
         commissioning_form_device_serial_is_missing_error:
           'Serial Number is required',
         commissioning_form_modbus_mbus_validation_error:
           'Validation failed, do you want to proceed anyway?',
         commissioning_form_stepper_validation_project_setting_title:
           'Project Settings',
         commissioning_form_stepper_validation_current_setting_title:
           'Device Settings',
         commissioning_form_stepper_validation_validate_to_view:
           'Validate to view details',
         commissioning_form_stepper_validation_modbus_title: 'Modbus',
         commissioning_form_stepper_validation_mbus_title: 'M-Bus',
         commissioning_form_stepper_validation_modbus_connected_title:
           'Connected',
         commissioning_form_stepper_validation_modbus_not_connected_title:
           'Not Connected',
         commissioning_form_stepper_validation_mbus_meters_title: 'meter(s)',
         project_single_project_setting_modbus_and_mbus_validation_form_title:
           'Modbus and Mbus Setting',
         commissioning_form_stepper_validation_is_modbus_connected:
           'Is Modbus Connected',
         commissioning_form_stepper_validation_mbus_meters_select_field:
           'M-Bus Meters',
         commissioning_form_stepper_validation_mbus_meters_select_option_field:
           'Select M-Bus Meters',
         commissioning_form_stepper_validation_mbus_meters_validate_button:
           'Validate',
         commissioning_form_upload_file_type_error:
           'Only XLSX files are allowed.',
         commissioning_form_upload_file_invalid_column_names_error:
           "Invalid column ##COLUMNS##, please don't change the column names",
         commissioning_form_upload_file_size_error:
           'File size should be less than 5 MB.',
         commissioning_form_uploading_text: 'Uploading...',
         project_single_project_setting_mbus_reporting_form_title:
           'Mbus Reporting Setting',
         project_single_project_setting_mbus_hourly_missing_data_reporting_value_field:
           'Mbus Hourly Missing Data Reporting',
         project_single_project_setting_mbus_anomaly_reporting_value_field:
           'Mbus Anomaly Reporting',
         project_single_project_setting_mbus_reporting_form_button: 'Update',
         project_single_project_setting_mbus_reporting_success_message:
           'Mbus Reporting data is successfully set for the project',
         project_single_project_setting_mbus_reporting_error_message:
           'Failed to update Mbus Reporting data for the project',
         commissioning_form_upload_file_incorrect_serial_number_error:
           'Incorrect Serial Number(s) found for the project commissioning',
         commissioning_form_upload_file_incorrect_devices_data_error:
           'Incorrect Device(s) data found for the project commissioning',
         commissioning_form_upload_file_empty_sheet_error:
           'Project Commissioning file is empty',
         commissioning_form_upload_success_message:
           'Project Commissioning is successfully completed',
         commissioning_validation_failed_subject:
           'Mercurius Commissioning Report',
         commissioning_form_stepper_validation_mbus_meters_loading_title:
           'Mbus meters check takes upto 30 - 60 seconds',
         commissioning_form_stepper_validation_mbus_meters_retries_label:
           'Mbus Retries',
         commissioning_form_stepper_validation_mbus_meters_retries_button:
           'Retry',
         mbus_reporting_table_bulk_snooze_button: 'Bulk Snooze',
         mbus_reporting_table_bulk_snooze_devices_success_message:
           'Mbus Reporting Devices are successfully snoozed',
         mbus_reporting_table_bulk_snooze_modal_title: 'Are you sure?',
         mbus_reporting_table_bulk_snooze_modal_sub_title:
           'You want to snooze Mbus Reporting for the selected devices?',
         mbus_reporting_table_bulk_snooze_modal_cancel_button: 'Cancel',
         mbus_reporting_table_bulk_snooze_modal_snooze_button: 'Snooze',
         mbus_reporting_table_bulk_snooze_modal_snooze_duration:
           'Snooze Duration',
         mbus_reporting_table_bulk_snooze_modal_select_snooze_duration:
           'Select Snooze Duration',
         mbus_reporting_table_bulk_snooze_modal_snooze_duration_day: 'Day',
         mbus_reporting_table_bulk_snooze_modal_snooze_duration_week: 'Weeks',
         mbus_reporting_table_bulk_snooze_modal_snooze_duration_month: 'Months',
         mbus_reporting_table_bulk_snooze_modal_snooze_duration_year: 'Years',
         sidebar_mbus_reporting_snoozed_devices:
           'Mbus Reporting - Snoozed Devices',
         mbus_reporting_snoozed_devices_table_title: 'Snoozed Devices',
         mbus_reporting_table_bulk_un_snooze_devices_success_message:
           'Mbus Reporting Devices are successfully UnSnoozed',
         mbus_reporting_table_bulk_un_snooze_modal_title: 'Are you sure?',
         mbus_reporting_table_bulk_un_snooze_modal_sub_title:
           'You want to UnSnooze Mbus Reporting for the selected devices?',
         mbus_reporting_table_bulk_un_snooze_modal_cancel_button: 'Cancel',
         mbus_reporting_table_bulk_un_snooze_modal_snooze_button: 'UnSnooze',
         mbus_reporting_table_bulk_un_snooze_button: 'Bulk UnSnooze',
         mbus_reporting_table_snooze_request_at: 'Request At',
         mbus_reporting_table_snooze_end_at: 'End At',
         mbus_reporting_snoozed_devices_table_all_filter: 'All',
         mbus_reporting_snoozed_devices_table_snoozed_filter: 'Snoozed',
         mbus_reporting_snoozed_devices_table_unsnoozed_filter: 'UnSnoozed',
         devices_list_diagnostics_condition_modal_single_meter_label: 'Meter',
         devices_list_diagnostics_condition_modal_multiple_meters_label:
           'Meters',
         devices_list_diagnostics_condition_modal_mbus_meters_dropdown_label:
           'Connected Mbus Meters',
         devices_list_diagnostics_condition_modal_are_mbus_connected_value_connected_label:
           'Connected',
         devices_list_diagnostics_condition_modal_are_mbus_connected_value_not_connected_label:
           'Not Connected',
         devices_list_diagnostics_condition_modal_mbus_meters_dropdown_select_record_label:
           'Select Connected Mbus Meters',
         devices_list_diagnostics_condition_modal_are_mbus_connected_dropdown_label:
           'Mbus Meters Connection',
         devices_list_diagnostics_condition_modal_are_mbus_connected_select_field_label:
           'Select connection status',
         devices_search_mbus_registers_multiple_devices_success:
           'The message has been successfully sent to the selected device(s).',
         devices_testing_button: 'Device Testing',
         devices_testing_form_header: 'Device Testing',
         devices_testing_device_serial_field: 'Device Serial',
         devices_testing_modbus_registers_field: 'Modbus Registers',
         devices_testing_modbus_registers_button_field: 'Send Modbus Message',
         devices_testing_single_mbus_register_field: 'Single MBus Register',
         devices_testing_single_mbus_register_button_field: 'Send Message',
         devices_testing_send_fetch_mbus_message: 'Send Fetch MBus Message',
         devices_testing_send_scan_mbus_message: 'Send Scan MBus Message',
         project_single_project_setting_mbus_hourly_logs_success_unset_message:
           'Mbus Hourly logs are successfully unset for the project',
         mbus_reporting_table_export_button: 'Export',
         mbus_reporting_table_export_file: 'Mbus Reporting',
         mbus_hourly_missing_reporting_export_button: 'Export',
         mbus_hourly_missing_reporting_export_file:
           'Mbus Hourly Missing Data Reporting',
         snoozed_devices_export_button: 'Export',
         snoozed_devices_export_file: 'Snoozed Devices',
         device_single_documentation_instructie_pomp_button: 'Instructie Pomp',
         sidebar_inconsistent_mbus_devices_reporting:
           'Inconsistent Mbus Devices',
         inconsistent_mbus_devices_reporting_table_header:
           'Inconsistent Mbus Devices',
         inconsistent_mbus_devices_reporting_bulk_export_button: 'Export',
         inconsistent_mbus_devices_reporting_filter_reset_button: 'Reset',
         inconsistent_mbus_devices_reporting_table_filter_search: 'Search',
         inconsistent_mbus_devices_reporting_table_created_at: 'Created At',
         inconsistent_mbus_devices_reporting_table_total_devices:
           'Total Devices',
         inconsistent_mbus_devices_reporting_table_total_projects:
           'Total Projects',
         inconsistent_mbus_devices_reporting_table_no_record_found:
           'No Record Found',
         inconsistent_mbus_devices_reporting_table_row_per_page:
           'Rows per page',
         devices_mbus_meter_count: 'Mbus Meters',
         devices_bulk_modbus_download_form_data_type: 'Data Type',
         devices_bulk_modbus_download_form_export_type: 'Export Type',
         devices_bulk_modbus_download_form_data_type_daily: 'Daily',
         devices_bulk_modbus_download_form_data_type_hourly: 'Hourly',
         devices_bulk_modbus_download_form_export_type_combined: 'Combined',
         devices_bulk_modbus_download_form_export_type_separated: 'Separated',
         devices_bulk_export_modbus_historic_data_button:
           'Download Modbus Data',
         devices_bulk_export_modbus_historic_data_file_name:
           'Modbus Historic Data',
         devices_bulk_modbus_download_title: 'Download Modbus Historical Data',
         devices_bulk_modbus_download_form_date_range: 'Date Range:',
         devices_bulk_modbus_download_form_submit_button:
           'Download Modbus Data',
         devices_bulk_modbus_download_form_cancel_button: 'Cancel',
         devices_bulk_modbus_download_form_success:
           'Modbus Historical Data is emailed to ##EMAIL## successfully!',
         devices_bulk_modbus_download_form_api_error: 'Internal Server Alarm',
         devices_bulk_modbus_download_no_devices_error:
           'Please select atleast 1 device with correct TR Type (TR03/TR04)',
         devices_bulk_modbus_download_form_no_devices_error:
           'Please select devices to proceed.',
         devices_bulk_modbus_download_modal_title: 'Are you sure?',
         devices_bulk_modbus_download_modal_subtitle:
           'You want to run a bulk download historical Modbus data?',
         devices_bulk_modbus_download_modal_cancel_button: 'Cancel',
         devices_bulk_modbus_download_modal_submit_button: 'Confirm',
         projects_bulk_export_modbus_historic_data_file_name:
           'Modbus Historic Data',
         projects_bulk_modbus_download_title: 'Download Modbus Historical Data',
         projects_bulk_bulk_modbus_download_form_date_range: 'Date Range:',
         projects_bulk_bulk_modbus_download_form_data_export_type:
           'Date Export Type',
         projects_bulk_bulk_modbus_download_form_data_export_type_combined:
           'Combined',
         projects_bulk_bulk_modbus_download_form_data_export_type_daily:
           'Daily',
         projects_bulk_bulk_modbus_download_form_data_export_type_normal:
           'Normal',
         projects_bulk_bulk_modbus_download_form_submit_button:
           'Download Modbus Data',
         projects_bulk_bulk_modbus_download_form_cancel_button: 'Cancel',
         projects_bulk_modbus_download_form_success:
           'Modbus Historical Data is emailed to ##EMAIL## successfully!',
         projects_bulk_modbus_download_form_api_error: 'Internal Server Alarm',
         projects_bulk_modbus_download_no_projects_error: '',
         projects_bulk_modbus_download_form_no_projects_error:
           'Please select projects to proceed.',
         projects_bulk_bulk_modbus_download_modal_title: 'Are you sure?',
         projects_bulk_modbus_download_modal_subtitle:
           'You want to run a bulk download historical Modbus data?',
         projects_bulk_modbus_download_modal_cancel_button: 'Cancel',
         projects_bulk_modbus_download_modal_submit_button: 'Confirm',
         projects_bulk_modbus_selected_projects: 'Projects Selected',
         device_single_status_modbus_date_export_label: 'Date',
         device_single_download_modbus_data: 'Modbus Export',
         device_monitoring_maxitel_status_heading: 'Network Status',
         device_monitoring_maxitel_status_online: 'Online',
         device_monitoring_maxitel_status_offline: 'Offline',
         device_monitoring_maxitel_operational_status: 'Operational',
         device_monitoring_maxitel_non_operational_status: 'Not Operational',
         device_monitoring_maxitel_mobile_on_cloud_network_green:
           'MaxiTEL MobileOnCloud - Network Purple',
         device_monitoring_maxitel_mobile_on_cloud_network_purple:
           'MaxiTEL MobileOnCloud - Network Green',
         device_monitoring_maxitel_mobile_data_network_purple:
           'Mobile data - Network Purple',
         device_monitoring_maxitel_mobile_m2m_blend: 'M2M Blend',
         device_monitoring_maxitel_other_api: 'API',
         device_monitoring_maxitel_other_portal: 'Portal',
         device_monitoring_maxitel_updated_at: 'Updated',
         admins_last_seen: 'Last Seen',
         device_monitoring_send_grid_email_reached: 'Email Limit Reached',
         sidebar_email_reporting: 'Email Report',
         email_reporting_title: 'Email Reporting',
         email_reporting_tab_all: 'All',
         email_reporting_tab_passed: 'Passed',
         email_reporting_tab_failed: 'Failed',
         email_reporting_table_email_forwarded_at: 'Forwarded Date',
         email_reporting_table_to: 'To',
         email_reporting_table_recipient_name: 'Recipient Name',
         email_reporting_table_subject: 'Subject',
         email_reporting_table_status: 'Status',
         email_reporting_table_no_record_found: 'No Records Found',
         email_reporting_single_output_tab: 'Email Content',
         email_reporting_single_second_bread_crumb: 'Email Detail',
         email_reporting_single_email_logs_title: 'Email Logs',
         email_reporting_table_resend_failed_email_success_message:
           'Emails are forwarded again.',
         email_reporting_table_resend_failed_email_error_message:
           'Please select atleast records to resend email',
         email_reporting_table_resend_failed_email_button: 'Resend Email',
         email_reporting_table_filter_search: 'Search',
         email_reporting_table_row_per_page: 'Rows per page',
         settings_menu_modbus_global_configuration_title:
           'Modbus Global Configuration',
         settings_menu_modbus_global_configuration_title_form_header:
           'Modbus Global Configuration',
         settings_menu_modbus_global_configuration_TR03_tab: 'TR03 Settings',
         settings_menu_modbus_global_configuration_TR04_tab: 'TR04 Settings',
         settings_menu_modbus_global_configuration_form_success:
           'Modbus Global Configurations are saved successully',
         settings_menu_modbus_global_configuration_form_error:
           'Failed to update Modbus Global Configurations',
         settings_menu_modbus_global_configuration_form_save_button:
           'Save Modbus Settings',
         device_single_unprovisioned_detailed_message:
           'Device is in "Unprovisioned" mode',
         commissioning_form_stepper_validation_modbus_loading_title:
           'Modbus check takes upto 1 - 3 minutes',
         settings_menu_modbus_global_configuration_title_form_header_add_new:
           'Add New',
         settings_menu_modbus_global_configuration_title_add_form_header:
           'Add Article Number',
         settings_menu_modbus_global_configuration_article_number_field:
           'Article Number',
         settings_menu_modbus_global_configuration_article_number_required_form_error:
           'Article Number is required',
         settings_menu_modbus_global_configuration_article_number_unique_form_error:
           'Article Number already exists. Please provide a unique Article Number',
         settings_menu_modbus_global_configuration_type_field: 'Type',
         settings_menu_modbus_global_configuration_type_required_form_error:
           'Type is required',
         settings_menu_modbus_global_configuration_type_default_option:
           'Select a Type',
         settings_menu_modbus_global_configuration_add_success_message:
           'Article Number is successfully added',
         settings_menu_modbus_global_configuration_cancel_button: 'Cancel',
         settings_menu_modbus_global_configuration_save_button: 'Save',
         missing_article_number_message:
           'The Article Number field is either empty or not registered in the Modbus Global Configurations. Please commission the device. If the issue persists, contact your administrator.',
         // General Modbus Control / Status registers(90-99) - TR04
         general_modbus_control_TR04_80: 'Firmware Image status',
         general_modbus_control_TR04_81: 'Firmware Image ID',
         general_modbus_control_TR04_82: 'Defaults Image status',
         general_modbus_control_TR04_83: 'Defaults Image Checksum',
         general_modbus_control_TR04_96: 'Modbus Version',
         general_modbus_control_TR04_97: 'Modbus Device type / table',
         general_modbus_control_TR04_98: 'Unit selection ',
         general_modbus_control_TR04_99: 'Control register ',

         // Operating Status - TR04
         business_situation_operating_status_TR04_title:
           'Operating state Heat Interface Unit',
         business_situation_operating_status_TR04_100: 'CH Control state',
         business_situation_operating_status_TR04_100_list: JSON.stringify({
           list: {
             0: 'Idle',
             1: 'Request',
             2: 'Demand',
             3: 'Post Circulation',
             4: 'Off',
             5: 'Pre Circulation',
           },
         }),
         business_situation_operating_status_TR04_101: 'DHW Control State',
         business_situation_operating_status_TR04_101_list: JSON.stringify({
           list: {
             0: 'Idle',
             1: 'Request',
             2: 'Demand',
             3: 'Post Circulation',
             4: 'Off',
           },
         }),
         business_situation_operating_status_TR04_102: 'Preheat Control State',
         business_situation_operating_status_TR04_102_list: JSON.stringify({
           list: {
             0: 'Idle',
             1: 'Request',
             2: 'Demand',
             3: 'Post Circulation',
             4: 'Off',
           },
         }),
         business_situation_operating_status_TR04_103:
           'Anti-Legionella control state',
         business_situation_operating_status_TR04_103_list: JSON.stringify({
           list: {
             0: 'Idle',
             1: 'Request',
             2: 'Demand',
             3: 'Post Circulation',
             4: 'Off',
           },
         }),
         business_situation_operating_status_TR04_104: 'Cooling Control state',
         business_situation_operating_status_TR04_104_list: JSON.stringify({
           list: {
             0: 'Idle',
             1: 'Request',
             2: 'Demand',
             3: 'Post Cooling',
             4: 'Off',
             5: 'Pre Circulation',
             6: 'Init',
           },
         }),

         business_situation_operating_status_TR04_105: 'Alarm Code',
         business_situation_operating_status_TR04_106: 'Software version',
         business_situation_operating_status_TR04_107:
           'StepperMotor1 Actual Position',
         business_situation_operating_status_TR04_108:
           'StepperMotor2 Actual Position',
         business_situation_operating_status_TR04_109: 'Pump',
         business_situation_operating_status_TR04_109_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         business_situation_operating_status_TR04_110: 'Valve1',
         business_situation_operating_status_TR04_110_list: JSON.stringify({
           list: {
             0: 'Position: Heating',
             1: 'Position: Cooling',
           },
         }),
         business_situation_operating_status_TR04_112_list: JSON.stringify({
           list: {
             0: 'Heating or demand',
             1: 'Cooling',
           },
         }),
         business_situation_operating_status_TR04_113: 'Room thermostat input',
         business_situation_operating_status_TR04_113_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         business_situation_operating_status_TR04_114: 'OpenTherm Indicator',
         business_situation_operating_status_TR04_114_list: JSON.stringify({
           list: {
             0: 'Inactive',
             1: 'Active',
           },
         }),
         business_situation_operating_status_TR04_115: 'Appliance Type',

         // Business situation - TR04
         business_situation_measured_values_TR04_title: 'Measurements',
         business_situation_measured_values_TR04_200: 'Flow rate',
         business_situation_measured_values_TR04_201: 'DHW Out temperature',
         business_situation_measured_values_TR04_202: 'Primary supply',
         business_situation_measured_values_TR04_203: 'Primary return',
         business_situation_measured_values_TR04_205: 'Secondary CH Supply',
         business_situation_measured_values_TR04_206: 'Secondary CH Return',
         business_situation_measured_values_TR04_204: 'CH calculated setpoint',
         business_situation_measured_values_TR04_207: 'OT Room Temperature',
         business_situation_measured_values_TR04_208: 'OT CH Setpoint',
         business_situation_measured_values_TR04_209: 'Outdoor Temperature',
         business_situation_measured_values_TR04_210: 'Water pressure',
         business_situation_measured_values_TR04_213: 'Primary DHW Return',
         business_situation_measured_values_TR04_214: 'Primary CH Return',

         // Operating time - TR04
         business_situation_operating_time_TR04_title: 'Operating Time',
         business_situation_operating_time_TR04_800: 'System Run Time',
         business_situation_operating_time_TR04_801: 'CH Burn Time',
         business_situation_operating_time_TR04_802: 'Cooling Time',
         business_situation_operating_time_TR04_803: 'DHW Burn Time',
         business_situation_operating_time_TR04_804: 'Number of tappings',

         // Lockout History-TR04
         lockout_time_TR04_title: 'Lockout History',
         lockout_time_TR04_820: 'Lock-out 1',
         lockout_time_TR04_821: 'Lock-out 2',
         lockout_time_TR04_822: 'Lock-out 3',
         lockout_time_TR04_823: 'Lock-out 4',
         lockout_time_TR04_824: 'Lock-out 5',
         lockout_time_TR04_825: 'Lock-out 6',
         lockout_time_TR04_826: 'Lock-out 7',
         lockout_time_TR04_827: 'Lock-out 8',
         lockout_time_TR04_828: 'Lock-out 9',
         lockout_time_TR04_829: 'Lock-out 10',
         lockout_time_TR04_830: 'Lock-out 11',
         lockout_time_TR04_831: 'Lock-out 12',
         lockout_time_TR04_832: 'Lock-out 13',
         lockout_time_TR04_833: 'Lock-out 14',
         lockout_time_TR04_834: 'Lock-out 15',
         lockout_time_TR04_835: 'Lock-out 16',
         lockout_time_TR04_836: 'Lock-out history time 1',
         lockout_time_TR04_837: 'Lock-out history time 2',
         lockout_time_TR04_838: 'Lock-out history time 3',
         lockout_time_TR04_839: 'Lock-out history time 4 ',
         lockout_time_TR04_840: 'Lock-out history time 5 ',
         lockout_time_TR04_841: 'Lock-out history time 6 ',
         lockout_time_TR04_842: 'Lock-out history time 7',
         lockout_time_TR04_843: 'Lock-out history time 8',
         lockout_time_TR04_844: 'Lock-out history time 9',
         lockout_time_TR04_845: 'Lock-out history time 10',
         lockout_time_TR04_846: 'Lock-out history time 11',
         lockout_time_TR04_847: 'Lock-out history time 12',
         lockout_time_TR04_848: 'Lock-out history time 13',
         lockout_time_TR04_849: 'Lock-out history time 14',
         lockout_time_TR04_850: 'Lock-out history time 15',
         lockout_time_TR04_851: 'Lock-out history time 16',
         // Blocking History-TR04
         blocking_history_TR04_860: 'Blocking 1',
         blocking_history_TR04_861: 'Blocking 2',
         blocking_history_TR04_862: 'Blocking 3',
         blocking_history_TR04_863: 'Blocking 4',
         blocking_history_TR04_864: 'Blocking 5',
         blocking_history_TR04_865: 'Blocking 6',
         blocking_history_TR04_866: 'Blocking 7',
         blocking_history_TR04_867: 'Blocking 8',
         blocking_history_TR04_868: 'Blocking 9',
         blocking_history_TR04_869: 'Blocking 10',
         blocking_history_TR04_870: 'Blocking 11',
         blocking_history_TR04_871: 'Blocking 12',
         blocking_history_TR04_872: 'Blocking 13',
         blocking_history_TR04_873: 'Blocking 14',
         blocking_history_TR04_874: 'Blocking 15',
         blocking_history_TR04_875: 'Blocking 16',
         blocking_history_TR04_876: 'Blocking history time 1',
         blocking_history_TR04_877: 'Blocking history time 2',
         blocking_history_TR04_878: 'Blocking history time 3',
         blocking_history_TR04_879: 'Blocking history time 4',
         blocking_history_TR04_880: 'Blocking history time 5',
         blocking_history_TR04_881: 'Blocking history time 6',
         blocking_history_TR04_882: 'Blocking history time 7',
         blocking_history_TR04_883: 'Blocking history time 8',
         blocking_history_TR04_884: 'Blocking history time 9',
         blocking_history_TR04_885: 'Blocking history time 10',
         blocking_history_TR04_886: 'Blocking history time 11',
         blocking_history_TR04_887: 'Blocking history time 12',
         blocking_history_TR04_888: 'Blocking history time 13',
         blocking_history_TR04_889: 'Blocking history time 14',
         blocking_history_TR04_890: 'Blocking history time 15',
         blocking_history_TR04_891: 'Blocking history time 16',
         // Warmtapwater - TR04
         settings_dhw_warm_tap_water_TR04_title: 'Settings hot water',
         settings_dhw_warm_tap_water_TR04_300: 'DHW setpoint',
         settings_dhw_warm_tap_water_TR04_301: 'Preheat mode',
         settings_dhw_warm_tap_water_TR04_301_list: JSON.stringify({
           list: { 0: 'Eco', 1: 'Anti freeze', 2: 'Comfort', 3: 'Dynamic' },
         }),
         settings_dhw_warm_tap_water_TR04_302: 'Preheat Comfort setpoint',
         settings_dhw_warm_tap_water_TR04_303: 'Flow rate start threshold',
         settings_dhw_warm_tap_water_TR04_304: 'DHW Mode',
         settings_dhw_warm_tap_water_TR04_304_list: JSON.stringify({
           list: {
             0: 'Off',
             8: 'PID Controlled',
           },
         }),
         settings_dhw_warm_tap_water_TR04_305: 'DHW Primary Boost Exit Time',
         settings_dhw_warm_tap_water_TR04_306:
           'DHW Mode8 Dynamic Setpoint Active',
         settings_dhw_warm_tap_water_TR04_306_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         settings_dhw_warm_tap_water_TR04_307: 'DHW Actual Setpoint',

         // Thermal disinfection - TR04
         settings_thermal_disinfection_TR04_title:
           'Settings Thermal disinfection',
         settings_thermal_disinfection_TR04_400: 'Aleg enabled',
         settings_thermal_disinfection_TR04_400_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         settings_thermal_disinfection_TR04_401: 'Aleg burn time',
         settings_thermal_disinfection_TR04_402: 'Aleg burn time',
         settings_thermal_disinfection_TR04_403: 'Aleg wait time',

         // Heating - TR04
         heating_and_cooling_settings_heating_TR04_title: 'Settings heating',
         heating_and_cooling_settings_heating_TR04_500: 'CH Max Setpoint',
         heating_and_cooling_settings_heating_TR04_501: 'CH Min Setpoint',
         heating_and_cooling_settings_heating_TR04_502: 'OutdoorResetMin',
         heating_and_cooling_settings_heating_TR04_503: 'OutdoorResetMax',
         heating_and_cooling_settings_heating_TR04_504: 'WarmWeatherShut',
         heating_and_cooling_settings_heating_TR04_506:
           'Maximum primary return',
         heating_and_cooling_settings_heating_TR04_507:
           'Max Primary Return perc',
         heating_and_cooling_settings_heating_TR04_508:
           'Delta Prim CH Setpoint',
         heating_and_cooling_settings_heating_TR04_509: 'Delta Prim min',
         heating_and_cooling_settings_heating_TR04_510: 'Max Heating Temp',
         heating_and_cooling_settings_heating_TR04_514: 'CH Setpoint',
         heating_and_cooling_settings_heating_TR04_515: 'CH Mode',
         heating_and_cooling_settings_heating_TR04_515_list: JSON.stringify({
           list: {
             0: 'PID',
             8: 'Open/Close',
             9: 'Primary Delta-T',
             10: 'Secondary Delta-T',
           },
         }),

         // Cooling - TR04
         heating_and_cooling_settings_cooling_TR04_title: 'Settings cooling',
         heating_and_cooling_settings_cooling_TR04_600: 'CoolTempSetpoint',
         heating_and_cooling_settings_cooling_TR04_601:
           'Cool MaxPrimary Return',
         heating_and_cooling_settings_cooling_TR04_602:
           'Cool % of Max Setpoint compensation',
         heating_and_cooling_settings_cooling_TR04_605: 'Max Cooling Temp',
         heating_and_cooling_settings_cooling_TR04_606: 'Cool setpoint min',
         heating_and_cooling_settings_cooling_TR04_607: 'Cool setpoint max',
         heating_and_cooling_settings_cooling_TR04_608: 'Condens protection',
         heating_and_cooling_settings_cooling_TR04_608_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         heating_and_cooling_settings_cooling_TR04_609: 'Condens timer',
         heating_and_cooling_settings_cooling_TR04_610:
           'Condens Increased setpoint',
         heating_and_cooling_settings_cooling_TR04_611: 'Cooling enable',
         heating_and_cooling_settings_cooling_TR04_611_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),

         // Secondary General - TR04
         heating_and_cooling_settings_secondary_general_TR04_title:
           'Settings general',
         heating_and_cooling_settings_secondary_general_TR04_512:
           'CH Min Pressure',
         heating_and_cooling_settings_secondary_general_TR04_513:
           'CH Max Pressure',
         heating_and_cooling_settings_secondary_general_TR04_603:
           'CoolHeatWaitingTime',
         heating_and_cooling_settings_secondary_general_TR04_604:
           '6-way valve waiting time',

         // Manual Operation - TR04
         settings_manual_operation_TR04_title: 'Manual control',
         settings_manual_operation_TR04_700: 'Manual control enable',
         settings_manual_operation_TR04_700_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         settings_manual_operation_TR04_701: 'MCV-1 Manual control',
         settings_manual_operation_TR04_702: 'MCV-2 Manual control',
         settings_manual_operation_TR04_703: 'Manual (CH) Pump setting',
         settings_manual_operation_TR04_703_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         settings_manual_operation_TR04_704: 'Manual 6-way valve position',
         settings_manual_operation_TR04_704_list: JSON.stringify({
           list: {
             0: 'Heating',
             1: 'Cooling',
           },
         }),
         settings_manual_operation_TR04_707: 'MCV-1 Manual control[%]',
         settings_manual_operation_TR04_708: 'MCV-2 Manual control[%]',
         settings_manual_operation_TR04_709: 'Manual control timeout',
         // DeltaP Parameters(LIN-PUMP)
         deltap_parameters_TR04_1870_1871: 'Customer installation pressure',
         deltap_parameters_TR04_1872_1873: 'DeltaP KV-Value',
         deltap_parameters_TR04_1874_1875: 'DeltaP Max Pressure',
         device_status_name_TR03: 'Name (TR03)',
         device_status_name_TR04: 'Name (TR04)',
         device_single_set_register_device_tr_type_unavailable:
           'Device Type is unavailable for the whole project',
         sidebar_terms_and_conditions_title: 'Terms and Conditions',
         sidebar_support_text: 'Questions or comments? Email',
         sidebar_support_text_copied: 'Email Copied!',
         settings_menu_legal_document_title: 'Legal Documents',
         legal_documents_name_en_required_form_error:
           'Document Name (EN) is required',
         legal_documents_name_nl_required_form_error:
           'Document Name (NL) is required',
         legal_documents_name_fr_required_form_error:
           'Document Name (FR) is required',
         legal_documents_name_de_required_form_error:
           'Document Name (DE) is required',
         legal_documents_name_dk_required_form_error:
           'Document Name (DK) is required',
         legal_documents_title_en_required_form_error:
           'Document Popup Title (EN) is required',
         legal_documents_title_nl_required_form_error:
           'Document Popup Title (NL) is required',
         legal_documents_title_fr_required_form_error:
           'Document Popup Title (FR) is required',
         legal_documents_title_de_required_form_error:
           'Document Popup Title (DE) is required',
         legal_documents_title_dk_required_form_error:
           'Document Popup Title (DK) is required',
         legal_documents_checkbox_label_en_required_form_error:
           'Document Checkbox Label (EN) is required',
         legal_documents_checkbox_label_nl_required_form_error:
           'Document Checkbox Label (NL) is required',
         legal_documents_checkbox_label_fr_required_form_error:
           'Document Checkbox Label (FR) is required',
         legal_documents_checkbox_label_de_required_form_error:
           'Document Checkbox Label (DE) is required',
         legal_documents_checkbox_label_dk_required_form_error:
           'Document Checkbox Label (DK) is required',
         legal_documents_document_url_required_form_error:
           'Legal Document is required',
         legal_documents_version_required_form_error: 'Version is required',
         legal_documents_type_required_form_error: 'Document Type is required',
         legal_documents_add_form_success:
           'Legal Document is successfully created',
         legal_documents_form_api_error:
           'Failed to created Legal Document due to Internal Server Alarm',
         legal_documents_form_legal_document_name_en_field:
           'Document Name (EN)',
         legal_documents_form_legal_document_name_nl_field:
           'Document Name (NL)',
         legal_documents_form_legal_document_name_fr_field:
           'Document Name (FR)',
         legal_documents_form_legal_document_name_de_field:
           'Document Name (DE)',
         legal_documents_form_legal_document_name_dk_field:
           'Document Name (DK)',
         legal_documents_form_legal_document_title_en_field:
           'Document Popup Title (EN)',
         legal_documents_form_legal_document_title_nl_field:
           'Document Popup Title (NL)',
         legal_documents_form_legal_document_title_fr_field:
           'Document Popup Title (FR)',
         legal_documents_form_legal_document_title_de_field:
           'Document Popup Title (DE)',
         legal_documents_form_legal_document_title_dk_field:
           'Document Popup Title (DK)',
         legal_documents_form_legal_document_checkbox_label_en_field:
           'Document Checkbox Label (EN)',
         legal_documents_form_legal_document_checkbox_label_nl_field:
           'Document Checkbox Label (NL)',
         legal_documents_form_legal_document_checkbox_label_fr_field:
           'Document Checkbox Label (FR)',
         legal_documents_form_legal_document_checkbox_label_de_field:
           'Document Checkbox Label (DE)',
         legal_documents_form_legal_document_checkbox_label_dk_field:
           'Document Checkbox Label (DK)',
         legal_documents_form_legal_document_document_url_field:
           'Upload Legal Document (PDF)',
         legal_documents_form_legal_document_version_field: 'Version',
         legal_documents_form_legal_document_type_field: 'Document Type',
         legal_documents_form_legal_is_mandatory_field:
           'Is Document Manadatory',
         legal_documents_form_add_legal_document_button: 'Add Document',
         legal_documents_form_cancel_button: 'Cancel',
         add_legal_documents_form_header: 'Add Legal Document',
         add_legal_documents_bread_crumb_first_link: 'Add Legal Document',
         legal_documents_bread_crumb_main_title: 'Legal Documents',
         legal_documents_edit_form_success:
           'Legal Document is successfully updated',
         legal_documents_form_edit_legal_document_button: 'Edit Document',
         edit_legal_documents_form_header: 'Edit Legal Document',
         edit_legal_documents_bread_crumb_first_link: 'Edit Legal Document',
         loginTermsOfUseInfo: 'To continue, please agree to the Terms of Use',
         legal_documents_table_document_name_en: 'Document Name (EN)',
         legal_documents_table_document_title_en: 'Document Popup Title (EN)',
         legal_documents_table_document_checkbox_label_en:
           'Document Checkbox Label (EN)',
         legal_documents_table_document_document_url: 'Legal Document',
         legal_documents_table_document_type: 'Document Type',
         legal_documents_table_version: 'Version',
         legal_documents_table_updated_at: 'Updated At',
         legal_documents_table_is_default: 'Status',
         legal_documents: 'Legal Documents',
         legal_documents_add_new: 'Add Legal Document',
         legal_documents_table_row_per_page: 'Rows per page',
         legal_documents_no_record_found: 'No Records Found',
         legal_documents_filter_delete_button: 'Delete',
         legal_documents_status_default: 'Default',
         legal_documents_status_archived: 'Archived',
         legal_documents_all: 'All',
         legal_documents_filter_search: 'Search',
         legal_documents_default_document_success_message:
           '"LEGAL_DOC_TYPE" default Legal Document is successfully updated.',
         legal_documents_bulk_delete_button: 'Delete',
         legal_documents_bulk_delete_success_message:
           'Legal Document(s) are successfully deleted',
         legal_documents_bulk_delete_error_message:
           'Please select multiple records to delete',
         legal_documents_bulk_delete_title: 'Are you sure?',
         legal_documents_bulk_delete_subtitle: 'You want to delete Records?',
         legal_documents_upload_success:
           'Document is upload successfully!, please submit the changes.',
         legal_documents_upload_file_type_error: 'Only PDF files are allowed.',
         legal_documents_upload_file_size_error:
           'File size should be less than 20 MB.',
         legal_documents_uploading_text: 'Uploading...',
         legal_documents_reset_legal_documents_status_modal_title:
           'Are you sure?',
         legal_documents_reset_legal_documents_status_modal_subtitle:
           'Users will have to accept the document again. Are you sure you want to continue?',
         legal_documents_reset_legal_documents_status_cancel_button: 'Cancel',
         legal_documents_reset_legal_documents_status_update_without_acceptance_request_button:
           'Update without Acceptance Request',
         legal_documents_reset_legal_documents_status_update_with_acceptance_request_button:
           'Update with Acceptance Request',
         legal_documents_table_already_default_document_message:
           'This document is already set as a default "LEGAL_DOC_TYPE" document',
         cookie_banner_main_title: 'Manage Consent',
         cookie_banner_main_subtitle:
           'This website uses cookies to improve your user experience. By using our website you consent to all cookies in accordance with our Cookie Policy.',
         cookie_banner_essential_cookie_title: 'Essential Cookies',
         cookie_banner_essential_cookie_status_title: 'Always Active',
         cookie_banner_essential_cookie_subtitle:
           'Essential Cookies are crucial for a website basic functions, such as keeping you logged in, remembering settings, and ensuring security. They are necessary for the site to work properly and cannot be turned off.',
         cookie_banner_tracking_cookie_title: 'Tracking Cookies',
         cookie_banner_tracking_cookie_subtitle:
           'Tracking Cookies used by Google Analytics collect data on how you interact with the website, such as pages visited and time spent. This helps us understand user behavior and improve website performance. These cookies are optional and can be turned off.',
         cookie_banner_accept_button_title: 'Accept',
         cookie_banner_decline_button_title: 'Decline',
         cookie_banner_preferences_button_title: 'Preferences',
         cookie_banner_save_preferences_button_title: 'Save',
         settings_cookie_consent_title: 'Manage Cookies Consent',
         settings_cookie_tracking_cookies_title: 'Tracking Cookies',
         settings_cookie_tracking_cookies_success_message:
           'Tracking Cookies Status is updated successfully',
         settings_menu_partner_setting_title: 'Portal Settings',
         partner_settings_form_header: 'Portal Settings',
         partner_settings_form_logo_title: 'Logo',
         partner_settings_form_primary_color_title: 'Primary Color',
         partner_settings_form_secondary_color_title: 'Secondary Color',
         partner_settings_form_submit_button: 'Save Changes',
         partner_settings_form_white_label_success_message:
           'White-label is updated successfully.',
         devices_bulk_edit_registers_tr_device_type_unavailable:
           'Selected devices have no proper TR Type. Please perform device commissioning the devices',
         commissioning_form_stepper_validation_sim_connectivity_title:
           'Connectivity',
         commissioning_form_stepper_validation_sim_connectivity_default_setting:
           'Active',
         commissioning_form_stepper_validation_sim_connectivity_success:
           'Connectivity Active',
         commissioning_form_stepper_validation_sim_connectivity_error:
           'Connectivity Alarm',
         commissioning_form_stepper_validation_sim_connectivity_loading_title:
           'Connectivity check takes around 1 minute',
         device_single_device_settings_fetch_latest_settings_button_v2:
           'Data Collect',
         kong_account_created_subject:
           'Fortes Data Management - New API Gateway Account Created',
         kong_admin_user_form_create_success_message:
           'Kong Admin User created successfully!',
         kong_client_user_form_create_success_message:
           'Kong Client User created successfully!',
         kong_admin_user_form_update_success_message:
           'Kong Admin User updated successfully!',
         kong_client_user_form_update_success_message:
           'Kong Client User updated successfully!',
         kong_admin_user_form_error_message: 'Internal Server Alarm',
         kong_client_user_form_error_message: 'Internal Server Alarm',
         kong_admin_user_form_unique_error_message:
           'Email must be unique in Kong',
         kong_client_user_form_unique_error_message:
           'Email must be unique in Kong',
         kong_user_admin_single_api_documentation_link_label:
           'OpenAPI Specification',
         kong_client_bulk_deleted_message:
           '{{ USERS_COUNT }} Kong Clients are deleted successfully',
         devices_form_project_disabled_field:
           'The Project Field is disabled because this device is a service device',
         partner_settings_white_label: 'White Label',
         partner_settings_general_settings: 'General Setting',
         partner_settings_general_settings_partner_locales:
           'Available Languages',
         partner_settings_form_general_settings_success_message:
           'General Settings are updated successfully.',
         commissioning_form_article_number_is_missing_error:
           'Article Number is missing',
         commissioning_form_stepper_validation_sim_connectivity_check_started_title:
           'Started Connectivity Check',
         commissioning_form_stepper_validation_sim_connectivity_check_success_title:
           'Connectivity Success',
         commissioning_form_stepper_validation_project_modbus_settings_check_started_title:
           'Project Modbus Setting Check Started',
         commissioning_form_stepper_validation_project_modbus_settings_success_title:
           'Project Modbus Setting is Enabled',
         commissioning_form_stepper_validation_project_modbus_settings_disabled_title:
           'No Modbus specified in Project',
         commissioning_form_stepper_validation_sim_connectivity_missing_sim_number_error_event:
           'Connectivity Alarm - SIM Number is missing in the database',
         commissioning_form_stepper_validation_sim_connectivity_maxitel_error_event:
           'Connectivity Alarm - Network Provider API is not responding',
         commissioning_form_stepper_validation_firmware_is_less_then_2_title:
           'Device Firmware version i.e. ###DEVICE_FIRMWARE_VERSION### must be 2.x.x, Please perform an OTA operation to update the firmware version',
         commissioning_form_stepper_validation_firmware_is_missing_title:
           'Device Firmware version is missing',
         commissioning_form_stepper_validation_baud_rate_fetch_failed_error_event:
           'Modbus - Unable to Fetch Baud Rate. Expected Baud Rate was ###BAUD_RATE###',
         commissioning_form_stepper_validation_baud_rate_set_failed_error_event:
           'Modbus - Unable to Set Baud Rate ###BAUD_RATE###',
         commissioning_form_stepper_validation_modbus_connection_error_event:
           'Modbus - Not Connected',
         commissioning_form_stepper_validation_modbus_connection_success_event:
           'Modbus - Connected',
         commissioning_form_stepper_validation_mbus_meters_check_success_event:
           'Mbus - Device Mbus Meters Count i.e. ###DEVICE_MBUS_METERS_COUNT### matched with Project Settings Meters Count i.e. ###PROJECT_SETTINGS_MBUS_METERS_COUNT###',
         commissioning_form_stepper_validation_mbus_meters_check_error_event:
           "Mbus - Device Mbus Meters Count i.e. ###DEVICE_MBUS_METERS_COUNT### doesn't match with Project Settings Meters Count i.e. ###PROJECT_SETTINGS_MBUS_METERS_COUNT###",
         commissioning_form_stepper_validation_complete_success_event:
           'Validation process is successfully completed',
         device_bulk_insert_form_header: 'Device Insert',
         devices_form_order_type_field: 'Order Type',
         partner_settings_general_settings_distributor_article_number_label:
           'HIU Settings',
         partner_settings_general_settings_distributor_article_number_enable_settings_label:
           'Enable Distributor Article and Serial Number',
         partner_settings_general_settings_distributor_article_number_disable_settings_label:
           'Disable Distributor HIU Settings',
         devices_partner_serial_number:
           'Distributor Serial Number heat interface unit',
         devices_partner_article_number_field:
           'Distributor Article number heat interface unit',
         commissioning_form_stepper_validation_baud_rate_retries_label:
           'Baud Rate Retries',
         commissioning_form_stepper_validation_modbus_retries_label:
           'Modbus Connection Retries',
         commissioning_form_header_updated_information_title:
           'Updated Information',
         commissioning_form_header_report_title: 'Report',
         commissioning_form_header_report_connectivity:
           'Connectivity Step Status: ',
         commissioning_form_header_report_modbus_validation_title:
           'Modbus Validation: ',
         commissioning_form_header_report_mbus_validation_title:
           'Mbus Validation: ',
         commissioning_form_header_report_failed_status_title: 'Failed',
         commissioning_form_header_report_passed_status_title: 'Passed',
         commissioning_form_header_report_not_status_title: 'N/A',
         commissioning_form_stepper_validation_sim_connectivity_maxitel_success_event:
           'Network Provider API is working fine',
         project_single_project_error_devices_tab: 'Project Alarm History',
         device_monitoring_project_active_device_errors_counters_title:
           'Active Alarm Devices Counters',
         device_monitoring_project_active_device_errors_list_title:
           'Active Alarm Devices List',
         device_v2_settings_tab_general: 'General',
         device_v2_settings_tab_modbus: 'Modbus',
         device_v2_settings_tab_mbus: 'Mbus',
         device_single_device_settings_hiu_reset_device_v2: 'HIU Reset',
         device_single_device_settings_hiu_reset_message_forwarded:
           'Device HIU Modbus Reset message is forwarded to device',
         device_single_device_settings_interval_field: 'Interval',
         device_single_device_settings_interval_in_seconds_field:
           'Interval (Minutes)',
         device_single_device_settings_mbus_interval_message_forwarded:
           'Set Mbus Interval message is forwarded to device',
         device_single_device_settings_mbus_interval_error_message_forwarded:
           'Mbus Interval must be greater than or equal to 0',
         device_single_device_settings_mbus_interval: 'Mbus Interval',
         mbus_export_is_validated_field: 'Is Validated',
         device_single_device_settings_fqdn_field: 'Device FQDN',
         device_single_device_settings_fqdn_field_default_option: 'Select FQDN',
         device_single_device_settings_fqdn_error:
           'Please select a FQDN to proceed',
         device_single_device_settings_fqdn_message_forwarded:
           'FQDN message is forwarded to the device',
         projects_table_online_devices: 'Online Devices',
         add_subscriptions_form_header: 'Create Subscription Extension',
         subscriptions_bread_crumb_main_title: 'Subscriptions',
         add_subscriptions_bread_crumb_first_link:
           'Create Subscription Extension',
         subscriptionOrderNumber_required_form_error:
           'Subscription Order Number is required',
         subscriptionPeriod_required_form_error:
           'Subscription Period is required',
         projectId_required_form_error: 'Project is required',
         clientId_required_form_error: 'Client is required',
         subscriptionType_required_form_error: 'Subscription Type is required',
         subscription_form_subscriptionOrderNumber_field:
           'Subscription Order Number',
         subscription_form_subscriptionPeriod_field:
           'Subscription Period (months)',
         subscription_form_projectId_field: 'Project',
         subscription_form_clientId_field: 'Client',
         subscription_form_subscriptionType_field: 'Subscription Type',
         subscription_form_subscriptionStartDate_field:
           'Subscription Start Date',
         subscription_form_subscriptionEndDate_field:
           'Subscription Expected End Date',
         subscription_form_description_field: 'Description',
         subscription_form_notes_field: 'Notes',
         subscription_form_add_subscription_button: 'Save Changes',
         subscription_form_cancel_button: 'Cancel',
         subscription_add_form_success: 'Subscription is successfully created',
         subscription_form_api_error:
           'Failed to created Subscription due to Internal Server Alarm',
         subscriptions_form_header: 'Subscriptions',
         subscriptions_add_new: 'Create Subscription Extension',
         subscriptions_table_project: 'Project',
         subscriptions_table_client: 'Client',
         subscriptions_table_start_date: 'Start Date',
         subscriptions_table_end_date: 'End Date',
         subscriptions_table_subscriptionPeriod: 'Duration',
         subscriptions_table_total_device: 'Total Devices',
         subscriptions_table_total_credit: 'Total Credits',
         subscriptions_table_credit_used: 'Credits Used',
         subscriptions_table_credit_left: 'Credits Left',
         subscriptions_table_month_to_zero_credit: 'Months to Zero Credit',
         subscriptions_table_status: 'Status',
         subscriptions_table_loading: 'Loading...',
         subscriptions_no_record_found: 'No Records Found',
         subscriptions_all: 'All',
         subscriptions_active: 'Active',
         subscriptions_inactive: 'Inactive',
         subscriptions_expired: 'Expired',
         subscriptions_expiring_soon: 'Expiring Soon',
         subscriptions_table_row_per_page: 'Rows per page',
         subscriptions_filter_search: 'Search',
         subscriptions_filters: 'Filters',
         sidebar_subscriptions_overview: 'Subscriptions Overview',
         sidebar_subscriptions: 'Subscriptions',
         project_single_project_subscription_devices_tab:
           'Device Subscriptions',
         project_single_project_subscription_overview_tab:
           'Subscription Extensions',
         sidebar_subscriptions_analytics: 'Subscription Analytics',
         subscriptions_analytics_form_header: 'Subscription Analytics',
         devices_form_order_type_order_with_hiu: 'Order with HIU',
         devices_form_order_type_order_without_hiu: 'Order without HIU',
         subscription_status_overview_title: 'Device Subscription Overview',
         subscription_analytics_data_missing_message: 'Data is not available',
         subscription_analytics_data_loading_message: 'Data is loading ...',
         subscription_status_overview_subscriptions: 'Subscriptions',
         subscription_status_overview_expiring_soon: 'Expiring soon',
         subscription_status_overview_not_expiring_in_3_months:
           'Not expiring in 3 months',
         subscription_status_overview_expired: 'Expired',
         subscription_analytics_subscriptions_expiring_soon_title:
           'Project Subscriptions Expiring Soon',
         subscription_analytics_subscriptions_expiring_soon_2_weeks: '2 Weeks',
         subscription_analytics_subscriptions_expiring_soon_1_month: '1 month',
         subscription_analytics_subscriptions_expiring_soon_2_months:
           '2 months',
         subscription_analytics_subscriptions_expiring_soon_3_months:
           '3 months',
         subscription_analytics_subscriptions_expiring_soon_6_months:
           '6 months',
         subscription_analytics_subscriptions_expiring_soon_12_months:
           '12 months',
         subscription_analytics_subscriptions_expiring_soon_no_of_subscriptions:
           'No. of Subscriptions',
         subscription_analytics_projects_credits_timeline_title:
           'Projects Credits Timeline',
         subscription_analytics_projects_credits_timeline_no_of_credits:
           'No. of Credits',
         subscription_analytics_projects_credits_timeline_months: 'Months',
         subscription_analytics_projects_credits_timeline_jan: 'Jan',
         subscription_analytics_projects_credits_timeline_feb: 'Feb',
         subscription_analytics_projects_credits_timeline_mar: 'Mar',
         subscription_analytics_projects_credits_timeline_apr: 'Apr',
         subscription_analytics_projects_credits_timeline_may: 'May',
         subscription_analytics_projects_credits_timeline_jun: 'Jun',
         subscription_analytics_projects_credits_timeline_jul: 'Jul',
         subscription_analytics_projects_credits_timeline_aug: 'Aug',
         subscription_analytics_projects_credits_timeline_sep: 'Sep',
         subscription_analytics_projects_credits_timeline_oct: 'Oct',
         subscription_analytics_projects_credits_timeline_nov: 'Nov',
         subscription_analytics_projects_credits_timeline_dec: 'Dec',
         subscription_analytics_projects_credits_consumed: 'Credits Consumed',
         subscription_analytics_projects_credits_details_active_subscriptions:
           'Active Subscriptions',
         subscription_analytics_projects_credits_details_expiring_soon:
           'Expiring soon',
         subscription_analytics_projects_credits_details_expired_subscriptions:
           'Expired Subscriptions',
         subscription_analytics_projects_credits_details_expiring_in_3_months:
           'Expiring in 3 months',
         subscription_analytics_projects_credits_details_expiring_in_6_months:
           'Expiring in 6 months',
         partner_settings_general_settings_partner_timezone: 'Default Timezone',
         distributor_timezone_modal_update_distributor_and_external_api_timezone_only:
           'Update Distributor and External API timezone only',
         distributor_timezone_modal_update_distributor_and_all_users_timezone:
           'Update Distributor and all users timezone',
         distributor_timezone_modal_cancel: 'Cancel',
         distributor_timezone_modal_title: 'Are you sure?',
         distributor_timezone_modal_subtitle:
           'You want to update the timezone for the distributor module?',
         distributor_timezone_modal_success_message:
           'Timezone is successfully updated',
         distributor_timezone_modal_error_message: 'Timezone updation failed',
         commissioning_email_commissioned_at_field: 'Commissioned at',
         commissioning_email_commissioned_by_field: 'Commissioned by',
         commissioning_email_commissioned_status_field: 'Commissioned status',
         commissioning_email_commissioned_completed_hiu_details_field:
           'Completed HIU details',
         commissioning_email_mobile_connectivity_validation_field:
           'Mobile connectivity validation',
         commissioning_email_modbus_connectivity_validation_field:
           'Modbus connectivity validation',
         commissioning_email_mbus_connectivity_validation_field:
           'Mbus connectivity validation',
         commissioning_email_updated_address_details_field:
           'Updated address details',
         commissioning_email_title: 'Mercurius Commissioning Report',
         commissioning_email_commissioned_by_message:
           'has proceeded to complete the commissioning process.',
         commissioning_email_subtitle:
           'Please find below the commissioning report of the recently commissioned Mercurius in your project.',
         commissioning_email_information:
           'generates this report after completing the Mercurius commissioning process. This will allow you or your organisation to take timely action to resolve any issues with connecting the heating interface units and ensure correct commissioning.',
         commissioning_email_questions:
           'Questions? Please contact <a href="mailto:support@fortesdata.com"><span style="font-weight: 600; color: {{ primaryColor }};">support@fortesdata.com</span></a> for further support.',
         commissioning_none_added_status: 'None Added',
         commissioning_partially_updated_status: 'Partially Updated',
         commissioning_completed_status: 'Completed',
         commissioning_hiu_failed: 'Failed',
         commissioning_hiu_passed: 'Passed',
         subscription_credits_overview_title: 'Project Credits Overview',
         subscription_credits_positive_credits: 'Positive',
         subscription_credits_negative_credits: 'Negative',
         partner_settings_general_settings_partner_locale: 'Default Language',
         distributor_locale_modal_update_distributor_locale_only:
           'Update Default Language only',
         distributor_locale_modal_update_distributor_and_all_users_locale:
           'Update Distributor and all users locale',
         distributor_locale_modal_cancel: 'Cancel',
         distributor_locale_modal_title: 'Are you sure?',
         distributor_locale_modal_subtitle:
           'You want to update the locale for the distributor module?',
         distributor_locale_modal_success_message:
           'Language is successfully updated',
         distributor_locale_modal_error_message: 'Language updation failed',
         users_form_timezone_field: 'Timezone',
         users_form_locale_field: 'Language',
         error_check_details_table_new_tab: 'New',
         error_check_details_table_resolved_tab: 'Resolved',
         error_check_details_table_active_tab: 'Active',
         error_check_details_table_error_status: 'Alarm Status',
         error_check_details_table_error: 'Alarm Code',
         error_check_details_table_error_at: 'Alarm At',
         partner_settings_general_settings_distributor_serial_number_and_article_number_settings_label:
           'Distributor Serial, Article and Order Number',
         kong_user_admin_single_client_label: 'Client',
         commissioning_updated_information_title: 'Updated Information',
         subscription_form_customerReference_field: 'Customer Reference',
         subscriptionCustomerReference_required_form_error:
           'Customer Reference is required',
         subscription_previous_credits_left: 'Previous Credits Left',
         subscription_new_credits_added: 'New Credits Added',
         subscription_actual_credits_available: 'Actual Credits Available',
         subscription_start_date: 'Start Date',
         subscription_expected_expiry_date: 'Expected Expiry Date',
         subscription_created_at: 'Created At',
         subscription_created_by: 'Created By',
         subscription_notes_detail_for_users:
           '(For Fortes Internal Use Only): Sales notes, follow-ups, and other relevant information can be documented here.',
         subscription_extension_overview: 'Subscription Extension Overview',
         view_subscriptions_form_header: 'View Subscription',
         current_subscription_state: 'Current subscription state',
         subscription_analytics_projects_credits_details_expiring_in_1_month:
           'Expiring in 1 month',
         business_situation_measured_values_TR04_211:
           'Filtered Outdoor Temperature',
         business_situation_measured_values_TR04_212:
           'Secondary Incoming Cold Water',
         business_situation_measured_values_TR04_215: 'Primary DHW Supply',
         business_situation_measured_values_TR04_216: 'Primary CH Supply',
         appliance_types_applicable: 'Applicable',
         appliance_types_device_dashboard: 'Device Dashboard',
         appliance_types_register_name: 'Register Name',
         firmware_registers_TR04_80: 'Firmware Image status',
         firmware_registers_TR04_80_list: JSON.stringify({
           list: {
             0: 'Partial image (Receiving image)',
             1: 'Valid image (Ready for programming)',
             2: 'Corrupt image',
             3: 'Unknown image',
             4: 'Unknown image',
             5: 'Unknown image',
             6: 'Unknown image',
             7: 'Unknown image',
             8: 'Unknown image',
             9: 'Unknown image',
             10: 'Unknown image',
           },
         }),
         firmware_registers_TR04_81_list: JSON.stringify({
           list: {
             0: 'Firmware/application image',
             1: 'Defaults image',
             2: 'Unknown image',
             3: 'Unknown image',
             4: 'Unknown image',
             5: 'Unknown image',
             6: 'Unknown image',
             7: 'Unknown image',
             8: 'Unknown image',
             9: 'Unknown image',
             10: 'Unknown image',
           },
         }),
         firmware_registers_TR04_82_list: JSON.stringify({
           list: {
             0: 'Partial image (Receiving image)',
             1: 'Valid image (Ready for programming)',
             2: 'Corrupt image',
             3: 'Unknown image',
             4: 'Unknown image',
             5: 'Unknown image',
             6: 'Unknown image',
             7: 'Unknown image',
             8: 'Unknown image',
             9: 'Unknown image',
             10: 'Unknown image',
           },
         }),
         firmware_registers_TR04_98_list: JSON.stringify({
           list: {
             0: '°C bar',
             1: '°F bar',
             2: '°C psi',
             3: '°F psi',
           },
         }),
         firmware_registers_TR04_81: 'Firmware Image ID',
         firmware_registers_TR04_82: 'Defaults Image status',
         firmware_registers_TR04_98: 'Unit selection',
         firmware_registers_TR04_title: 'Firmware Registers',
         lin_pump_delta_parameters_TR04_title: 'LIN-Pump DeltaP Parameters',
         lin_pump_delta_parameters_TR04_1871: 'DeltaP Customer Installation',
         lin_pump_delta_parameters_TR04_1873: 'DeltaP Kv Value',
         lin_pump_delta_parameters_TR04_1875: 'NV DeltaP Max',
         appliance_types_form_cancel_button: 'Cancel',
         appliance_types_form_submit_button: 'Save Changes',
         custom_popover_211_short_description: 'Filtered Outdoor Temperature',
         custom_popover_212_short_description: 'Secondary Incoming Cold Water',
         custom_popover_215_short_description: 'Primary DHW Supply',
         custom_popover_216_short_description: 'Primary CH Supply',
         custom_popover_80_short_description: 'Firmware Image status',
         custom_popover_81_short_description: 'Firmware Image ID',
         custom_popover_82_short_description: 'Defaults Image status',
         custom_popover_98_short_description: 'Unit selection',
         custom_popover_1871_short_description: 'DeltaP Customer Installation',
         custom_popover_1873_short_description: 'DeltaP Kv Value',
         custom_popover_1875_short_description: 'NV DeltaP Max',
         edit_devices_device_name_unique_error: 'Device Name must be unique',
         edit_devices_serial_number_unique_error:
           'Serial Number Mercurius must be unique',
         edit_devices_description_error: 'Type Heat Interface Unit is required',
         edit_devices_box_serial_number_unique_error:
           'Serial Number Heat Interface Unit must be unique',
         edit_devices_article_number_error: 'Article Number is required',
         edit_devices_distributor_article_number_error:
           'Distributor Article Number is required',
         edit_devices_distributor_serial_number_unique_error:
           'Distributor Serial Number Heat Interface Unit must be unique',
         edit_devices_prod_order_nr_week_error:
           'Production order number is required',
         edit_devices_sim_card_number_error: 'Sim card number is required',
         edit_devices_production_date_error: 'Production Date is required',
         custom_popover_211_long_description: 'Filtered Outdoor Temperature',
         custom_popover_212_long_description: 'Secondary Incoming Cold Water',
         custom_popover_215_long_description: 'Primary DHW Supply',
         custom_popover_216_long_description: 'Primary CH Supply',
         custom_popover_80_long_description: 'Firmware Image status',
         custom_popover_81_long_description: 'Firmware Image ID',
         custom_popover_82_long_description: 'Defaults Image status',
         custom_popover_98_long_description: 'Unit selection',
         custom_popover_1871_long_description: 'DeltaP Customer Installation',
         custom_popover_1873_long_description: 'DeltaP Kv Value',
         custom_popover_1875_long_description: 'NV DeltaP Max',
         devices_form_backend_error_message:
           'There are some issues with the fields. Kindly review the form and correct the errors to proceed.',
         devices_sim_card_number_length_and_type_form_error:
           'SIM card number must be numeric and exactly 19 digits',
         devices_sim_card_number_required_form_error:
           'SIM card number is required',
         devices_name_type_form_error:
           'Device name should contain only capital alphabets and numbers.',
         devices_name_min_length_form_error:
           'Device name length should be at least 5 characters long.',
         devices_name_max_length_form_error:
           'Device name length should be at most 6 characters long.',
         devices_serial_number_type_form_error:
           'Serial Number Mercurius should contain only alphabets and numbers.',
         devices_serial_number_min_length_form_error:
           'Serial Number Mercurius should be exactly 24 characters long.',
         devices_serial_number_max_length_form_error:
           'Serial Number Mercurius should be exactly 24 characters long.',
         devices_article_number_min_length_form_error:
           'Article Number should be between 10 and 13 characters.',
         devices_article_number_max_length_form_error:
           'Article Number should be between 10 and 13 characters.',
         device_single_device_error_reporting_tab: 'Alarm Reporting',
         error_reporting_alarm_type_field: 'Alarm Type',
         error_reporting_description_field: 'Description',
         error_reporting_resolution_field: 'Resolution',
         error_reporting_error_start_date_field: 'Start Date',
         error_reporting_error_end_date_field: 'End Date',
         error_reporting_error_counters_title: 'Historic Alarm Counters',
         error_reporting_error_counters_error: 'No data found',
         error_reporting_error_counters_no_graph_data_error:
           'The piechart is unavailable',
         error_reporting_error_counters_loading_data: 'Loading ...',
         errorReporting_TR04_255_errorName: 'No alarm',
         errorReporting_TR04_255_errorDescription: 'No alarm',
         errorReporting_TR04_255_errorResolution: 'None',

         errorReporting_TR04_0_errorName: 'E2PROM_READ_ERROR',
         errorReporting_TR04_0_errorDescription: 'Internal software error',
         errorReporting_TR04_0_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_8_errorName: 'RAM_ERROR',
         errorReporting_TR04_8_errorDescription: 'Internal software error',
         errorReporting_TR04_8_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_10_errorName: 'E2PROM_ERROR',
         errorReporting_TR04_10_errorDescription:
           'Wrong safety parameters in E2prom',
         errorReporting_TR04_10_errorResolution: 'Replace controller',

         errorReporting_TR04_11_errorName: 'STATE_ERROR',
         errorReporting_TR04_11_errorDescription: 'Internal software error',
         errorReporting_TR04_11_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_12_errorName: 'ROM_ERROR',
         errorReporting_TR04_12_errorDescription: 'Internal software error',
         errorReporting_TR04_12_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_15_errorName: 'MAX_TEMP_ERROR',
         eerrorReporting_TR04_15_errorDescription:
           'The external overheat protection is enabled or the Secondary CH Supply sensor (TT-4) measures a temp higher than Maximum heating temp',
         errorReporting_TR04_15_errorResolution:
           'Resolve error and press reset button',

         errorReporting_TR04_17_errorName: 'STACK_ERROR',
         errorReporting_TR04_17_errorDescription: 'Internal software error',
         errorReporting_TR04_17_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_18_errorName: 'INSTRUCTION_ERROR',
         errorReporting_TR04_18_errorDescription: 'Internal software error',
         errorReporting_TR04_18_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_23_errorName: 'CORRUPTED_ERROR_NR',
         errorReporting_TR04_23_errorDescription:
           'Error code RAM byte was corrupted to an unknown error code',
         errorReporting_TR04_23_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_29_errorName: 'PSM_ERROR',
         errorReporting_TR04_29_errorDescription: 'Internal software error',
         errorReporting_TR04_29_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_30_errorName: 'REGISTER_ERROR',
         errorReporting_TR04_30_errorDescription: 'Internal software error',
         errorReporting_TR04_30_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_37_errorName: 'ADC_ERROR',
         errorReporting_TR04_37_errorDescription: 'Internal hardware error',
         errorReporting_TR04_37_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_39_errorName: 'E2PROM_VERSION_CHECK_ERROR',
         errorReporting_TR04_39_errorDescription: 'Internal software error',
         errorReporting_TR04_39_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_106_errorName: 'REFHI_TOO_HIGH',
         errorReporting_TR04_106_errorDescription: 'Internal hardware error',
         errorReporting_TR04_106_errorResolution: 'Replace controller',

         errorReporting_TR04_107_errorName: 'REFHI_TOO_LOW',
         errorReporting_TR04_107_errorDescription: 'Internal hardware error',
         errorReporting_TR04_107_errorResolution: 'Replace controller',

         errorReporting_TR04_108_errorName: 'REFLO_TOO_HIGH',
         errorReporting_TR04_108_errorDescription: 'Internal hardware error',
         errorReporting_TR04_108_errorResolution: 'Replace controller',

         errorReporting_TR04_109_errorName: 'REFLO_TOO_LOW',
         errorReporting_TR04_109_errorDescription: 'Internal hardware error',
         errorReporting_TR04_109_errorResolution: 'Replace controller',

         errorReporting_TR04_114_errorName: 'E2PROM_VERSION_ERROR',
         errorReporting_TR04_114_errorDescription: 'Internal software error',
         errorReporting_TR04_114_errorResolution: 'Replace controller',

         errorReporting_TR04_116_errorName: 'LOW_WATER_PRESSURE_SENSOR',
         errorReporting_TR04_116_errorDescription: 'Low water pressure',
         errorReporting_TR04_116_errorResolution:
           'Top up secondary water circuit to desired value',

         errorReporting_TR04_119_errorName: 'T_PRIMARY_CH_RETURN_OPEN',
         errorReporting_TR04_119_errorDescription:
           'Primary CH Return sensor open',
         errorReporting_TR04_119_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR04_120_errorName: 'T_PRIMARY_SUPPLY_OPEN',
         errorReporting_TR04_120_errorDescription: 'Primary Supply sensor open',
         errorReporting_TR04_120_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR04_122_errorName: 'T_DHW_OUT_OPEN',
         errorReporting_TR04_122_errorDescription: 'DHW Output sensor open',
         errorReporting_TR04_122_errorResolution:
           'Check a/o replace DHW sensor a/o cable',

         errorReporting_TR04_126_errorName: 'T_PRIMARY_CH_RETURN_SHORTED',
         errorReporting_TR04_126_errorDescription:
           'Primary CH Return sensor shorted',
         errorReporting_TR04_126_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR04_127_errorName: 'T_PRIMARY_SUPPLY_SHORTED',
         errorReporting_TR04_127_errorDescription:
           'Primary Supply sensor shorted',
         errorReporting_TR04_127_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR04_129_errorName: 'T_DHW_OUT_SHORTED',
         errorReporting_TR04_129_errorDescription: 'DHW Output sensor shorted',
         errorReporting_TR04_129_errorResolution:
           'Check a/o replace DHW sensor a/o cable',

         errorReporting_TR04_134_errorName: 'RESET_BUTTON_ERROR',
         errorReporting_TR04_134_errorDescription:
           'Too many resets in a short time period',
         errorReporting_TR04_134_errorResolution:
           'Interrupt power supply HIU for approx.. 10 seconds',

         errorReporting_TR04_158_errorName: 'T_SECONDARY_CH_SUPPLY_OPEN',
         errorReporting_TR04_158_errorDescription:
           'Secondary CH Supply sensor open',
         errorReporting_TR04_158_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR04_159_errorName: 'T_SECONDARY_CH_RETURN_OPEN',
         errorReporting_TR04_159_errorDescription:
           'Secondary CH Return sensor open',
         errorReporting_TR04_159_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR04_160_errorName: 'T_SECONDARY_CH_SUPPLY_SHORTED',
         errorReporting_TR04_160_errorDescription:
           'Secondary CH Supply sensor shorted',
         errorReporting_TR04_160_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR04_161_errorName: 'T_SECONDARY_CH_RETURN_SHORTED',
         errorReporting_TR04_161_errorDescription:
           'Secondary CH Return sensor shorted',
         errorReporting_TR04_161_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR04_171_errorName: 'ADC_UNSTABLE',
         errorReporting_TR04_171_errorDescription:
           'ADC measurement detected too many unstable measurements',
         errorReporting_TR04_171_errorResolution: 'Replace controller',

         errorReporting_TR04_174_errorName: 'T_PRIMARY_DHW_RETURN_OPEN',
         errorReporting_TR04_174_errorDescription:
           'Primary DHW Return sensor open',
         errorReporting_TR04_174_errorResolution:
           'Check a/o replace DHW sensor a/o cable',

         errorReporting_TR04_175_errorName: 'T_PRIMARY_DHW_RETURN_SHORTED',
         errorReporting_TR04_175_errorDescription:
           'Primary DHW Return sensor shorted',
         errorReporting_TR04_175_errorResolution:
           'Check a/o replace DHW sensor a/o cable',

         errorReporting_TR04_203_errorName: 'HIGH_WATER_PRESSURE_SENSOR',
         errorReporting_TR04_203_errorDescription:
           'High (CH) water pressure detected',
         errorReporting_TR04_203_errorResolution: '-',

         errorReporting_TR04_206_errorName: 'TE_BOOSTER_WARNING',
         errorReporting_TR04_206_errorDescription:
           'TE-Booster is in state SafetyLock',
         errorReporting_TR04_206_errorResolution: '-',

         errorReporting_TR04_207_errorName: 'POWERPACK_DEFECT_WARNING',
         errorReporting_TR04_207_errorDescription: 'PowerPack is defective',
         errorReporting_TR04_207_errorResolution: '-',

         errorReporting_TR04_208_errorName: 'ERRORLOG_STORAGE_FAULT',
         errorReporting_TR04_208_errorDescription: 'Internal software warning',
         errorReporting_TR04_208_errorResolution: '-',

         errorReporting_TR04_209_errorName: 'DATALOG_STORAGE_FAULT',
         errorReporting_TR04_209_errorDescription: 'Internal software warning',
         errorReporting_TR04_209_errorResolution: '-',

         errorReporting_TR04_210_errorName: 'FIRMWARE_STORAGE_FAULT',
         errorReporting_TR04_210_errorDescription: 'Internal software warning',
         errorReporting_TR04_210_errorResolution: '-',

         errorReporting_TR04_211_errorName: 'DEFAULTS_STORAGE_FAULT',
         errorReporting_TR04_211_errorDescription: 'Internal software warning',
         errorReporting_TR04_211_errorResolution: '-',

         errorReporting_TR04_212_errorName: 'NO_PRIMARY_FLOW',
         errorReporting_TR04_212_errorDescription: 'No primary flow',
         errorReporting_TR04_212_errorResolution: '-',

         errorReporting_TR04_213_errorName: 'LOW_PRIMARY_FLOW',
         errorReporting_TR04_213_errorDescription: 'Primary flow too low',
         errorReporting_TR04_213_errorResolution: '-',

         errorReporting_TR04_214_errorName: 'UNDESIRED_PRIMARY_FLOW_MCV1',
         errorReporting_TR04_214_errorDescription:
           'Undesired primary flow warning for MCV1',
         errorReporting_TR04_214_errorResolution: '-',

         errorReporting_TR04_215_errorName: 'UNDESIRED_PRIMARY_FLOW_MCV1_2',
         errorReporting_TR04_215_errorDescription:
           'Undesired primary flow warning for MCV1 and MCV2',
         errorReporting_TR04_215_errorResolution: '-',

         errorReporting_TR04_216_errorName: 'T_ALEG_TOO_LOW',
         errorReporting_TR04_216_errorDescription:
           'Return temp too low during Anti-Legionella demand',
         errorReporting_TR04_216_errorResolution: '-',

         errorReporting_TR04_217_errorName: 'T_DHW_TOO_HIGH',
         errorReporting_TR04_217_errorDescription:
           'DHW temp is too high ( > 70ºC for > 5 s.)',
         errorReporting_TR04_217_errorResolution: '-',

         errorReporting_TR04_218_errorName: 'EVALUATION_TIMER_EXPIRED',
         errorReporting_TR04_218_errorDescription:
           'Evaluation Timer has expired',
         errorReporting_TR04_218_errorResolution: '-',

         errorReporting_TR04_219_errorName: 'WATER_LEAK',
         errorReporting_TR04_219_errorDescription: 'Water leak detected',
         errorReporting_TR04_219_errorResolution: '-',

         errorReporting_TR03_255_errorName: 'No alarm',
         errorReporting_TR03_255_errorDescription: 'No alarm',
         errorReporting_TR03_255_errorResolution: 'None',

         errorReporting_TR03_0_errorName: 'E2PROM_READ_ERROR',
         errorReporting_TR03_0_errorDescription: 'Internal software error',
         errorReporting_TR03_0_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_4_errorName: 'BLOCKING_TOO_LONG',
         errorReporting_TR03_4_errorDescription:
           'Control had a blocking error for more than 20 hours',
         errorReporting_TR03_4_errorResolution:
           'Press reset button and resolve underlying blocking error',

         errorReporting_TR03_8_errorName: 'RAM_ERROR',
         errorReporting_TR03_8_errorDescription: 'Internal software error',
         errorReporting_TR03_8_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_9_errorName: 'WRONG_EEPROM_SIGNATURE',
         errorReporting_TR03_9_errorDescription:
           'Contents of E2prom is not up to date',
         errorReporting_TR03_9_errorResolution: 'Replace controller',

         errorReporting_TR03_10_errorName: 'E2PROM_ERROR',
         errorReporting_TR03_10_errorDescription:
           'Wrong safety parameters in E2prom',
         errorReporting_TR03_10_errorResolution: 'Replace controller',

         errorReporting_TR03_11_errorName: 'STATE_ERROR',
         errorReporting_TR03_11_errorDescription: 'Internal software error',
         errorReporting_TR03_11_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_12_errorName: 'ROM_ERROR',
         errorReporting_TR03_12_errorDescription: 'Internal software error',
         errorReporting_TR03_12_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_15_errorName: 'MAX_TEMP_ERROR',
         errorReporting_TR03_15_errorDescription:
           'The external overheat protection is enabled or the Secondary Supply sensor (TT-1) measures a temp higher than Maximum heating temp',
         errorReporting_TR03_15_errorResolution:
           'Resolve error and press reset button',

         errorReporting_TR03_17_errorName: 'STACK_ERROR',
         errorReporting_TR03_17_errorDescription: 'Internal software error',
         errorReporting_TR03_17_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_18_errorName: 'INSTRUCTION_ERROR',
         errorReporting_TR03_18_errorDescription: 'Internal software error',
         errorReporting_TR03_18_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_23_errorName: 'CORRUPTED_ERROR_NR',
         errorReporting_TR03_23_errorDescription:
           'Error code RAM byte was corrupted to an unknown error code',
         errorReporting_TR03_23_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_29_errorName: 'PSM_ERROR',
         errorReporting_TR03_29_errorDescription: 'Internal software error',
         errorReporting_TR03_29_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_30_errorName: 'REGISTER_ERROR',
         errorReporting_TR03_30_errorDescription: 'Internal software error',
         errorReporting_TR03_30_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_36_errorName: 'COOLING_TO_HIGH',
         errorReporting_TR03_36_errorDescription:
           'Cooling temp on secondary supply too high. Cooling temp above Max cooling temp for >3 minutes.',
         errorReporting_TR03_36_errorResolution:
           'Reduce cooling temp. Press reset button. If alarm remains or returns, increase Max cooling temp to 55C. If alarm remains, replace controller.',

         errorReporting_TR03_106_errorName: 'REFHI_TOO_HIGH',
         errorReporting_TR03_106_errorDescription: 'Internal hardware error',
         errorReporting_TR03_106_errorResolution: 'Replace controller',

         errorReporting_TR03_107_errorName: 'REFHI_TOO_LOW',
         errorReporting_TR03_107_errorDescription: 'Internal hardware error',
         errorReporting_TR03_107_errorResolution: 'Replace controller',

         errorReporting_TR03_108_errorName: 'REFLO_TOO_HIGH',
         errorReporting_TR03_108_errorDescription: 'Internal hardware error',
         errorReporting_TR03_108_errorResolution: 'Replace controller',

         errorReporting_TR03_109_errorName: 'REFLO_TOO_LOW',
         errorReporting_TR03_109_errorDescription: 'Internal hardware error',
         errorReporting_TR03_109_errorResolution: 'Replace controller',

         errorReporting_TR03_110_errorName: 'REFHI2_TOO_HIGH',
         errorReporting_TR03_110_errorDescription: 'Internal hardware error',
         errorReporting_TR03_110_errorResolution: 'Replace controller',

         errorReporting_TR03_111_errorName: 'REFHI2_TOO_LOW',
         errorReporting_TR03_111_errorDescription: 'Internal hardware error',
         errorReporting_TR03_111_errorResolution: 'Replace controller',

         errorReporting_TR03_112_errorName: 'REFLO2_TOO_HIGH',
         errorReporting_TR03_112_errorDescription: 'Internal hardware error',
         errorReporting_TR03_112_errorResolution: 'Replace controller',

         errorReporting_TR03_113_errorName: 'REFLO2_TOO_LOW',
         errorReporting_TR03_113_errorDescription: 'Internal hardware error',
         errorReporting_TR03_113_errorResolution: 'Replace controller',

         errorReporting_TR03_115_errorName: 'LOW_WATER_PRESSURE_ERROR',
         errorReporting_TR03_115_errorDescription: 'Low water pressure error',
         errorReporting_TR03_115_errorResolution:
           'Top up secondary water circuit to desired value',

         errorReporting_TR03_116_errorName: 'LOW_WATER_PRESSURE_SENSOR',
         errorReporting_TR03_116_errorDescription: 'Low water pressure',
         errorReporting_TR03_116_errorResolution:
           'Top up secondary water circuit to desired value',

         errorReporting_TR03_119_errorName: 'RETURN_OPEN',
         errorReporting_TR03_119_errorDescription: 'Return sensor open',
         errorReporting_TR03_119_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR03_120_errorName: 'SUPPLY_OPEN',
         errorReporting_TR03_120_errorDescription: 'Supply sensor open',
         errorReporting_TR03_120_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR03_121_errorName: 'SUPPLY2_OPEN',
         errorReporting_TR03_121_errorDescription: 'Supply 2 sensor open',
         errorReporting_TR03_121_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR03_122_errorName: 'DHW_OPEN',
         errorReporting_TR03_122_errorDescription: 'DHW sensor open',
         errorReporting_TR03_122_errorResolution:
           'Check a/o replace DHW sensor a/o cable',

         errorReporting_TR03_126_errorName: 'RETURN_SHORTED',
         errorReporting_TR03_126_errorDescription: 'Return sensor shorted',
         errorReporting_TR03_126_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR03_127_errorName: 'SUPPLY_SHORTED',
         errorReporting_TR03_127_errorDescription: 'Supply sensor shorted',
         errorReporting_TR03_127_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR03_128_errorName: 'SUPPLY2_SHORTED',
         errorReporting_TR03_128_errorDescription: 'Supply 2 sensor shorted',
         errorReporting_TR03_128_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR03_129_errorName: 'DHW_SHORTED',
         errorReporting_TR03_129_errorDescription: 'DHW sensor shorted',
         errorReporting_TR03_129_errorResolution:
           'Check a/o replace DHW sensor a/o cable',

         errorReporting_TR03_134_errorName: 'RESET_BUTTON_ERROR',
         errorReporting_TR03_134_errorDescription:
           'Too many resets in a short time period',
         errorReporting_TR03_134_errorResolution:
           'Interrupt power supply HIU for approx. 10 seconds',

         errorReporting_TR03_167_errorName: 'RETURN2_SHORTED',
         errorReporting_TR03_167_errorDescription:
           'Secondary circuit supply sensor shorted',
         errorReporting_TR03_167_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR03_168_errorName: 'RETURN2_OPEN',
         errorReporting_TR03_168_errorDescription:
           'Secondary circuit return sensor shorted',
         errorReporting_TR03_168_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR03_169_errorName: 'HEAT_COOL_ACTIVE',
         errorReporting_TR03_169_errorDescription:
           'Cooling demand and Heating demand',
         errorReporting_TR03_169_errorResolution:
           'Check thermostat/controller a/o cables to avoid simultaneous cooling and heating demand',

         errorReporting_TR03_170_errorName: 'HW_IDENTIFIER_ERROR',
         errorReporting_TR03_170_errorDescription:
           'Hardware ID detection mismatch',
         errorReporting_TR03_170_errorResolution: 'Replace controller',

         errorReporting_TR03_203_errorName: 'HIGH_PRESSURE',
         errorReporting_TR03_203_errorDescription:
           'High (CH) water pressure detected',
         errorReporting_TR03_203_errorResolution: 'N/A',

         errorReporting_TR03_204_errorName: 'OUTDOOR_WRONG',
         errorReporting_TR03_204_errorDescription:
           'Outdoor sensor measures open/shorted',
         errorReporting_TR03_204_errorResolution: 'N/A',

         errorReporting_TR03_206_errorName: 'TE_BOOSTER_WARNING',
         errorReporting_TR03_206_errorDescription: 'DHW Storage locked DHW',
         errorReporting_TR03_206_errorResolution: 'N/A',
         errorReporting_errorType_lockout: 'Lockout',
         errorReporting_errorType_blocking: 'Blocking',
         errorReporting_errorType_warning: 'Warning',
         device_single_dashboard_active_error_title: 'Active Alarm',
         devices_box_serial_number_start_with_F_error:
           'Serial Number Heat Interface Unit must start with F',
         devices_form_default_controller_type_field: 'Default Controller Type',
         devices_form_default_soft_version_field: 'Default Software Version',
         devices_form_default_appliance_type_field: 'Default Appliance Type',
         devices_form_default_client_name_field: 'Default Client Name',
         projects_form_total_amount_order_field: 'Amount on Production Order',
         error_check_details_table_device_status_field: 'Device Status',
         error_check_details_table_export_generated_at_field: 'Generated At',
         error_check_details_table_export_generated_for_field: 'Generated for',
         error_check_details_table_export_generated_by_user_field:
           'Generated By',
         error_check_details_table_export_report_name_field: 'Name',
         error_check_details_table_export_active_alarms_report_field:
           'Active Alarms',
         error_check_details_table_export_active_new_alarms_report_field:
           'New Active Alarms',
         error_check_details_table_export_resolved_alarms_report_field:
           'Resolved Alarms',
         error_check_details_table_export_active_alarms_sheet_report_field:
           'Active Alarms',
         error_check_details_table_export_active_new_alarms_sheet_report_field:
           'New Active Alarms',
         error_check_details_table_export_resolved_alarms_sheet_report_field:
           'Resolved Alarms',
         projects_form_main_client_contact_field: 'Main Client Contact',
         projects_form_main_service_client_contact_field:
           'Main Service Client Contact',
         errorReporting_TR03_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorName:
           'Alarm',
         errorReporting_TR03_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorDescription:
           'Device is in Alarm Mode',
         errorReporting_TR03_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorResolution:
           'Contact Support Department',
         errorReporting_TR04_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorName:
           'Alarm',
         errorReporting_TR04_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorDescription:
           'Device is in Alarm Mode',
         errorReporting_TR04_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorResolution:
           'Contact Support Department',
         error_check_details_table_error_name: 'Alarm Name',
         devices_sim_card_number_form_unique_error:
           'Sim card number must be unique',
         devices_list_diagnostics_condition_modal_filter_button: 'Filter',
         devices_list_diagnostics_condition_modal_close_button: 'Close',
         roles_overview_bread_crumb_first_link:
           'Role Permissions Overview (Active Roles)',
         roles_overview_form_header: 'Role Permissions Overview (Active Roles)',
         roles_overview_fortes_roles_tab: 'Fortes Roles',
         roles_overview_client_roles_tab: 'Client roles',
         roles_overview_service_client_roles_tab: 'Service client roles',
         roles_overview_filter_roles_button: 'Filter Roles',
         roles_form_permissions_loading:
           'Loading data... This may take between 10 to 20 seconds. Thank you for your patience.',
         roles_overview_success_message:
           'Role permissions for active roles have been successfully updated.',
         roles_overview_error_message:
           'Failed to update role permissions for active roles. Please contact the administrator.',
         roles_overview_success_no_permission_change_message:
           'No permission changes detected. Navigating back to the roles overview page.',
         roles_overview_export_button: 'Export',
         roles_overview_export_file_name: 'Roles Overview',
         roles_list_table_roles_overview_button: 'Roles Overview',
         roles_overview_update_button: 'Update Roles',
         devices_form_first_event_timestamp_field: 'First event date',
         devices_list_diagnostics_condition_modal_sensor_type_field_label:
           'Sensor Type',
         devices_list_diagnostics_condition_modal_controller_type_field_label:
           'Controller Type',
         subscription_form_unique_error_message:
           'Subscription Order Number already exist',
         email_common_questions: `Questions? Please contact <a style="color: ${primaryColor};" href="mailto:${process.env.REACT_APP_SUPPORT_EMAIL}"><span>${process.env.REACT_APP_SUPPORT_EMAIL}</span></a> for further support.`,
         email_common_footer_receiving:
           'You are receiving this email because you have an active account on the ##distributorName## portal and have chosen to receive notifications via email.',
         email_common_footer_unsubscribe: `Do not wish to receive these emails? Turn off email notifications <a style="color: ${primaryColor};" href="${process.env.REACT_APP_BASE_URL}/admin/setting">here</a>.`,

         email_template_new_account_created_title: 'New Account Created',
         email_template_new_account_created_main_content:
           'Thank you for registering with ##distributorName##, the platform to remotely monitor and manage your Fortes Heating Interface Units and linked energy meters.',
         email_template_new_account_created_password_intro:
           'To get you started, we have created an account for you on the ##distributorName## portal. Please find your temporary password below.',
         email_template_new_account_created_temp_password:
           'Temporary Password:',
         email_template_new_account_created_login_instruction: `Please follow this <a style="font-weight: 600;color: ${primaryColor};" href="${process.env.REACT_APP_BASE_URL}"> link</a>, to <a style="font-weight: 600;color: ${primaryColor};" href="${process.env.REACT_APP_BASE_URL}"> login</a> and change your password.`,
         email_template_new_account_created_button: 'LOGIN',
         email_template_modbus_data_title: 'Modbus Data',
         email_template_modbus_data_content:
           'You have requested an export for the available (Modbus) data of the Heating Interface Unit(s). The export file is password protected to safeguard your data.<br />Please click on this link to download the zip file. Enter the password when opening the zip file.',
         email_template_modbus_data_password: 'Password:',
         email_template_modbus_data_expiry_note:
           'Note: The above link will expire after 12 hours.',
         email_template_modbus_data_button: 'DOWNLOAD ZIP FILE',
         email_template_mbus_data_title: 'Mbus Data',
         email_template_mbus_data_content:
           'You have requested an export for the available (Mbus) data of the energy meter(s).',
         email_template_mbus_data_content_1:
           'The export file is password protected to safeguard your data.',
         email_template_mbus_data_content_2:
           'Please click on this link to download the zip file. Enter the password when opening the zip file.',
         email_template_mbus_data_password: 'Password:',
         email_template_mbus_data_expiry:
           'Note: The above link will expire after 12 hours.',
         email_template_mbus_data_button: 'DOWNLOAD ZIP FILE',

         email_template_device_swapping_title: 'Device Swapping',
         email_template_device_swapping_content:
           'You have recently swapped a Mercurius Communication Module for a new unit.',
         email_template_device_swapping_content_1:
           'Please find below a summary of the swap in your project.',
         email_template_device_swapping_old_device_section: 'Old Device',
         email_template_device_swapping_old_project: 'Project',
         email_template_device_swapping_old_client: 'Client',
         email_template_device_swapping_old_device_name: 'Device name',
         email_template_device_swapping_old_swapped_at: 'Swapped at',
         email_template_device_swapping_old_swapped_by: 'Swapped by',
         email_template_device_swapping_old_serial_number_mercurius:
           'Serial number Mercurius',
         email_template_device_swapping_old_type_heat_interface_unit:
           'Type Heat Interface Unit',
         email_template_device_swapping_old_distributor_serial_number:
           'Distributor Serial # heat interface unit',
         email_template_device_swapping_old_distributor_article_number:
           'Distributor Article # heat interface unit',
         email_template_device_swapping_old_serial_number:
           'Serial number Heat Interface Unit',
         email_template_device_swapping_old_production_date: 'Production date',
         email_template_device_swapping_old_customer_reference:
           'Customer reference',
         email_template_device_swapping_old_article_number_heat_interface_unit:
           'Article number heat interface unit',
         email_template_device_swapping_old_production_order_number:
           'Production order number',
         email_template_device_swapping_old_order_number: 'Order number',
         email_template_device_swapping_new_device_section: 'New Device',

         email_template_device_swapping_new_device_name: 'Name',
         email_template_device_swapping_new_serial_number:
           'Serial number Mercurius',
         email_template_device_swapping_new_sim_card: 'Sim card number',
         email_template_device_swapping_new_firmware: 'Firmware version',
         email_template_device_swapping_new_device_type: 'Device type',

         email_template_device_swapping_completion:
           'has proceeded to complete the swapping process.',
         email_template_device_swapping_completion_info:
           '##distributorName## generates this report after completing the device swapping process. This will allow you or your organisation to take timely action to resolve any issues.',

         email_template_active_alarms_title: 'Active Alarms',
         email_template_active_alarms_intro:
           'Please find below a summary of the Active Alarms <sup>2</sup> for the connected Fortes Heating Interface Units in your project(s).',
         email_template_active_alarms_new_active_alarms:
           'New Active Alarms<sup>2</sup>',
         email_template_active_alarms_existing_active_alarms:
           'Existing Active Alarms',
         email_template_active_alarms_resolved_alarms:
           'Resolved Alarms<sup>3</sup>',
         email_template_active_alarms_download_report:
           'To download the full Excel report, please click on this link.',
         email_template_active_alarms_download_report_button:
           'DOWNLOAD FULL EXCEL REPORT',
         email_template_active_alarms_report_info:
           '##distributorName## generates this report every 6 hours. This will allow you or your organisation to take timely action to resolve the alarms in the heating interface units and ensure correct operation.',
         email_template_active_alarms_report_info_1:
           '1. An Active Alarm is an alarm that has occurred and is not resolved yet.',
         email_template_active_alarms_report_info_2:
           '2. A New Active Alarm is an alarm that has occurred since the last report.',
         email_template_active_alarms_report_info_3:
           '3. A Resolved Alarm is an alarm that has been resolved since the last report.',

         email_template_api_gateway_title: 'New API Gateway Account Created',
         email_template_api_gateway_main_content:
           'Thank you for registering with ##distributorName##, the platform to remotely monitor and manage your Fortes Heating Interface Units and linked energy meters.',
         email_template_api_gateway_info:
           'To get you started, we have created an account for you on the ##distributorName## Platform. Please find your API Key below.',
         email_template_api_gateway_api_key: 'API Key:',
         email_template_api_gateway_spec_link: `Please click on this <a href="#" style="font-weight: 600; color: ${primaryColor};">link</a>, to review OpenAPI Specification.`,
         email_template_api_gateway_button: 'OpenAPI Specification',

         email_template_forgot_password_title: 'Forgot Password',
         email_template_forgot_password_content:
           'We received a request to reset the password for your account.',
         email_template_forgot_password_content_1: `Please click on this <a href="#" style="font-weight: 600; color: ${primaryColor};">link</a>, to reset your password.`,
         email_template_forgot_password_reset_password_button: 'RESET PASSWORD',

         email_template_mbus_hourly_logs_missing_title:
           'Mbus hourly logs Missing report',
         email_template_mbus_hourly_logs_missing_content:
           'We have identified that certain devices have not sent mbus hourly data.',
         email_template_mbus_hourly_logs_view_report_button: 'VIEW REPORT',

         email_template_anomaly_digest_title: 'Anomaly Digest',
         email_template_anomaly_digest_content:
           'Here are the details of Anomaly Digest',
         email_template_anomaly_digest_duration:
           'Duration: <b>{{ anomalyDuration }}</b>',
         email_template_anomaly_digest_project_name:
           'Project name: {{projectName}}',
         email_template_anomaly_digest_device_serial: 'Device serial',
         email_template_anomaly_digest_anomaly_count: 'Anomaly count',
         email_template_anomaly_digest_button: 'VIEW ANOMALY REPORT',

         email_template_maxitel_m2m_blend_and_api_status_title:
           'Maxitel M2M Blend And API Status',
         email_template_maxitel_m2m_blend_and_api_status_intro:
           'Here are the details of Maxitel M2M Blend And API Status.',
         email_template_maxitel_m2m_blend_and_api_status_service_header:
           'Maxitel Service',
         email_template_maxitel_m2m_blend_and_api_status_status_header:
           'Status',
         email_template_maxitel_m2m_blend_and_api_status_api_status:
           'Non-operational',
         email_template_maxitel_m2m_blend_and_api_status_operational:
           'Operational',

         email_template_device_commissioning_report_title:
           'Mercurius Commissioning Report',
         email_template_device_commissioning_report_intro:
           'Please find below the commissioning report of the recently commissioned Mercurius in your project.',
         email_template_device_commissioning_report_project: 'Project',
         email_template_device_commissioning_report_client: 'Client',
         email_template_device_commissioning_report_device_name: 'Device name',
         email_template_device_commissioning_report_commissioned_at:
           'Commissioned at',
         email_template_device_commissioning_report_commissioned_by:
           'Commissioned by',
         email_template_device_commissioning_report_commissioning_status:
           'Commissioning status',
         email_template_device_commissioning_report_completed_hiu_details:
           '-Completed HIU details',
         email_template_device_commissioning_report_mobile_connectivity_validation:
           '-Mobile connectivity validation',
         email_template_device_commissioning_report_modbus_connectivity_validation:
           '-Modbus connectivity validation',
         email_template_device_commissioning_report_mbus_connectivity_validation:
           '-MBus connectivity validation',
         email_template_device_commissioning_report_updated_address_details:
           '-Updated address details',
         email_template_device_commissioning_report_completion:
           'User has proceeded to complete the commissioning process.',
         email_template_device_commissioning_report_footer:
           'generates this report after completing the Mercurius commissioning process. This will allow you or your organisation to take timely action to resolve any issues with connecting the heating interface units and ensure correct commissioning.',

         email_template_subscriptions_expiring_title:
           'Project Subscriptions Expiring Soon Notification',
         email_template_subscriptions_expiring_content:
           'This is to inform you that {{ numberOfProjects }} projects are expiring soon.',
         email_template_subscriptions_expiring_content_1: `Please click on the <a style="font-weight: 600; color: ${primaryColor};" href={{ subscriptionsExpiringUrl }}>link</a> to view the details.`,
         email_template_subscriptions_expiring_soon_notification:
           'Expiring soon notification',
         email_template_subscriptions_expiring_months: 'months',
         email_template_subscriptions_expiring_button:
           'VIEW EXPIRING SOON SUBSCRIPTIONS',

         email_template_delete_device_sim_subscription_title:
           'Delete device sim subscription',
         email_template_delete_device_sim_subscription_content:
           'Please find below the device information required to manually delete the SIM subscription, as the Maxitel Delete Subscription API is currently not functioning.',

         email_template_delete_device_sim_subscription_project: 'Project',
         email_template_delete_device_sim_subscription_client: 'Client',
         email_template_delete_device_sim_subscription_device_name:
           'Device name',
         email_template_delete_device_sim_subscription_device_edited_by:
           'Device edited by',
         email_template_delete_device_sim_subscription_device_edited_at:
           'Device edited at',
         email_template_delete_device_sim_subscription_old_sim_number:
           'Old SIM number',
         email_template_greeting: 'Hi',
         swapping_email_swapped_at_field: 'Swapped At',
         swapping_email_swapped_by_field: 'Swapped By',
         projects_form_created_at_field: 'Creation Date',
         add_subscription_order_number_duplicate_error:
           'Subscription order number must be unique.',
         add_subscription_project_not_found_error:
           'The specified project does not exist.',
         add_subscription_subscription_project_credits_missing_error:
           'No devices found for the selected project.',
         add_subscription_subscription_creation_failed_error:
           'Failed to create the subscription due to an internal server error.',
         add_subscription_invalid_or_null_payload_error:
           'The provided payload is either null or invalid.',
         devices_bulk_delete_button: 'Delete Devices',
         devices_bulk_delete_modal_title: 'Are you sure?',
         devices_bulk_delete_modal_subtitle: `<strong>The following data will be deleted:</strong>
          <ul>
            <li><i>Device information</i></li>
            <li><i>Events</i></li>
            <li><i>Modbus Data</i></li>
            <li><i>Mbus Data</i></li>
            <li><i>Graph Data</i></li>
            <li><i>Device Register</i></li>
            <li><i>Error Data</i></li>
            <li><i>Other related tables</i></li>
          </ul>`,
         devices_bulk_delete_modal_note:
           '<strong>Note:</strong> <br/> Once you proceed with the deletion, it cannot be undone unless the IT team manually restores the data from old backups. Recovering events and other related information will be highly time-consuming. Device deletion takes some time due to the data mentioned above. Please be patient and do not cancel or refresh the page.',
         devices_bulk_delete_modal_cancel_button: 'Cancel',
         devices_bulk_delete_modal_delete_button: 'Delete',
         devices_bulk_deleted_message:
           '{{ DEVICES_COUNT }} Devices are deleted successfully',
         email_template_device_deletion_title: 'Deleted Devices Report',
         email_template_device_deletion_content:
           'Please find the summary of the devices deleted from the ##distributorName## platform:',
         email_template_device_deletion_content_1: `To download the full Excel report, please click on this <a href="#" style="font-weight: 600; color: ${primaryColor};">link</a>.`,
         email_template_device_deletion_download_button:
           'Download Full Excel Report',
         email_template_device_deletion_note:
           '##distributorName## generates this report to track device deletions for auditing purposes and to retain data in case of accidental deletions.',
         email_template_device_deletion_deleted_devices_count_field:
           'Deleted Devices count ',
         email_template_device_deletion_deleted_at_field: 'Deleted at',
         email_template_device_deletion_deleted_at_by: 'Deleted By',
         inconsistent_mbus_devices_reporting_details_table_header:
           'Inconsistent Mbus Devices',
         inconsistent_mbus_devices_reporting_details_bulk_export_button:
           'Export',
         inconsistent_mbus_devices_reporting_details_filter_reset_button:
           'Reset',
         inconsistent_mbus_devices_reporting_details_table_filter_search:
           'Search',
         inconsistent_mbus_devices_reporting_details_table_created_at:
           'Created At',
         inconsistent_mbus_devices_reporting_details_table_device: 'Device',
         inconsistent_mbus_devices_reporting_details_table_project: 'Project',
         inconsistent_mbus_devices_reporting_details_table_client: 'Client',
         inconsistent_mbus_devices_reporting_details_table_firmware: 'Firmware',
         inconsistent_mbus_devices_reporting_details_table_actual_rmeters_count:
           'Actual Meters Count',
         inconsistent_mbus_devices_reporting_details_table_shown_meters_count:
           'Shown Meters Count',
         inconsistent_mbus_devices_reporting_details_table_no_record_found:
           'No Record Found',
         inconsistent_mbus_devices_reporting_details_table_row_per_page:
           'Rows per page',
         error_check_details_table_export_success_message:
           'An alarm email has been sent to your inbox.',
         error_check_details_table_export_error_message:
           'Alarm email forwarding failed. Please contact support for assistance.',
         errorReporting_TR03_256_errorName: 'MODBUS_WARNING_MESSAGE',
         errorReporting_TR03_256_errorDescription:
           'No Modbus communication with HIU controller',
         errorReporting_TR03_256_errorResolution:
           'Check a/o replace Modbus cable a/o connectors. If problem persists, replace controller',
         errorReporting_TR04_256_errorName: 'MODBUS_WARNING_MESSAGE',
         errorReporting_TR04_256_errorDescription:
           'No Modbus communication with HIU controller',
         errorReporting_TR04_256_errorResolution:
           'Check a/o replace Modbus cable a/o connectors. If problem persists, replace controller',
         error_check_details_table_export_start_time_field: 'Start Time',
         error_check_details_table_export_end_time_field: 'End Time',
         error_check_details_table_export_resolution_field: 'Resolution',
         error_check_details_table_export_alarm_code_field: 'Alarm Code',
         error_check_details_table_export_alarm_name_field: 'Alarm Name',
         error_check_details_table_export_alarm_resolutions_field:
           'Alarm Resolutions',
         error_check_details_table_export_alarm_description_field:
           'Description',
         subscription_form_subscriptionPeriod_years_field:
           'Subscription Period (years)',
         subscription_form_project_devices_missing_error:
           'No devices are currently assigned to the selected project. Please add devices to continue.',
         settings_notification_device_error_toast_message:
           '"Notify when a device is in error mode" is updated successfully.',
         subscription_form_client_email_status_field: 'Client Email Status',
         subscription_form_client_email_success_field:
           'The Client Contact for this client is set on the Edit Client page, and email is successfully forwarded for the subscription extension.',
         subscription_form_client_email_error_field:
           'The Client Contact for this client is not set on the Edit Client page, and email is not forwarded for the subscription extension.',
         subscription_extension_client_email_status: 'Client Email Status',
         subscription_form_keycloak_user_id_mismatch_issue_error:
           'Client email user account has issue. Please contact the administrator',
         devices_partner_order_number_field: 'Distributor Order Number',
         edit_devices_distributor_order_number_error:
           'Distributor Order Number is required',
         legal_documents_checkbox_link_information_form_error:
           '<strong>Note: </strong><i>In the document checkbox label field, use [link] to insert the document URL and it will be automatically replaced with the actual link.</i>',
         devices_form_distinct_mercurius_type_field: 'Distinct Mercurius Type',
         devices_table_row_all_records_label: 'All',
         devices_show_all_devices_modal_title: 'Are you Sure?',
         devices_show_all_devices_modal_subtitle:
           'By selecting "All" from the records dropdown, you are requesting to load all available records i.e. ##TOTAL_DEVICES##.',
         devices_show_all_devices_modal_note:
           '<ul><li>This action may take 30 seconds or more and could slow down the page.</li><li>Loading all records (over 10MB of data) might cause performance issues, including page lag due to the large number of items being rendered.</li><li>If you\'re okay with that, click <strong>"Proceed Anyway"</strong>.</li><li>To cancel and revert to the default 25 records, click <strong>"Cancel"</strong>.</li></ul>',
         devices_show_all_devices_modal_cancel_button: 'Cancel',
         devices_show_all_devices_modal_proceed_anyway_button: 'Proceed Anyway',
         commissioning_form_stepper_validation_appliance_type_check_started_title:
           'Started Appliance Type Check',
         commissioning_form_stepper_validation_appliance_type_check_success_title:
           'Success: The device has provided the appliance type',
         commissioning_form_stepper_validation_appliance_type_check_warning_title:
           'Warning: The device has not provided the appliance type',
       };
